function addClassToBody(e) {
    document.body.classList.add(e);
}
function removeClassFromBody(e) {
    document.body.classList.remove(e);
}
function toggleSlideNavItemClasses(e) {
    var t = e.currentTarget;
    t.querySelector(".slide-nav__link").classList.toggle("is-active"),
        t.querySelector(".slide-nav__dropdown").classList.toggle("is-active");
}
(window.theme = window.theme || {}),
    (window.Shopify = window.Shopify || {}),
    (theme.bp = {}),
    (theme.config = {
        cssLoaded: !1,
        bpSmall: !1,
        hasSessionStorage: !0,
        mediaQuerySmall: "screen and (max-width: 768px)",
        youTubeReady: !1,
        vimeoReady: !1,
        vimeoLoading: !1,
        isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
        isTouch:
            !!("ontouchstart" in window || (window.DocumentTouch && window.document instanceof DocumentTouch)) ||
            !!window.navigator.maxTouchPoints ||
            !!window.navigator.msMaxTouchPoints,
        rtl: "rtl" == document.documentElement.getAttribute("dir"),
    }),
    theme.config.isTouch && (document.documentElement.className += " supports-touch"),
    console &&
        console.log &&
        console.log(
            "Streamline theme (" +
                theme.settings.themeVersion +
                ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
        ),
    (theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches),
    matchMedia(theme.config.mediaQuerySmall).addListener(function (e) {
        e.matches
            ? ((theme.config.bpSmall = !0), document.dispatchEvent(new CustomEvent("matchSmall")))
            : ((theme.config.bpSmall = !1), document.dispatchEvent(new CustomEvent("unmatchSmall")));
    }),
    (function () {
        "use strict";
        var e, t, i, s, n, a, o, r;
        if (
            ((theme.delegate = {
                on: function (e, t, i) {
                    return (
                        this.namespaces || (this.namespaces = {}),
                        (this.namespaces[e] = t),
                        (i = i || !1),
                        this.addEventListener(e.split(".")[0], t, i),
                        this
                    );
                },
                off: function (e) {
                    if (this.namespaces)
                        return (
                            this.removeEventListener(e.split(".")[0], this.namespaces[e]),
                            delete this.namespaces[e],
                            this
                        );
                },
            }),
            (window.on = Element.prototype.on = theme.delegate.on),
            (window.off = Element.prototype.off = theme.delegate.off),
            (theme.utils = {
                defaultTo: function (e, t) {
                    return null == e || e != e ? t : e;
                },
                wrap: function (e, t) {
                    e.parentNode.insertBefore(t, e), t.appendChild(e);
                },
                debounce: function (e, t, i) {
                    var s;
                    return function () {
                        var n = this,
                            a = arguments,
                            o = function () {
                                (s = null), i || t.apply(n, a);
                            },
                            r = i && !s;
                        clearTimeout(s), (s = setTimeout(o, e)), r && t.apply(n, a);
                    };
                },
                throttle: function (e, t) {
                    var i = !1;
                    return function () {
                        i ||
                            (t.apply(this, arguments),
                            (i = !0),
                            setTimeout(function () {
                                i = !1;
                            }, e));
                    };
                },
                prepareTransition: function (e, t) {
                    function i(t) {
                        e.classList.remove("is-transitioning"), e.removeEventListener("transitionend", i);
                    }
                    e.addEventListener("transitionend", i),
                        e.classList.add("is-transitioning"),
                        e.offsetWidth,
                        "function" == typeof t && t();
                },
                compact: function (e) {
                    for (var t = -1, i = null == e ? 0 : e.length, s = 0, n = []; ++t < i; ) {
                        var a = e[t];
                        a && (n[s++] = a);
                    }
                    return n;
                },
                serialize: function (e) {
                    var t = [];
                    return (
                        Array.prototype.slice.call(e.elements).forEach(function (e) {
                            if (
                                !(!e.name || e.disabled || ["file", "reset", "submit", "button"].indexOf(e.type) > -1)
                            ) {
                                if ("select-multiple" === e.type) {
                                    Array.prototype.slice.call(e.options).forEach(function (i) {
                                        i.selected &&
                                            t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(i.value));
                                    });
                                    return;
                                }
                                (!(["checkbox", "radio"].indexOf(e.type) > -1) || e.checked) &&
                                    t.push(encodeURIComponent(e.name) + "=" + encodeURIComponent(e.value));
                            }
                        }),
                        t.join("&")
                    );
                },
            }),
            (theme.a11y = {
                trapFocus: function (e) {
                    var t = {
                            focusin: e.namespace ? "focusin." + e.namespace : "focusin",
                            focusout: e.namespace ? "focusout." + e.namespace : "focusout",
                            keydown: e.namespace ? "keydown." + e.namespace : "keydown.handleFocus",
                        },
                        i = e.container.querySelectorAll(
                            'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
                        ),
                        s = [].slice.call(i).filter((e) => null !== e.offsetParent),
                        n = s[0],
                        a = s[s.length - 1];
                    e.elementToFocus || (e.elementToFocus = e.container),
                        e.container.setAttribute("tabindex", "-1"),
                        e.elementToFocus.focus(),
                        document.documentElement.off("focusin"),
                        document.documentElement.on(t.focusout, function () {
                            document.documentElement.off(t.keydown);
                        }),
                        document.documentElement.on(t.focusin, function (i) {
                            (i.target === e.container || i.target === a || i.target === n) &&
                                document.documentElement.on(t.keydown, function (e) {
                                    var t;
                                    (t = e),
                                        9 !== t.keyCode ||
                                            t.target !== a ||
                                            t.shiftKey ||
                                            (t.preventDefault(), n.focus());
                                });
                        });
                },
                removeTrapFocus: function (e) {
                    var t = e.namespace ? "focusin." + e.namespace : "focusin";
                    e.container && e.container.removeAttribute("tabindex"), document.documentElement.off(t);
                },
                lockMobileScrolling: function (e, t) {
                    var i = t || document.documentElement;
                    document.documentElement.classList.add("lock-scroll"),
                        i.on("touchmove" + e, function () {
                            return !0;
                        });
                },
                unlockMobileScrolling: function (e, t) {
                    document.documentElement.classList.remove("lock-scroll"),
                        (t || document.documentElement).off("touchmove" + e);
                },
            }),
            document.documentElement.on("keyup.tab", function (e) {
                9 === e.keyCode &&
                    (document.documentElement.classList.add("tab-outline"), document.documentElement.off("keyup.tab"));
            }),
            (theme.Sections = function e() {
                (this.constructors = {}),
                    (this.instances = []),
                    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)),
                    document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)),
                    document.addEventListener("shopify:section:select", this._onSelect.bind(this)),
                    document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)),
                    document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)),
                    document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this));
            }),
            (theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
                _createInstance: function (e, t, i) {
                    var s = e.getAttribute("data-section-id"),
                        n = e.getAttribute("data-section-type");
                    if (void 0 !== (t = t || this.constructors[n])) {
                        i && this._findInstance(s) && this._removeInstance(s);
                        try {
                            var a = Object.assign(new t(e), { id: s, type: n, container: e });
                            this.instances.push(a);
                        } catch (o) {
                            console.error(o);
                        }
                    }
                },
                _findInstance: function (e) {
                    for (var t = 0; t < this.instances.length; t++)
                        if (this.instances[t].id === e) return this.instances[t];
                },
                _removeInstance: function (e) {
                    for (var t, i = this.instances.length; i--; )
                        if (this.instances[i].id === e) {
                            (t = this.instances[i]), this.instances.splice(i, 1);
                            break;
                        }
                    return t;
                },
                _onSectionLoad: function (e, t, i) {
                    window.AOS && AOS.refreshHard(), theme && theme.initGlobals && theme.initGlobals();
                    var s = t || e.target,
                        n = t || e.target.querySelector("[data-section-id]");
                    if (n) {
                        this._createInstance(n);
                        var a = t ? i : this._findInstance(e.detail.sectionId);
                        s.querySelectorAll("[data-subsection]").length && this.loadSubSections(s),
                            a && "function" == typeof a.onLoad && a.onLoad(e),
                            setTimeout(function () {
                                window.dispatchEvent(new Event("scroll"));
                            }, 200);
                    }
                },
                _onSectionUnload: function (e) {
                    this.instances = this.instances.filter(function (t) {
                        var i = t.id === e.detail.sectionId;
                        return i && "function" == typeof t.onUnload && t.onUnload(e), !i;
                    });
                },
                loadSubSections: function (e) {
                    e &&
                        e.querySelectorAll("[data-section-id]").forEach((e) => {
                            this._onSectionLoad(null, e, e.dataset.sectionId);
                        });
                },
                _onSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onSelect && t.onSelect(e);
                },
                _onDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onDeselect && t.onDeselect(e);
                },
                _onBlockSelect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                },
                _onBlockDeselect: function (e) {
                    var t = this._findInstance(e.detail.sectionId);
                    void 0 !== t && "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                },
                register: function (e, t, i) {
                    this.constructors[e] = t;
                    var s = document.querySelectorAll('[data-section-type="' + e + '"]');
                    i && (s = i.querySelectorAll('[data-section-type="' + e + '"]')),
                        s.forEach(
                            function (e) {
                                this._createInstance(e, t, i);
                            }.bind(this)
                        );
                },
                reinit: function (e) {
                    for (var t = 0; t < this.instances.length; t++) {
                        var i = this.instances[t];
                        i.type === e && "function" == typeof i.forceReload && i.forceReload();
                    }
                },
            })),
            (theme.Currency =
                ((e = theme && theme.settings && theme.settings.superScriptPrice),
                {
                    formatMoney: function t(i, s) {
                        s || (s = theme.settings.moneyFormat), "string" == typeof i && (i = i.replace(".", ""));
                        var n = "",
                            a = /\{\{\s*(\w+)\s*\}\}/,
                            o = s || "${{amount}}";
                        function r(e, t, i, s) {
                            if (
                                ((t = theme.utils.defaultTo(t, 2)),
                                (i = theme.utils.defaultTo(i, ",")),
                                (s = theme.utils.defaultTo(s, ".")),
                                isNaN(e) || null == e)
                            )
                                return 0;
                            var n,
                                a = (e = (e / 100).toFixed(t)).split(".");
                            return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? s + a[1] : "");
                        }
                        switch (o.match(a)[1]) {
                            case "amount":
                                (n = r(i, 2)), e && n && n.includes(".") && (n = n.replace(".", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals":
                                n = r(i, 0);
                                break;
                            case "amount_with_comma_separator":
                                (n = r(i, 2, ".", ",")),
                                    e && n && n.includes(",") && (n = n.replace(",", "<sup>") + "</sup>");
                                break;
                            case "amount_no_decimals_with_comma_separator":
                                n = r(i, 0, ".", ",");
                                break;
                            case "amount_no_decimals_with_space_separator":
                                n = r(i, 0, " ");
                        }
                        return o.replace(a, n);
                    },
                    getBaseUnit: function e(t) {
                        if (t && t.unit_price_measurement && t.unit_price_measurement.reference_value)
                            return 1 === t.unit_price_measurement.reference_value
                                ? t.unit_price_measurement.reference_unit
                                : t.unit_price_measurement.reference_value + t.unit_price_measurement.reference_unit;
                    },
                })),
            (theme.Images = {
                imageSize: function e(t) {
                    if (!t) return "620x";
                    var i = t.match(
                        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
                    );
                    return null !== i ? i[1] : null;
                },
                getSizedImageUrl: function e(t, i) {
                    if (!t || null == i) return t;
                    if ("master" === i) return this.removeProtocol(t);
                    var s = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (null != s) {
                        var n = t.split(s[0]),
                            a = s[0];
                        return this.removeProtocol(n[0] + "_" + i + a);
                    }
                    return null;
                },
                removeProtocol: function e(t) {
                    return t.replace(/http(s)?:/, "");
                },
                buildImagePath: function e(t, i) {
                    if (null == t) return [];
                    if (!i) return [t];
                    {
                        let s = [];
                        return (
                            i.forEach((e) => {
                                let n = `${t}?width=${e}`;
                                e === i[i.length - 1] ? (n += ` ${e}w`) : (n += ` ${e}w,`), s.push(n);
                            }),
                            s
                        );
                    }
                },
            }),
            (theme.initWhenVisible = function (e) {
                var t = e.threshold ? e.threshold : 0;
                new IntersectionObserver(
                    (t, i) => {
                        t.forEach((t) => {
                            t.isIntersecting &&
                                "function" == typeof e.callback &&
                                (e.callback(), i.unobserve(t.target));
                        });
                    },
                    { rootMargin: "0px 0px " + t + "px 0px" }
                ).observe(e.element);
            }),
            (theme.Variants = (function () {
                function e(e) {
                    (this.container = e.container),
                        (this.variants = e.variants),
                        (this.singleOptionSelector = e.singleOptionSelector),
                        (this.originalSelectorId = e.originalSelectorId),
                        (this.enableHistoryState = e.enableHistoryState),
                        (this.dynamicVariantsEnabled = e.dynamicVariantsEnabled),
                        (this.currentlySelectedValues = this._getCurrentOptions()),
                        (this.currentVariant = this._getVariantFromOptions()),
                        this.container.querySelectorAll(this.singleOptionSelector).forEach((e) => {
                            e.addEventListener("change", this._onSelectChange.bind(this));
                        });
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        _getCurrentOptions: function () {
                            var e = [];
                            return (
                                this.container.querySelectorAll(this.singleOptionSelector).forEach((t) => {
                                    var i = t.getAttribute("type");
                                    "radio" === i || "checkbox" === i
                                        ? t.checked && e.push({ value: t.value, index: t.dataset.index })
                                        : e.push({ value: t.value, index: t.dataset.index });
                                }),
                                (e = theme.utils.compact(e))
                            );
                        },
                        _numberFromOptionKey: function (e) {
                            return parseInt(e.substr(-1));
                        },
                        _getWeightedOptionMatchCount: function (e) {
                            return this._getCurrentOptions().reduce((t, { value: i, index: s }) => {
                                let n = this._numberFromOptionKey(s);
                                return e[s] === i ? t + (4 - n) : t;
                            }, 0);
                        },
                        _getFullMatch(e) {
                            let t = this._getCurrentOptions(),
                                i = this.variants;
                            return i.find((i) => {
                                let s = t.every(({ value: e, index: t }) => i[t] === e);
                                return e ? s && i.available : s;
                            });
                        },
                        _getClosestAvailableMatch: function (e) {
                            if (!e) return null;
                            let t = this._getCurrentOptions(),
                                i = this.variants,
                                s =
                                    e &&
                                    i.filter(
                                        (i) =>
                                            t
                                                .filter(
                                                    ({ value: t, index: i }) =>
                                                        this._numberFromOptionKey(i) <=
                                                        this._numberFromOptionKey(e.index)
                                                )
                                                .every(({ value: e, index: t }) => i[t] === e) && i.available
                                    );
                            return s.reduce((t, i) => {
                                if (null === t) return i;
                                let s = this._getWeightedOptionMatchCount(t, e),
                                    n = this._getWeightedOptionMatchCount(i, e);
                                return n > s ? i : t;
                            }, null);
                        },
                        _getVariantFromOptions: function (e) {
                            let t = this._getFullMatch(!0),
                                i = this._getClosestAvailableMatch(e),
                                s = this._getFullMatch(!1);
                            return this.dynamicVariantsEnabled ? t || i || s || null : s || null;
                        },
                        _updateInputState: function (e, t) {
                            return (t) => {
                                if (null === e) return;
                                let i = t.dataset.index,
                                    s = t.value,
                                    n = t.getAttribute("type");
                                "radio" === n || "checkbox" === n ? (t.checked = e[i] === s) : (t.value = e[i]);
                            };
                        },
                        _onSelectChange: function ({ srcElement: e }) {
                            let t = this.container.querySelectorAll(this.singleOptionSelector),
                                i = this._getVariantFromOptions({ index: e.dataset.index, value: e.value });
                            t.forEach(this._updateInputState(i, e));
                            let s = (this.currentlySelectedValues = this._getCurrentOptions()),
                                n = {
                                    variant: i,
                                    currentlySelectedValues: s,
                                    value: e.value,
                                    index: e.parentElement.dataset.index,
                                };
                            this.container.dispatchEvent(new CustomEvent("variantChange", { detail: n })),
                                document.dispatchEvent(new CustomEvent("variant:change", { detail: n })),
                                i &&
                                    (this._updateMasterSelect(i),
                                    this._updateImages(i),
                                    this._updatePrice(i),
                                    this._updateUnitPrice(i),
                                    this._updateSKU(i),
                                    (this.currentVariant = i),
                                    this.enableHistoryState && this._updateHistoryState(i));
                        },
                        _updateImages: function (e) {
                            var t = e.featured_image || {},
                                i = (this.currentVariant && this.currentVariant.featured_image) || {};
                            e.featured_image &&
                                t.src !== i.src &&
                                this.container.dispatchEvent(
                                    new CustomEvent("variantImageChange", { detail: { variant: e } })
                                );
                        },
                        _updatePrice: function (e) {
                            (!this.currentVariant ||
                                e.price !== this.currentVariant.price ||
                                e.compare_at_price !== this.currentVariant.compare_at_price) &&
                                this.container.dispatchEvent(
                                    new CustomEvent("variantPriceChange", { detail: { variant: e } })
                                );
                        },
                        _updateUnitPrice: function (e) {
                            (!this.currentVariant || e.unit_price !== this.currentVariant.unit_price) &&
                                this.container.dispatchEvent(
                                    new CustomEvent("variantUnitPriceChange", { detail: { variant: e } })
                                );
                        },
                        _updateSKU: function (e) {
                            (!this.currentVariant || e.sku !== this.currentVariant.sku) &&
                                this.container.dispatchEvent(
                                    new CustomEvent("variantSKUChange", { detail: { variant: e } })
                                );
                        },
                        _updateHistoryState: function (e) {
                            if (history.replaceState && e) {
                                var t =
                                    window.location.protocol +
                                    "//" +
                                    window.location.host +
                                    window.location.pathname +
                                    "?variant=" +
                                    e.id;
                                window.history.replaceState({ path: t }, "", t);
                            }
                        },
                        _updateMasterSelect: function (e) {
                            let t = this.container.querySelector(this.originalSelectorId);
                            t && ((t.value = e.id), t.dispatchEvent(new Event("change", { bubbles: !0 })));
                        },
                    })),
                    e
                );
            })()),
            (theme.rteInit = function () {
                function e(e) {
                    e.src = e.src;
                    var t = document.createElement("div");
                    t.classList.add("video-wrapper"), theme.utils.wrap(e, t);
                }
                document.querySelectorAll(".rte table").forEach((e) => {
                    var t = document.createElement("div");
                    t.classList.add("table-wrapper"), theme.utils.wrap(e, t);
                }),
                    document.querySelectorAll('.rte iframe[src*="youtube.com/embed"]').forEach((t) => {
                        e(t);
                    }),
                    document.querySelectorAll('.rte iframe[src*="player.vimeo"]').forEach((t) => {
                        e(t);
                    }),
                    document.querySelectorAll(".rte a img").forEach((e) => {
                        e.parentNode.classList.add("rte__image");
                    });
            }),
            (theme.LibraryLoader =
                ((i = { requested: "requested", loaded: "loaded" }),
                (s = "https://cdn.shopify.com/shopifycloud/"),
                (n = {
                    youtubeSdk: {
                        tagId: "youtube-sdk",
                        src: "https://www.youtube.com/iframe_api",
                        type: (t = { link: "link", script: "script" }).script,
                    },
                    vimeo: { tagId: "vimeo-api", src: "https://player.vimeo.com/api/player.js", type: t.script },
                    shopifyXr: {
                        tagId: "shopify-model-viewer-xr",
                        src: s + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
                        type: t.script,
                    },
                    modelViewerUi: {
                        tagId: "shopify-model-viewer-ui",
                        src: s + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
                        type: t.script,
                    },
                    modelViewerUiStyles: {
                        tagId: "shopify-model-viewer-ui-styles",
                        src: s + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
                        type: t.link,
                    },
                }),
                {
                    load: function e(s, a) {
                        var o,
                            r = n[s];
                        if (r && r.status !== i.requested) {
                            if (((a = a || function () {}), r.status === i.loaded)) {
                                a();
                                return;
                            }
                            switch (((r.status = i.requested), r.type)) {
                                case t.script:
                                    o =
                                        ((c = r),
                                        (l = a),
                                        (d = document.createElement("script")),
                                        (d.src = c.src),
                                        d.addEventListener("load", function () {
                                            (c.status = i.loaded), l();
                                        }),
                                        d);
                                    break;
                                case t.link:
                                    o =
                                        ((h = r),
                                        (u = a),
                                        (p = document.createElement("link")),
                                        (p.href = h.src),
                                        (p.rel = "stylesheet"),
                                        (p.type = "text/css"),
                                        p.addEventListener("load", function () {
                                            (h.status = i.loaded), u();
                                        }),
                                        p);
                            }
                            (o.id = r.tagId), (r.element = o);
                            var c,
                                l,
                                d,
                                h,
                                u,
                                p,
                                f = document.getElementsByTagName(r.type)[0];
                            f.parentNode.insertBefore(o, f);
                        }
                    },
                })),
            (window.vimeoApiReady = function () {
                let e, t;
                (theme.config.vimeoLoading = !0),
                    new Promise((i, s) => {
                        (e = setInterval(function () {
                            Vimeo && (clearInterval(e), clearTimeout(t), i());
                        }, 500)),
                            (t = setTimeout(function () {
                                clearInterval(e), s();
                            }, 4e3));
                    }).then(function () {
                        (theme.config.vimeoReady = !0),
                            (theme.config.vimeoLoading = !1),
                            document.dispatchEvent(new CustomEvent("vimeoReady"));
                    });
            }),
            (theme.VimeoPlayer = (function () {
                let e = { loading: "loading", loaded: "loaded", interactable: "video-interactable" },
                    t = { byline: !1, loop: !0, muted: !0, playsinline: !0, portrait: !1, title: !1 };
                function i(e, t, i) {
                    (this.divId = e),
                        (this.el = document.getElementById(e)),
                        (this.videoId = t),
                        (this.iframe = null),
                        (this.options = i),
                        this.options &&
                            this.options.videoParent &&
                            (this.parent = this.el.closest(this.options.videoParent)),
                        this.setAsLoading(),
                        theme.config.vimeoReady
                            ? this.init()
                            : (theme.LibraryLoader.load("vimeo", window.vimeoApiReady),
                              document.addEventListener("vimeoReady", this.init.bind(this)));
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            let e = t;
                            (e.id = this.videoId),
                                (this.videoPlayer = new Vimeo.Player(this.el, e)),
                                this.videoPlayer.ready().then(this.playerReady.bind(this));
                        },
                        playerReady: function () {
                            (this.iframe = this.el.querySelector("iframe")),
                                this.iframe.setAttribute("tabindex", "-1"),
                                "false" === this.options.loop && this.videoPlayer.setLoop(!1),
                                "sound" === this.options.style
                                    ? this.videoPlayer.setVolume(1)
                                    : this.videoPlayer.setVolume(0),
                                this.setAsLoaded();
                            let e = new IntersectionObserver(
                                (e, t) => {
                                    e.forEach((e) => {
                                        e.isIntersecting ? this.play() : this.pause();
                                    });
                                },
                                { rootMargin: "0px 0px 50px 0px" }
                            );
                            e.observe(this.iframe);
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e.loading);
                        },
                        setAsLoaded: function () {
                            this.parent &&
                                (this.parent.classList.remove(e.loading),
                                this.parent.classList.add(e.loaded),
                                this.parent.classList.add(e.interactable),
                                Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add(e.interactable);
                        },
                        play: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.play && this.videoPlayer.play();
                        },
                        pause: function () {
                            this.videoPlayer && "function" == typeof this.videoPlayer.pause && this.videoPlayer.pause();
                        },
                        destroy: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.destroy &&
                                this.videoPlayer.destroy();
                        },
                    })),
                    i
                );
            })()),
            (window.onYouTubeIframeAPIReady = function () {
                (theme.config.youTubeReady = !0), document.dispatchEvent(new CustomEvent("youTubeReady"));
            }),
            (theme.YouTube = (function () {
                var e = { loading: "loading", loaded: "loaded", interactable: "video-interactable" },
                    t = {
                        width: 1280,
                        height: 720,
                        playerVars: {
                            autohide: 0,
                            autoplay: 1,
                            cc_load_policy: 0,
                            controls: 0,
                            fs: 0,
                            iv_load_policy: 3,
                            modestbranding: 1,
                            playsinline: 1,
                            rel: 0,
                        },
                    };
                function i(e, i) {
                    (this.divId = e),
                        (this.iframe = null),
                        (this.attemptedToPlay = !1),
                        (t.events = {
                            onReady: this.onVideoPlayerReady.bind(this),
                            onStateChange: this.onVideoStateChange.bind(this),
                        }),
                        (this.options = Object.assign({}, t, i)),
                        this.options &&
                            (this.options.videoParent &&
                                (this.parent = document.getElementById(this.divId).closest(this.options.videoParent)),
                            this.options.autoplay || (this.options.playerVars.autoplay = this.options.autoplay),
                            "sound" === this.options.style &&
                                ((this.options.playerVars.controls = 1), (this.options.playerVars.autoplay = 0))),
                        this.setAsLoading(),
                        theme.config.youTubeReady
                            ? this.init()
                            : (theme.LibraryLoader.load("youtubeSdk"),
                              document.addEventListener("youTubeReady", this.init.bind(this)));
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            this.videoPlayer = new YT.Player(this.divId, this.options);
                        },
                        onVideoPlayerReady: function (e) {
                            (this.iframe = document.getElementById(this.divId)),
                                this.iframe.setAttribute("tabindex", "-1"),
                                "sound" !== this.options.style && e.target.mute(),
                                new IntersectionObserver(
                                    (e, t) => {
                                        e.forEach((e) => {
                                            e.isIntersecting ? this.play() : this.pause();
                                        });
                                    },
                                    { rootMargin: "0px 0px 50px 0px" }
                                ).observe(this.iframe);
                        },
                        onVideoStateChange: function (e) {
                            switch (e.data) {
                                case -1:
                                    this.attemptedToPlay && (this.setAsLoaded(), this.enableInteraction());
                                    break;
                                case 0:
                                    this.play(e);
                                    break;
                                case 1:
                                    this.setAsLoaded();
                                    break;
                                case 3:
                                    this.attemptedToPlay = !0;
                            }
                        },
                        setAsLoading: function () {
                            this.parent && this.parent.classList.add(e.loading);
                        },
                        setAsLoaded: function () {
                            this.parent &&
                                (this.parent.classList.remove(e.loading),
                                this.parent.classList.add(e.loaded),
                                Shopify && Shopify.designMode && window.AOS && AOS.refreshHard());
                        },
                        enableInteraction: function () {
                            this.parent && this.parent.classList.add(e.interactable);
                        },
                        play: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.playVideo &&
                                this.videoPlayer.playVideo();
                        },
                        pause: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.pauseVideo &&
                                this.videoPlayer.pauseVideo();
                        },
                        destroy: function () {
                            this.videoPlayer &&
                                "function" == typeof this.videoPlayer.destroy &&
                                this.videoPlayer.destroy();
                        },
                    })),
                    i
                );
            })()),
            (o = !1),
            document.body.addEventListener("touchstart", function (e) {
                if (!e.target.closest(".flickity-slider")) return (o = !1);
                (o = !0), (a = { x: e.touches[0].pageX, y: e.touches[0].pageY });
            }),
            document.body.addEventListener(
                "touchmove",
                function (e) {
                    o &&
                        e.cancelable &&
                        Math.abs({ x: e.touches[0].pageX - a.x, y: e.touches[0].pageY - a.y }.x) >
                            Flickity.defaults.dragThreshold &&
                        e.preventDefault();
                },
                { passive: !1 }
            ),
            (theme.AjaxRenderer = (function () {
                function e({ sections: e, onReplace: t, debug: i } = {}) {
                    (this.sections = e || []),
                        (this.cachedSections = []),
                        (this.onReplace = t),
                        (this.debug = Boolean(i));
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        renderPage: function (e, t, i = !0) {
                            let s = new URLSearchParams(window.location.search),
                                n = this.getUpdatedParams(s, t),
                                a = this.sections.map((t) => {
                                    let i = `${e}?section_id=${t.sectionId}&${n.toString()}`,
                                        s = (e) => e.url === i;
                                    return this.cachedSections.some(s)
                                        ? this.renderSectionFromCache(s, t)
                                        : this.renderSectionFromFetch(i, t);
                                });
                            return i && this.updateURLHash(n), Promise.all(a);
                        },
                        renderSectionFromCache: function (e, t) {
                            let i = this.cachedSections.find(e);
                            return (
                                this.log(`[AjaxRenderer] rendering from cache: url=${i.url}`),
                                this.renderSection(i.html, t),
                                Promise.resolve(t)
                            );
                        },
                        renderSectionFromFetch: function (e, t) {
                            return (
                                this.log(`[AjaxRenderer] redering from fetch: url=${e}`),
                                new Promise((i, s) => {
                                    fetch(e)
                                        .then((e) => e.text())
                                        .then((s) => {
                                            let n = s;
                                            (this.cachedSections = [...this.cachedSections, { html: n, url: e }]),
                                                this.renderSection(n, t),
                                                i(t);
                                        })
                                        .catch((e) => s(e));
                                })
                            );
                        },
                        renderSection: function (e, t) {
                            this.log(`[AjaxRenderer] rendering section: section=${JSON.stringify(t)}`);
                            let i = new DOMParser().parseFromString(e, "text/html");
                            if (this.onReplace) this.onReplace(i, t);
                            else if ("string" == typeof t.nodeId) {
                                var s = i.getElementById(t.nodeId);
                                if (!s) return;
                                document.getElementById(t.nodeId).innerHTML = s.innerHTML;
                            } else
                                t.nodeId.forEach((e) => {
                                    document.getElementById(e).innerHTML = i.getElementById(e).innerHTML;
                                });
                            return t;
                        },
                        getUpdatedParams: function (e, t) {
                            let i = new URLSearchParams(e),
                                s = ["sort_by", "q", "options[prefix]", "type"];
                            for (let [n, a] of i.entries()) t.getAll(n).includes(a) || s.includes(n) || i.delete(n);
                            for (let [o, r] of t.entries()) i.getAll(o).includes(r) || "" === r || i.append(o, r);
                            return i;
                        },
                        updateURLHash: function (e) {
                            history.pushState({}, "", `${window.location.pathname}${e && "?".concat(e)}`);
                        },
                        log: function (...e) {
                            this.debug && console.log(...e);
                        },
                    })),
                    e
                );
            })()),
            window.Shopify &&
                window.Shopify.theme &&
                navigator &&
                navigator.sendBeacon &&
                window.Shopify.designMode &&
                navigator.sendBeacon(
                    "https://api.archetypethemes.co/api/beacon",
                    new URLSearchParams({
                        shop: window.Shopify.shop,
                        themeName:
                            window.theme &&
                            window.theme.settings &&
                            `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
                        role: window.Shopify.theme.role,
                        route: window.location.pathname,
                        themeId: window.Shopify.theme.id,
                        themeStoreId: window.Shopify.theme.theme_store_id || 0,
                        isThemeEditor: !!window.Shopify.designMode,
                    })
                ),
            (theme.cart = {
                getCart: function () {
                    return fetch("".concat(theme.routes.cart, "?t=").concat(Date.now()), {
                        credentials: "same-origin",
                        method: "GET",
                    }).then((e) => e.json());
                },
                getCartProductMarkup: function () {
                    var e = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());
                    return fetch((e = -1 === e.indexOf("?") ? e + "?view=ajax" : e + "&view=ajax"), {
                        credentials: "same-origin",
                        method: "GET",
                    })
                        .then((e) => e.text())
                        .catch((e) => console.error(e));
                },
                changeItem: function (e, t) {
                    return this._updateCart({
                        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
                        data: JSON.stringify({ id: e, quantity: t }),
                    });
                },
                _updateCart: function (e) {
                    return fetch(e.url, {
                        method: "POST",
                        body: e.data,
                        credentials: "same-origin",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                            Accept: "application/json",
                        },
                    })
                        .then((e) => e.text())
                        .then((e) => e);
                },
                updateAttribute: function (e, t) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({ attributes: { [e]: theme.cart.attributeToString(t) } }),
                    });
                },
                updateNote: function (e) {
                    return this._updateCart({
                        url: "/cart/update.js",
                        data: JSON.stringify({ note: theme.cart.attributeToString(e) }),
                    });
                },
                attributeToString: function (e) {
                    return "string" != typeof e && "undefined" == (e += "") && (e = ""), e.trim();
                },
            }),
            (theme.CartForm = (function () {
                var e = {
                        products: "[data-products]",
                        qtySelector: ".js-qty__wrapper",
                        discounts: "[data-discounts]",
                        savings: "[data-savings]",
                        subTotal: "[data-subtotal]",
                        cartBubble: ".cart-link__bubble",
                        cartNote: '[name="note"]',
                        termsCheckbox: ".cart__terms-checkbox",
                        checkoutBtn: ".cart__checkout",
                    },
                    t = { btnLoading: "btn--loading" },
                    i = { requiresTerms: !1 };
                function s(t) {
                    t &&
                        ((this.form = t),
                        (this.wrapper = t.parentNode),
                        (this.location = t.dataset.location),
                        (this.namespace = ".cart-" + this.location),
                        (this.products = t.querySelector(e.products)),
                        (this.submitBtn = t.querySelector(e.checkoutBtn)),
                        (this.discounts = t.querySelector(e.discounts)),
                        (this.savings = t.querySelector(e.savings)),
                        (this.subtotal = t.querySelector(e.subTotal)),
                        (this.termsCheckbox = t.querySelector(e.termsCheckbox)),
                        (this.noteInput = t.querySelector(e.cartNote)),
                        (this.cartItemsUpdated = !1),
                        this.termsCheckbox && (i.requiresTerms = !0),
                        this.init());
                }
                return (
                    (s.prototype = Object.assign({}, s.prototype, {
                        init: function () {
                            this.initQtySelectors(),
                                this.updateFreeShipping(),
                                document.addEventListener(
                                    "cart:quantity" + this.namespace,
                                    this.quantityChanged.bind(this)
                                ),
                                this.form.on("submit" + this.namespace, this.onSubmit.bind(this)),
                                this.noteInput &&
                                    this.noteInput.addEventListener("change", function () {
                                        var e = this.value;
                                        theme.cart.updateNote(e);
                                    }),
                                document.addEventListener(
                                    "cart:build",
                                    function () {
                                        this.buildCart();
                                    }.bind(this)
                                );
                        },
                        updateFreeShipping: function (cartTotalCents) {
                            var progressBarInput = document.querySelector("#CartDrawer .progressbar-box input");
                            if (!progressBarInput) return;
                            var baseAmount = parseFloat(progressBarInput.getAttribute("data-base-amount")) || 0;
                            if (baseAmount === 0) return;
                            var currencyRate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? window.Shopify.currency.rate : 1;
                            var convertedAmount = Math.round(baseAmount * currencyRate);
                            var cartTotal = cartTotalCents !== undefined ? cartTotalCents : (function() {
                                var cartDrawer = document.getElementById("CartDrawer");
                                return cartDrawer ? parseFloat(cartDrawer.getAttribute("data-cart-total")) || 0 : 0;
                            })();
                            var subtotalValue = cartTotal / 100;
                            var remainingPrice = Math.ceil(convertedAmount - subtotalValue);
                            var percentComplete = convertedAmount > 0 ? Math.max(0, Math.min(100, Math.ceil(100 - (100 * subtotalValue) / convertedAmount))) : 0;
                            var progressBar = document.querySelector("#CartDrawer .progressbar_range .process-bar__percent");
                            var remainingPriceEl = document.querySelector("#CartDrawer .remaining_price_for_shipping");
                            var priceRemainingEl = document.querySelector("#CartDrawer .price_remaining");
                            var priceNoRemainingEl = document.querySelector("#CartDrawer .price_noRemaining");
                            if (progressBar) {
                                progressBar.style.right = percentComplete + "%";
                            }
                            if (remainingPriceEl) {
                                remainingPriceEl.innerText = remainingPrice;
                            }
                            if (remainingPrice > 0) {
                                priceRemainingEl && priceRemainingEl.classList.contains("hide") && priceRemainingEl.classList.remove("hide");
                                priceNoRemainingEl && !priceNoRemainingEl.classList.contains("hide") && priceNoRemainingEl.classList.add("hide");
                            } else {
                                priceRemainingEl && !priceRemainingEl.classList.contains("hide") && priceRemainingEl.classList.add("hide");
                                priceNoRemainingEl && priceNoRemainingEl.classList.contains("hide") && priceNoRemainingEl.classList.remove("hide");
                            }
                        },
                        reInit: function () {
                            this.initQtySelectors();
                        },
                        onSubmit: function (e) {
                            return (this.submitBtn.classList.add(t.btnLoading),
                            (document.documentElement.classList.contains("js-drawer-open") && this.cartItemsUpdated) ||
                                (document.documentElement.classList.contains("cart-open") && this.cartItemsUpdated))
                                ? (this.submitBtn.classList.remove(t.btnLoading), e.preventDefault(), !1)
                                : i.requiresTerms && !this.termsCheckbox.checked
                                  ? (alert(theme.strings.cartTermsConfirmation),
                                    this.submitBtn.classList.remove(t.btnLoading),
                                    e.preventDefault(),
                                    !1)
                                  : void 0;
                        },
                        _parseProductHTML: function (e) {
                            let t = document.createElement("div");
                            return (
                                (t.innerHTML = e),
                                {
                                    items: t.querySelector(".cart__items"),
                                    discounts: t.querySelector(".cart__discounts"),
                                }
                            );
                        },
                        buildCart: function () {
                            theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
                        },
                        cartMarkup: function (e) {
                            var t = this._parseProductHTML(e),
                                i = t.items,
                                s = parseInt(i.dataset.count),
                                n = i.dataset.cartSubtotal,
                                a = i.dataset.cartSavings;
                            this.updateCartDiscounts(t.discounts),
                                this.updateSavings(a),
                                s > 0
                                    ? this.wrapper.classList.remove("is-empty")
                                    : this.wrapper.classList.add("is-empty"),
                                this.updateCount(s),
                                (this.products.innerHTML = ""),
                                this.products.append(i);
                            var o = document.querySelector(".cart__items").getAttribute("data-count"),
                                r = document.querySelector(".cart-item");
                            (r.innerHTML = ""), (r.innerHTML = "CART (" + o + ")");
                            this.updateFreeShipping(parseFloat(n));
                            (this.subtotal.innerHTML = theme.Currency.formatMoney(n, theme.settings.moneyFormat)),
                                this.reInit(),
                                window.AOS && AOS.refreshHard(),
                                Shopify &&
                                    Shopify.StorefrontExpressButtons &&
                                    Shopify.StorefrontExpressButtons.initialize();
                        },
                        updateCartDiscounts: function (e) {
                            this.discounts && ((this.discounts.innerHTML = ""), this.discounts.append(e));
                        },
                        initQtySelectors: function () {
                            this.form.querySelectorAll(e.qtySelector).forEach((e) => {
                                new theme.QtySelector(e, { namespace: this.namespace, isCart: !0 });
                            });
                        },
                        quantityChanged: function (e) {
                            var t = e.detail[0],
                                i = e.detail[1],
                                s = e.detail[2];
                            t &&
                                i &&
                                (s && s.classList.add("is-loading"),
                                theme.cart
                                    .changeItem(t, i)
                                    .then(
                                        function (i) {
                                            let s = JSON.parse(i);
                                            if (422 === s.status) alert(s.message);
                                            else {
                                                let n = s.items.find((e) => e.key === t);
                                                n &&
                                                    ("cart:quantity.cart-cart-drawer" === e.type ||
                                                        "cart:quantity.cart-header" === e.type) &&
                                                    (this.cartItemsUpdated = !0),
                                                    ((n && "cart:quantity.cart-cart-drawer" === e.type) ||
                                                        (n && "cart:quantity.cart-header" === e.type)) &&
                                                        (n.quantity, (this.cartItemsUpdated = !1)),
                                                    s.item_count > 0
                                                        ? this.wrapper.classList.remove("is-empty")
                                                        : this.wrapper.classList.add("is-empty");
                                            }
                                            this.buildCart(),
                                                document.dispatchEvent(
                                                    new CustomEvent("cart:updated", { detail: { cart: s } })
                                                );
                                        }.bind(this)
                                    )
                                    .catch(function (e) {}));
                        },
                        updateSubtotal: function (t) {
                            this.form.querySelector(e.subTotal).innerHTML = theme.Currency.formatMoney(
                                t,
                                theme.settings.moneyFormat
                            );
                        },
                        updateSavings: function (e) {
                            if (this.savings) {
                                if (e > 0) {
                                    var t = theme.Currency.formatMoney(e, theme.settings.moneyFormat);
                                    this.savings.classList.remove("hide"),
                                        (this.savings.innerHTML = theme.strings.cartSavings.replace("[savings]", t));
                                } else this.savings.classList.add("hide");
                            }
                        },
                        updateCount: function (t) {
                            var i = document.querySelectorAll(".cart-link__bubble-num");
                            i.length &&
                                i.forEach((e) => {
                                    e.innerText = t;
                                });
                            var s = document.querySelectorAll(e.cartBubble);
                            s.length &&
                                (t > 0
                                    ? s.forEach((e) => {
                                          e.classList.add("cart-link__bubble--visible");
                                      })
                                    : s.forEach((e) => {
                                          e.classList.remove("cart-link__bubble--visible");
                                      }));
                        },
                    })),
                    s
                );
            })()),
            (theme.collapsibles = (function () {
                var e = {
                        trigger: ".collapsible-trigger",
                        module: ".collapsible-content",
                        moduleInner: ".collapsible-content__inner",
                        tabs: ".collapsible-trigger--tab",
                    },
                    t = {
                        hide: "hide",
                        open: "is-open",
                        autoHeight: "collapsible--auto-height",
                        tabs: "collapsible-trigger--tab",
                    },
                    i = ".collapsible",
                    s = !1;
                function n(n) {
                    if (!s) {
                        s = !0;
                        var o,
                            r = n.currentTarget,
                            c = r.classList.contains(t.open),
                            l = r.classList.contains(t.tabs),
                            d = r.getAttribute("aria-controls"),
                            h = document.getElementById(d);
                        if ((d || (d = r.dataset.controls), d)) {
                            if (
                                (!h &&
                                    document.querySelectorAll('[data-id="' + d + '"]').length > 0 &&
                                    (h = r.parentNode.querySelector('[data-id="' + d + '"]')),
                                !h)
                            ) {
                                s = !1;
                                return;
                            }
                            var u = h.querySelector(e.moduleInner).offsetHeight,
                                p = h.classList.contains(t.autoHeight),
                                f = h.parentNode.closest(e.module),
                                m = u;
                            if (l) {
                                if (c) {
                                    s = !1;
                                    return;
                                }
                                document.querySelectorAll(e.tabs + '[data-id="' + r.dataset.id + '"]').forEach((e) => {
                                    e.classList.remove(t.open),
                                        a((o = document.querySelector("#" + e.getAttribute("aria-controls"))), 0, !0);
                                });
                            }
                            if (
                                (c &&
                                    p &&
                                    setTimeout(function () {
                                        a(h, (u = 0), c, p);
                                    }, 0),
                                c && !p && (u = 0),
                                r.setAttribute("aria-expanded", !c),
                                c ? r.classList.remove(t.open) : r.classList.add(t.open),
                                a(h, u, c, p),
                                f)
                            ) {
                                var v = f.style.height;
                                c && "auto" === v && (m = 0);
                                var g = c ? f.offsetHeight - m : u + f.offsetHeight;
                                a(f, g, !1, !1);
                            }
                            if (window.SPR) {
                                var y = h.querySelector(".spr-summary-actions-newreview");
                                if (!y) return;
                                y.off("click" + i),
                                    y.on("click" + i, function () {
                                        (u = h.querySelector(e.moduleInner).offsetHeight), a(h, u, c, p);
                                    });
                            }
                        }
                    }
                }
                function a(e, i, n, a) {
                    if (
                        (e.classList.remove(t.hide),
                        theme.utils.prepareTransition(e, function () {
                            (e.style.height = i + "px"), n ? e.classList.remove(t.open) : e.classList.add(t.open);
                        }),
                        !n && a)
                    ) {
                        var o = e;
                        window.setTimeout(function () {
                            o.css("height", "auto"), (s = !1);
                        }, 500);
                    } else s = !1;
                }
                return {
                    init: function s(a) {
                        (a || document).querySelectorAll(e.trigger).forEach((e) => {
                            var s = e.classList.contains(t.open);
                            e.setAttribute("aria-expanded", s), e.off("click" + i), e.on("click" + i, n);
                        });
                    },
                };
            })()),
            (theme.Disclosure = (function () {
                var e = {
                        disclosureForm: "[data-disclosure-form]",
                        disclosureList: "[data-disclosure-list]",
                        disclosureToggle: "[data-disclosure-toggle]",
                        disclosureInput: "[data-disclosure-input]",
                        disclosureOptions: "[data-disclosure-option]",
                    },
                    t = { listVisible: "disclosure-list--visible" };
                function i(e) {
                    (this.container = e), this._cacheSelectors(), this._setupListeners();
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        _cacheSelectors: function () {
                            this.cache = {
                                disclosureForm: this.container.closest(e.disclosureForm),
                                disclosureList: this.container.querySelector(e.disclosureList),
                                disclosureToggle: this.container.querySelector(e.disclosureToggle),
                                disclosureInput: this.container.querySelector(e.disclosureInput),
                                disclosureOptions: this.container.querySelectorAll(e.disclosureOptions),
                            };
                        },
                        _setupListeners: function () {
                            (this.eventHandlers = this._setupEventHandlers()),
                                this.cache.disclosureToggle.addEventListener("click", this.eventHandlers.toggleList),
                                this.cache.disclosureOptions.forEach(function (e) {
                                    e.addEventListener("click", this.eventHandlers.connectOptions);
                                }, this),
                                this.container.addEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                                this.cache.disclosureList.addEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureListFocusOut
                                ),
                                this.cache.disclosureToggle.addEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureToggleFocusOut
                                ),
                                document.body.addEventListener("click", this.eventHandlers.onBodyClick);
                        },
                        _setupEventHandlers: function () {
                            return {
                                connectOptions: this._connectOptions.bind(this),
                                toggleList: this._toggleList.bind(this),
                                onBodyClick: this._onBodyClick.bind(this),
                                onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
                                onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
                                onDisclosureToggleFocusOut: this._onDisclosureToggleFocusOut.bind(this),
                            };
                        },
                        _connectOptions: function (e) {
                            e.preventDefault(), this._submitForm(e.currentTarget.dataset.value);
                        },
                        _onDisclosureToggleFocusOut: function (e) {
                            !1 === this.container.contains(e.relatedTarget) && this._hideList();
                        },
                        _onDisclosureListFocusOut: function (e) {
                            var i = e.currentTarget.contains(e.relatedTarget);
                            this.cache.disclosureList.classList.contains(t.listVisible) && !i && this._hideList();
                        },
                        _onDisclosureKeyUp: function (e) {
                            27 === e.which && (this._hideList(), this.cache.disclosureToggle.focus());
                        },
                        _onBodyClick: function (e) {
                            var i = this.container.contains(e.target);
                            this.cache.disclosureList.classList.contains(t.listVisible) && !i && this._hideList();
                        },
                        _submitForm: function (e) {
                            (this.cache.disclosureInput.value = e), this.cache.disclosureForm.submit();
                        },
                        _hideList: function () {
                            this.cache.disclosureList.classList.remove(t.listVisible),
                                this.cache.disclosureToggle.setAttribute("aria-expanded", !1);
                        },
                        _toggleList: function () {
                            var e = "true" === this.cache.disclosureToggle.getAttribute("aria-expanded");
                            this.cache.disclosureList.classList.toggle(t.listVisible),
                                this.cache.disclosureToggle.setAttribute("aria-expanded", !e);
                        },
                        destroy: function () {
                            this.cache.disclosureToggle.removeEventListener("click", this.eventHandlers.toggleList),
                                this.cache.disclosureOptions.forEach(function (e) {
                                    e.removeEventListener("click", this.eventHandlers.connectOptions);
                                }, this),
                                this.container.removeEventListener("keyup", this.eventHandlers.onDisclosureKeyUp),
                                this.cache.disclosureList.removeEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureListFocusOut
                                ),
                                this.cache.disclosureToggle.removeEventListener(
                                    "focusout",
                                    this.eventHandlers.onDisclosureToggleFocusOut
                                ),
                                document.body.removeEventListener("click", this.eventHandlers.onBodyClick);
                        },
                    })),
                    i
                );
            })()),
            (theme.Drawers = (function () {
                function e(e, t) {
                    (this.config = {
                        id: e,
                        close: ".js-drawer-close",
                        open: ".js-drawer-open-" + t,
                        openClass: "js-drawer-open",
                        closingClass: "js-drawer-closing",
                        activeDrawer: "drawer--is-open",
                        namespace: ".drawer-" + t,
                    }),
                        (this.nodes = { page: document.querySelector("#MainContent") }),
                        (this.drawer = document.querySelector("#" + e)),
                        (this.isOpen = !1),
                        this.drawer && this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            document.querySelectorAll(this.config.open).forEach((e) => {
                                e.setAttribute("aria-expanded", "false"),
                                    e.addEventListener("click", this.open.bind(this));
                            }),
                                this.drawer
                                    .querySelector(this.config.close)
                                    .addEventListener("click", this.close.bind(this)),
                                document.addEventListener(
                                    "modalOpen",
                                    function () {
                                        this.close();
                                    }.bind(this)
                                );
                        },
                        open: function (e, t) {
                            e && e.preventDefault(),
                                !this.isOpen &&
                                    (e && e.stopPropagation
                                        ? (e.stopPropagation(),
                                          e.currentTarget.setAttribute("aria-expanded", "true"),
                                          (this.activeSource = e.currentTarget))
                                        : t && (t.setAttribute("aria-expanded", "true"), (this.activeSource = t)),
                                    theme.utils.prepareTransition(
                                        this.drawer,
                                        function () {
                                            this.drawer.classList.add(this.config.activeDrawer);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.add(this.config.openClass),
                                    (this.isOpen = !0),
                                    theme.a11y.trapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                    document.dispatchEvent(new CustomEvent("drawerOpen")),
                                    document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id)),
                                    this.bindEvents());
                        },
                        close: function (e) {
                            if (this.isOpen) {
                                if (e) {
                                    if (e.target.closest(".js-drawer-close"));
                                    else if (e.target.closest(".drawer")) return;
                                }
                                document.activeElement.blur(),
                                    theme.utils.prepareTransition(
                                        this.drawer,
                                        function () {
                                            this.drawer.classList.remove(this.config.activeDrawer);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.remove(this.config.openClass),
                                    document.documentElement.classList.add(this.config.closingClass),
                                    window.setTimeout(
                                        function () {
                                            document.documentElement.classList.remove(this.config.closingClass),
                                                this.activeSource &&
                                                    this.activeSource.getAttribute("aria-expanded") &&
                                                    (this.activeSource.setAttribute("aria-expanded", "false"),
                                                    this.activeSource.focus());
                                        }.bind(this),
                                        500
                                    ),
                                    (this.isOpen = !1),
                                    theme.a11y.removeTrapFocus({ container: this.drawer, namespace: "drawer_focus" }),
                                    this.unbindEvents();
                            }
                        },
                        bindEvents: function () {
                            window.on(
                                "click" + this.config.namespace,
                                function (e) {
                                    this.close(e);
                                }.bind(this)
                            ),
                                window.on(
                                    "keyup" + this.config.namespace,
                                    function (e) {
                                        27 === e.keyCode && this.close();
                                    }.bind(this)
                                ),
                                theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
                        },
                        unbindEvents: function () {
                            window.off("click" + this.config.namespace),
                                window.off("keyup" + this.config.namespace),
                                theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
                        },
                    })),
                    e
                );
            })()),
            (theme.Modals = (function () {
                function e(e, t, i) {
                    if (((this.id = e), (this.modal = document.getElementById(e)), !this.modal)) return !1;
                    (this.modalContent = this.modal.querySelector(".modal__inner")),
                        (this.config = Object.assign(
                            {
                                close: ".js-modal-close",
                                open: ".js-modal-open-" + t,
                                openClass: "modal--is-active",
                                closingClass: "modal--is-closing",
                                bodyOpenClass: ["modal-open"],
                                bodyOpenSolidClass: "modal-open--solid",
                                bodyClosingClass: "modal-closing",
                                closeOffContentClick: !0,
                            },
                            i
                        )),
                        (this.modalIsOpen = !1),
                        (this.focusOnOpen = this.config.focusIdOnOpen
                            ? document.getElementById(this.config.focusIdOnOpen)
                            : this.modal),
                        (this.isSolid = this.config.solid),
                        this.init();
                }
                return (
                    (e.prototype.init = function () {
                        document.querySelectorAll(this.config.open).forEach((e) => {
                            e.setAttribute("aria-expanded", "false"), e.addEventListener("click", this.open.bind(this));
                        }),
                            this.modal.querySelectorAll(this.config.close).forEach((e) => {
                                e.addEventListener("click", this.close.bind(this));
                            }),
                            document.addEventListener(
                                "drawerOpen",
                                function () {
                                    this.close();
                                }.bind(this)
                            );
                    }),
                    (e.prototype.open = function (e) {
                        var t = !1;
                        !this.modalIsOpen &&
                            (e ? e.preventDefault() : (t = !0),
                            e &&
                                e.stopPropagation &&
                                (e.stopPropagation(),
                                (this.activeSource = e.currentTarget.setAttribute("aria-expanded", "true"))),
                            this.modalIsOpen && !t && this.close(),
                            this.modal.classList.add(this.config.openClass),
                            document.documentElement.classList.add(...this.config.bodyOpenClass),
                            this.isSolid && document.documentElement.classList.add(this.config.bodyOpenSolidClass),
                            (this.modalIsOpen = !0),
                            setTimeout(() => {
                                theme.a11y.trapFocus({
                                    container: this.modal,
                                    elementToFocus: this.focusOnOpen,
                                    namespace: "modal_focus",
                                });
                            }, 100),
                            document.dispatchEvent(new CustomEvent("modalOpen")),
                            document.dispatchEvent(new CustomEvent("modalOpen." + this.id)),
                            this.bindEvents());
                    }),
                    (e.prototype.close = function (e) {
                        if (this.modalIsOpen) {
                            if (e) {
                                if (e.target.closest(".js-modal-close"));
                                else if (e.target.closest(".modal__inner")) return;
                            }
                            document.activeElement.blur(),
                                this.modal.classList.remove(this.config.openClass),
                                this.modal.classList.add(this.config.closingClass),
                                document.documentElement.classList.remove(...this.config.bodyOpenClass),
                                document.documentElement.classList.add(this.config.bodyClosingClass),
                                window.setTimeout(
                                    function () {
                                        document.documentElement.classList.remove(this.config.bodyClosingClass),
                                            this.modal.classList.remove(this.config.closingClass),
                                            this.activeSource &&
                                                this.activeSource.getAttribute("aria-expanded") &&
                                                this.activeSource.setAttribute("aria-expanded", "false").focus();
                                    }.bind(this),
                                    500
                                ),
                                this.isSolid &&
                                    document.documentElement.classList.remove(this.config.bodyOpenSolidClass),
                                (this.modalIsOpen = !1),
                                theme.a11y.removeTrapFocus({ container: this.modal, namespace: "modal_focus" }),
                                document.dispatchEvent(new CustomEvent("modalClose." + this.id)),
                                this.unbindEvents();
                        }
                    }),
                    (e.prototype.bindEvents = function () {
                        window.on(
                            "keyup.modal",
                            function (e) {
                                27 === e.keyCode && this.close();
                            }.bind(this)
                        ),
                            this.config.closeOffContentClick && this.modal.on("click.modal", this.close.bind(this));
                    }),
                    (e.prototype.unbindEvents = function () {
                        document.documentElement.off(".modal"),
                            this.config.closeOffContentClick && this.modal.off(".modal");
                    }),
                    e
                );
            })()),
            void 0 === window.noUiSlider)
        )
            throw Error("theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js");
        (theme.PriceRange = (function () {
            var e = {
                priceRange: ".price-range",
                priceRangeSlider: ".price-range__slider",
                priceRangeInputMin: ".price-range__input-min",
                priceRangeInputMax: ".price-range__input-max",
                priceRangeDisplayMin: ".price-range__display-min",
                priceRangeDisplayMax: ".price-range__display-max",
            };
            function t(e, { onChange: t, onUpdate: i, ...s } = {}) {
                return (
                    (this.container = e),
                    (this.onChange = t),
                    (this.onUpdate = i),
                    (this.sliderOptions = s || {}),
                    this.init()
                );
            }
            return (
                (t.prototype = Object.assign({}, t.prototype, {
                    init: function () {
                        if (!this.container.classList.contains("price-range"))
                            throw Error("You must instantiate PriceRange with a valid container");
                        return (
                            (this.formEl = this.container.closest("form")),
                            (this.sliderEl = this.container.querySelector(e.priceRangeSlider)),
                            (this.inputMinEl = this.container.querySelector(e.priceRangeInputMin)),
                            (this.inputMaxEl = this.container.querySelector(e.priceRangeInputMax)),
                            (this.displayMinEl = this.container.querySelector(e.priceRangeDisplayMin)),
                            (this.displayMaxEl = this.container.querySelector(e.priceRangeDisplayMax)),
                            (this.minRange = parseFloat(this.container.dataset.min) || 0),
                            (this.minValue = parseFloat(this.container.dataset.minValue) || 0),
                            (this.maxRange = parseFloat(this.container.dataset.max) || 100),
                            (this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange),
                            this.createPriceRange()
                        );
                    },
                    createPriceRange: function () {
                        this.sliderEl &&
                            this.sliderEl.noUiSlider &&
                            "function" == typeof this.sliderEl.noUiSlider.destroy &&
                            this.sliderEl.noUiSlider.destroy();
                        var e = noUiSlider.create(this.sliderEl, {
                            connect: !0,
                            step: 10,
                            ...this.sliderOptions,
                            start: [this.minValue, this.maxValue],
                            range: { min: this.minRange, max: this.maxRange },
                        });
                        return (
                            e.on("update", (e) => {
                                (this.displayMinEl.innerHTML = theme.Currency.formatMoney(
                                    e[0],
                                    theme.settings.moneyFormat
                                )),
                                    (this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
                                        e[1],
                                        theme.settings.moneyFormat
                                    )),
                                    this.onUpdate && this.onUpdate(e);
                            }),
                            e.on("change", (e) => {
                                if (((this.inputMinEl.value = e[0]), (this.inputMaxEl.value = e[1]), this.onChange)) {
                                    let t = new FormData(this.formEl);
                                    this.onChange(t);
                                }
                            }),
                            e
                        );
                    },
                })),
                t
            );
        })()),
            (theme.AjaxProduct = (function () {
                var e = { loading: !1 };
                function t(e, t, i) {
                    (this.form = e),
                        (this.args = i),
                        this.form &&
                            ((this.addToCart = e.querySelector(t || ".add-to-cart")),
                            this.form.addEventListener("submit", this.addItemFromForm.bind(this)));
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        addItemFromForm: function (t, i) {
                            if ((t.preventDefault(), !e.loading)) {
                                this.addToCart.classList.add("btn--loading"), (e.loading = !0);
                                var s = theme.utils.serialize(this.form);
                                fetch(theme.routes.cartAdd, {
                                    method: "POST",
                                    body: s,
                                    credentials: "same-origin",
                                    headers: {
                                        "Content-Type": "application/x-www-form-urlencoded",
                                        "X-Requested-With": "XMLHttpRequest",
                                    },
                                })
                                    .then((e) => e.json())
                                    .then(
                                        function (t) {
                                            422 === t.status ? this.error(t) : this.success(t),
                                                (e.loading = !1),
                                                this.addToCart.classList.remove("btn--loading"),
                                                document.body.classList.contains("template-cart") &&
                                                    (window.scrollTo(0, 0), location.reload());
                                        }.bind(this)
                                    );
                            }
                        },
                        success: function (e) {
                            var t = this.form.querySelector(".errors");
                            t && t.remove(),
                                this.form.dispatchEvent(
                                    new CustomEvent("ajaxProduct:added", {
                                        detail: { product: e, addToCartBtn: this.addToCart },
                                        bubbles: !0,
                                    })
                                ),
                                this.args &&
                                    this.args.scopedEventId &&
                                    document.dispatchEvent(
                                        new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
                                            detail: { product: e, addToCartBtn: this.addToCart },
                                        })
                                    );
                        },
                        error: function (e) {
                            if (!e.description) {
                                console.warn(e);
                                return;
                            }
                            var t = this.form.querySelector(".errors");
                            t && t.remove();
                            var i = document.createElement("div");
                            i.classList.add("errors", "text-center"),
                                "object" == typeof e.description
                                    ? (i.textContent = e.message)
                                    : (i.textContent = e.description),
                                this.form.append(i),
                                this.form.dispatchEvent(
                                    new CustomEvent("ajaxProduct:error", {
                                        detail: { errorMessage: e.description },
                                        bubbles: !0,
                                    })
                                ),
                                this.args &&
                                    this.args.scopedEventId &&
                                    document.dispatchEvent(
                                        new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
                                            detail: { errorMessage: e.description },
                                        })
                                    );
                        },
                    })),
                    t
                );
            })()),
            (theme.ProductMedia = (function () {
                var e = {},
                    t = {},
                    i = {},
                    s = { mediaGroup: "[data-product-single-media-group]", xrButton: "[data-shopify-xr]" };
                function n(e) {
                    if (!e) {
                        for (var i in t)
                            if (t.hasOwnProperty(i)) {
                                var s = t[i];
                                !s.modelViewerUi && Shopify && (s.modelViewerUi = new Shopify.ModelViewerUI(s.element)),
                                    a(s);
                            }
                    }
                }
                function a(e) {
                    var t = i[e.sectionId];
                    e.container.addEventListener("mediaVisible", function (i) {
                        t.element.setAttribute("data-shopify-model3d-id", e.modelId),
                            !theme.config.isTouch && i.detail.autoplayMedia && e.modelViewerUi.play();
                    }),
                        e.container.addEventListener("mediaHidden", function () {
                            t.element.setAttribute("data-shopify-model3d-id", t.defaultId), e.modelViewerUi.pause();
                        }),
                        e.container.addEventListener("xrLaunch", function () {
                            e.modelViewerUi.pause();
                        });
                }
                return {
                    init: function a(o, r) {
                        (e[r] = { loaded: !1 }),
                            o.forEach(function (e, n) {
                                var a = e.dataset.mediaId,
                                    o = e.querySelector("model-viewer"),
                                    c = o.dataset.modelId;
                                if (0 === n) {
                                    var l = e.closest(s.mediaGroup).querySelector(s.xrButton);
                                    i[r] = { element: l, defaultId: c };
                                }
                                t[a] = { modelId: c, sectionId: r, container: e, element: o };
                            }),
                            window.Shopify.loadFeatures([
                                {
                                    name: "shopify-xr",
                                    version: "1.0",
                                    onLoad: function t(i) {
                                        if (!i) {
                                            if (!window.ShopifyXR) {
                                                document.addEventListener("shopify_xr_initialized", function () {
                                                    t();
                                                });
                                                return;
                                            }
                                            for (var s in e)
                                                if (e.hasOwnProperty(s)) {
                                                    var n = e[s];
                                                    if (n.loaded) continue;
                                                    var a = document.querySelector("#ModelJson-" + s);
                                                    window.ShopifyXR.addModels(JSON.parse(a.innerHTML)),
                                                        (n.loaded = !0);
                                                }
                                            window.ShopifyXR.setupXRElements();
                                        }
                                    },
                                },
                                { name: "model-viewer-ui", version: "1.0", onLoad: n },
                            ]),
                            theme.LibraryLoader.load("modelViewerUiStyles");
                    },
                    removeSectionModels: function i(s) {
                        for (var n in t) t.hasOwnProperty(n) && t[n].sectionId === s && delete t[n];
                        delete e[s];
                    },
                };
            })()),
            (theme.QtySelector = (function () {
                var e = { input: ".js-qty__num", plus: ".js-qty__adjust--plus", minus: ".js-qty__adjust--minus" };
                function t(t, i) {
                    (this.wrapper = t),
                        (this.plus = t.querySelector(e.plus)),
                        (this.minus = t.querySelector(e.minus)),
                        (this.input = t.querySelector(e.input)),
                        (this.minValue = this.input.getAttribute("min") || 1);
                    var s = { namespace: null, isCart: !1, key: this.input.dataset.id };
                    (this.options = Object.assign({}, s, i)), this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.plus.addEventListener(
                                "click",
                                function () {
                                    var e = this._getQty();
                                    this._change(e + 1);
                                }.bind(this)
                            ),
                                this.minus.addEventListener(
                                    "click",
                                    function () {
                                        var e = this._getQty();
                                        this._change(e - 1);
                                    }.bind(this)
                                ),
                                this.input.addEventListener(
                                    "change",
                                    function (e) {
                                        this._change(this._getQty());
                                    }.bind(this)
                                );
                        },
                        _getQty: function () {
                            var e = this.input.value;
                            return (parseFloat(e) != parseInt(e) || isNaN(e)) && (e = 1), parseInt(e);
                        },
                        _change: function (e) {
                            e <= this.minValue && (e = this.minValue),
                                (this.input.value = e),
                                this.options.isCart &&
                                    document.dispatchEvent(
                                        new CustomEvent("cart:quantity" + this.options.namespace, {
                                            detail: [this.options.key, e, this.wrapper],
                                        })
                                    );
                        },
                    })),
                    t
                );
            })()),
            (theme.Slideshow = (function () {
                var e = { animateOut: "animate-out", isPaused: "is-paused", isActive: "is-active" },
                    t = {
                        allSlides: ".slideshow__slide",
                        currentSlide: ".is-selected",
                        wrapper: ".slideshow-wrapper",
                        pauseButton: ".slideshow__pause",
                    },
                    i = {
                        thumb: ".product__thumb-item:not(.hide)",
                        links: ".product__thumb-item:not(.hide) a",
                        arrow: ".product__thumb-arrow",
                    },
                    s = {
                        adaptiveHeight: !1,
                        autoPlay: !1,
                        avoidReflow: !1,
                        childNav: null,
                        childNavScroller: null,
                        childVertical: !1,
                        dragThreshold: 7,
                        fade: !1,
                        friction: 0.8,
                        initialIndex: 0,
                        pageDots: !1,
                        pauseAutoPlayOnHover: !1,
                        prevNextButtons: !0,
                        rightToLeft: theme.config.rtl,
                        selectedAttraction: 0.14,
                        setGallerySize: !0,
                        wrapAround: !0,
                    };
                function n(e, n) {
                    if (
                        ((this.el = e),
                        (this.args = Object.assign({}, s, n)),
                        (this.args.on = {
                            ready: this.init.bind(this),
                            change: this.slideChange.bind(this),
                            settle: this.afterChange.bind(this),
                        }),
                        this.args.childNav &&
                            ((this.childNavEls = this.args.childNav.querySelectorAll(i.thumb)),
                            (this.childNavLinks = this.args.childNav.querySelectorAll(i.links)),
                            (this.arrows = this.args.childNav.querySelectorAll(i.arrow)),
                            this.childNavLinks.length && this.initChildNav()),
                        this.args.avoidReflow &&
                            (function e(t) {
                                if (t.id) {
                                    for (var i = t.firstChild; null != i && 3 == i.nodeType; ) i = i.nextSibling;
                                    var s = document.createElement("style");
                                    (s.innerHTML = `#${t.id} .flickity-viewport{height:${i.offsetHeight}px}`),
                                        document.head.appendChild(s);
                                }
                            })(e),
                        (this.slideshow = new Flickity(e, this.args)),
                        e.dataset.zoom &&
                            "true" === e.dataset.zoom &&
                            (this.slideshow.on("dragStart", () => {
                                (this.slideshow.slider.style.pointerEvents = "none"),
                                    this.slideshow.options.fade &&
                                        (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents =
                                            "none");
                            }),
                            this.slideshow.on("dragEnd", () => {
                                (this.slideshow.slider.style.pointerEvents = "auto"),
                                    this.slideshow.options.fade &&
                                        (this.slideshow.slider.querySelector(".is-selected").style.pointerEvents =
                                            "auto");
                            })),
                        this.args.autoPlay)
                    ) {
                        var a = e.closest(t.wrapper);
                        (this.pauseBtn = a.querySelector(t.pauseButton)),
                            this.pauseBtn && this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
                    }
                    window.on(
                        "resize",
                        theme.utils.debounce(
                            300,
                            function () {
                                this.resize();
                            }.bind(this)
                        )
                    );
                }
                return (
                    (n.prototype = Object.assign({}, n.prototype, {
                        init: function (e) {
                            (this.currentSlide = this.el.querySelector(t.currentSlide)),
                                this.args.callbacks &&
                                    this.args.callbacks.onInit &&
                                    "function" == typeof this.args.callbacks.onInit &&
                                    this.args.callbacks.onInit(this.currentSlide),
                                window.AOS && AOS.refresh();
                        },
                        slideChange: function (t) {
                            this.args.fade &&
                                this.currentSlide &&
                                (this.currentSlide.classList.add(e.animateOut),
                                this.currentSlide.addEventListener(
                                    "transitionend",
                                    function () {
                                        this.currentSlide.classList.remove(e.animateOut);
                                    }.bind(this)
                                )),
                                this.args.childNav && this.childNavGoTo(t),
                                this.args.callbacks &&
                                    this.args.callbacks.onChange &&
                                    "function" == typeof this.args.callbacks.onChange &&
                                    this.args.callbacks.onChange(t),
                                this.arrows &&
                                    this.arrows.length &&
                                    (this.arrows[0].classList.toggle("hide", 0 === t),
                                    this.arrows[1].classList.toggle("hide", t === this.childNavLinks.length - 1));
                        },
                        afterChange: function (i) {
                            this.args.fade &&
                                this.el.querySelectorAll(t.allSlides).forEach((t) => {
                                    t.classList.remove(e.animateOut);
                                }),
                                (this.currentSlide = this.el.querySelector(t.currentSlide)),
                                this.args.childNav && this.childNavGoTo(this.slideshow.selectedIndex);
                        },
                        destroy: function () {
                            this.args.childNav &&
                                this.childNavLinks.length &&
                                this.childNavLinks.forEach((t) => {
                                    t.classList.remove(e.isActive);
                                }),
                                this.slideshow.destroy();
                        },
                        reposition: function () {
                            this.slideshow.reposition();
                        },
                        _togglePause: function () {
                            this.pauseBtn.classList.contains(e.isPaused)
                                ? (this.pauseBtn.classList.remove(e.isPaused), this.slideshow.playPlayer())
                                : (this.pauseBtn.classList.add(e.isPaused), this.slideshow.pausePlayer());
                        },
                        resize: function () {
                            this.slideshow.resize();
                        },
                        play: function () {
                            this.slideshow.playPlayer();
                        },
                        pause: function () {
                            this.slideshow.pausePlayer();
                        },
                        goToSlide: function (e) {
                            this.slideshow.select(e);
                        },
                        setDraggable: function (e) {
                            (this.slideshow.options.draggable = e), this.slideshow.updateDraggable();
                        },
                        initChildNav: function () {
                            this.childNavLinks[this.args.initialIndex].classList.add("is-active"),
                                this.childNavLinks.forEach((e, t) => {
                                    e.setAttribute("data-index", t),
                                        e.addEventListener(
                                            "click",
                                            function (e) {
                                                e.preventDefault(), this.goToSlide(this.getChildIndex(e.currentTarget));
                                            }.bind(this)
                                        ),
                                        e.addEventListener(
                                            "focus",
                                            function (e) {
                                                this.goToSlide(this.getChildIndex(e.currentTarget));
                                            }.bind(this)
                                        ),
                                        e.addEventListener(
                                            "keydown",
                                            function (e) {
                                                13 === e.keyCode && this.goToSlide(this.getChildIndex(e.currentTarget));
                                            }.bind(this)
                                        );
                                }),
                                this.arrows.length &&
                                    this.arrows.forEach((e) => {
                                        e.addEventListener("click", this.arrowClick.bind(this));
                                    });
                        },
                        getChildIndex: function (e) {
                            return parseInt(e.dataset.index);
                        },
                        childNavGoTo: function (t) {
                            this.childNavLinks.forEach((t) => {
                                t.blur(), t.classList.remove(e.isActive);
                            });
                            var i = this.childNavLinks[t];
                            if ((i.classList.add(e.isActive), this.args.childNavScroller)) {
                                if (this.args.childVertical) {
                                    var s = i.offsetTop;
                                    this.args.childNavScroller.scrollTop = s - 100;
                                } else {
                                    var n = i.offsetLeft;
                                    this.args.childNavScroller.scrollLeft = n - 100;
                                }
                            }
                        },
                        arrowClick: function (e) {
                            e.currentTarget.classList.contains("product__thumb-arrow--prev")
                                ? this.slideshow.previous()
                                : this.slideshow.next();
                        },
                    })),
                    n
                );
            })()),
            (theme.VariantAvailability = (function () {
                var e = { disabled: "disabled" };
                function t(e) {
                    (this.type = e.type),
                        (this.variantsObject = e.variantsObject),
                        (this.currentVariantObject = e.currentVariantObject),
                        (this.container = e.container),
                        (this.namespace = e.namespace),
                        this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.container.on("variantChange" + this.namespace, this.setAvailability.bind(this)),
                                this.setInitialAvailability();
                        },
                        createAvailableOptionsTree: (e, t) =>
                            e.reduce(
                                (e, i) => (
                                    Object.keys(e).forEach((s) => {
                                        if (null === i[s]) return;
                                        let n = e[s].find((e) => e.value === i[s]);
                                        void 0 === n && ((n = { value: i[s], soldOut: !0 }), e[s].push(n));
                                        let a = t.find(({ value: e, index: t }) => "option1" === t),
                                            o = t.find(({ value: e, index: t }) => "option2" === t);
                                        switch (s) {
                                            case "option1":
                                                n.soldOut = (!n.soldOut || !i.available) && n.soldOut;
                                                break;
                                            case "option2":
                                                a &&
                                                    i.option1 === a.value &&
                                                    (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                                            case "option3":
                                                a &&
                                                    i.option1 === a.value &&
                                                    o &&
                                                    i.option2 === o.value &&
                                                    (n.soldOut = (!n.soldOut || !i.available) && n.soldOut);
                                        }
                                    }),
                                    e
                                ),
                                { option1: [], option2: [], option3: [] }
                            ),
                        setInitialAvailability: function () {
                            this.container.querySelectorAll(".variant-input-wrap").forEach((e) => {
                                this.disableVariantGroup(e);
                            });
                            let e = this.currentVariantObject.options.map((e, t) => ({
                                    value: e,
                                    index: `option${t + 1}`,
                                })),
                                t = this.createAvailableOptionsTree(this.variantsObject, e, this.currentVariantObject);
                            for (var [i, s] of Object.entries(t)) this.manageOptionState(i, s);
                        },
                        setAvailability: function (e) {
                            let { value: t, index: i, currentlySelectedValues: s, variant: n } = e.detail,
                                a = this.createAvailableOptionsTree(this.variantsObject, s, n, i, t);
                            for (var [o, r] of Object.entries(a)) this.manageOptionState(o, r, t);
                        },
                        manageOptionState: function (e, t) {
                            var i = this.container.querySelector('.variant-input-wrap[data-index="' + e + '"]');
                            t.forEach((e) => {
                                this.enableVariantOption(i, e);
                            });
                        },
                        enableVariantOption: function (t, i) {
                            var s = i.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, "\\$1");
                            if ("dropdown" === this.type)
                                i.soldOut
                                    ? (t.querySelector('option[value="' + s + '"]').disabled = !0)
                                    : (t.querySelector('option[value="' + s + '"]').disabled = !1);
                            else {
                                var n = t.querySelector('.variant-input[data-value="' + s + '"]'),
                                    a = n.querySelector("input"),
                                    o = n.querySelector("label");
                                a.classList.remove(e.disabled),
                                    o.classList.remove(e.disabled),
                                    i.soldOut && (a.classList.add(e.disabled), o.classList.add(e.disabled));
                            }
                        },
                        disableVariantGroup: function (t) {
                            "dropdown" === this.type
                                ? t.querySelectorAll("option").forEach((e) => {
                                      e.disabled = !0;
                                  })
                                : (t.querySelectorAll("input").forEach((t) => {
                                      t.classList.add(e.disabled);
                                  }),
                                  t.querySelectorAll("label").forEach((t) => {
                                      t.classList.add(e.disabled);
                                  }));
                        },
                    })),
                    t
                );
            })()),
            (theme.videoModal = function () {
                var e,
                    t,
                    i = "VideoHolder",
                    s = {
                        youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
                        vimeo: 'a[href*="player.vimeo.com/player/"], a[href*="vimeo.com/"]',
                        mp4Trigger: ".product-video-trigger--mp4",
                        mp4Player: ".product-video-mp4-sound",
                    },
                    n = document.querySelectorAll(s.youtube),
                    a = document.querySelectorAll(s.vimeo),
                    o = document.querySelectorAll(s.mp4Trigger);
                if (n.length || a.length || o.length) {
                    var r = document.getElementById(i);
                    n.length && theme.LibraryLoader.load("youtubeSdk"),
                        a.length && theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
                    var c = new theme.Modals("VideoModal", "video-modal", {
                        closeOffContentClick: !0,
                        bodyOpenClass: ["modal-open", "video-modal-open"],
                        solid: !0,
                    });
                    n.forEach((e) => {
                        e.addEventListener("click", l);
                    }),
                        a.forEach((e) => {
                            e.addEventListener("click", d);
                        }),
                        o.forEach((e) => {
                            e.addEventListener("click", h);
                        }),
                        document.addEventListener("modalClose.VideoModal", function i() {
                            e && "function" == typeof e.destroy
                                ? e.destroy()
                                : t && "function" == typeof t.destroy
                                  ? t.destroy()
                                  : p();
                        });
                }
                function l(t) {
                    if (theme.config.youTubeReady) {
                        t.preventDefault(), p(), c.open(t);
                        var s,
                            n,
                            a =
                                ((s = t.currentTarget.getAttribute("href")),
                                (n = s.match(
                                    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/
                                )),
                                !!n && 11 == n[7].length && n[7]);
                        e = new theme.YouTube(i, { videoId: a, style: "sound", events: { onReady: u } });
                    }
                }
                function d(e) {
                    if (theme.config.vimeoReady) {
                        e.preventDefault(), p(), c.open(e);
                        var s = e.currentTarget.dataset.videoId,
                            n = e.currentTarget.dataset.videoLoop;
                        t = new theme.VimeoPlayer(i, s, { style: "sound", loop: n });
                    }
                }
                function h(e) {
                    p();
                    var t = e.currentTarget.parentNode.querySelector(s.mp4Player).cloneNode(!0);
                    t.classList.remove("hide"), r.append(t), c.open(e), r.querySelector("video").play();
                }
                function u(e) {
                    e.target.unMute(), e.target.playVideo();
                }
                function p() {
                    r.innerHTML = "";
                }
            });
        class c extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.inner = this.querySelector("[data-tool-tip-inner]")),
                    (this.closeButton = this.querySelector("[data-tool-tip-close]")),
                    (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
                    (this.toolTipTitle = this.querySelector("[data-tool-tip-title]")),
                    (this.triggers = document.querySelectorAll("[data-tool-tip-trigger]")),
                    document.addEventListener("tooltip:open", (e) => {
                        this._open(e.detail.context, e.detail.content);
                    });
            }
            _open(e, t) {
                (this.toolTipContent.innerHTML = t),
                    "store-availability" != e && this.toolTipTitle.remove(),
                    this._lockScrolling(),
                    this.closeButton &&
                        this.closeButton.on("click.tooltip-close", () => {
                            this._close();
                        }),
                    document.documentElement.on("click.tooltip-outerclick", (e) => {
                        "true" !== this.el.dataset.toolTipOpen || this.inner.contains(e.target) || this._close();
                    }),
                    document.documentElement.on("keydown.tooltip-esc", (e) => {
                        "Escape" === e.code && this._close();
                    }),
                    (this.el.dataset.toolTipOpen = !0),
                    (this.el.dataset.toolTip = e);
            }
            _close() {
                (this.toolTipContent.innerHTML = ""),
                    (this.el.dataset.toolTipOpen = "false"),
                    (this.el.dataset.toolTip = ""),
                    this._unlockScrolling(),
                    this.closeButton.off("click.tooltip-close"),
                    document.documentElement.off("click.tooltip-outerclick"),
                    document.documentElement.off("keydown.tooltip-esc");
            }
            _lockScrolling() {
                theme.a11y.trapFocus({ container: this.el, namespace: "tooltip_focus" }),
                    theme.a11y.lockMobileScrolling(),
                    document.documentElement.classList.add("modal-open");
            }
            _unlockScrolling() {
                theme.a11y.removeTrapFocus({ container: this.el, namespace: "tooltip_focus" }),
                    theme.a11y.unlockMobileScrolling(),
                    document.documentElement.classList.remove("modal-open");
            }
        }
        customElements.define("tool-tip", c);
        class l extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.toolTipContent = this.querySelector("[data-tool-tip-content]")),
                    this.init();
            }
            init() {
                let e = new CustomEvent("tooltip:open", {
                    detail: { context: this.dataset.toolTip, content: this.toolTipContent.innerHTML },
                    bubbles: !0,
                });
                this.el.addEventListener("click", (t) => {
                    t.stopPropagation(), this.dispatchEvent(e);
                });
            }
        }
        customElements.define("tool-tip-trigger", l);
        class d extends HTMLElement {
            constructor() {
                super(),
                    (this.closeBtn = this.querySelector("[data-close-button]")),
                    (this.popupTrigger = this.querySelector("[data-message]")),
                    (this.id = this.dataset.sectionId),
                    (this.newsletterId = `NewsletterPopup-${this.id}`),
                    (this.cookie = Cookies.get(`newsletter-${this.id}`)),
                    (this.cookieName = `newsletter-${this.id}`),
                    (this.secondsBeforeShow = this.dataset.delaySeconds),
                    (this.expiry = parseInt(this.dataset.delayDays)),
                    (this.modal = new theme.Modals(`NewsletterPopup-${this.newsletterId}`, "newsletter-popup-modal")),
                    this.init();
            }
            init() {
                document.addEventListener("shopify:block:select", (e) => {
                    e.detail.sectionId === this.id && this.show(0, !0);
                }),
                    document.addEventListener("shopify:block:deselect", (e) => {
                        e.detail.sectionId === this.id && this.hide();
                    }),
                    document.addEventListener(`modalOpen.${this.newsletterId}`, () => this.hide()),
                    document.addEventListener(`modalClose.${this.newsletterId}`, () => this.show()),
                    document.addEventListener("newsletter:openReminder", () => this.show(0)),
                    this.closeBtn.addEventListener("click", () => {
                        this.hide(), Cookies.set(this.cookieName, "opened", { path: "/", expires: this.expiry });
                    }),
                    this.popupTrigger.addEventListener("click", () => {
                        let e = new CustomEvent("reminder:openNewsletter", { bubbles: !0 });
                        this.dispatchEvent(e), this.hide();
                    });
            }
            show(e = this.secondsBeforeShow, t = !1) {
                let i = "true" === sessionStorage.getItem("reminderAppeared");
                i ||
                    setTimeout(() => {
                        (this.dataset.enabled = "true"), sessionStorage.setItem("reminderAppeared", !0);
                    }, 1e3 * e);
            }
            hide() {
                this.dataset.enabled = "false";
            }
        }
        customElements.define("newsletter-reminder", d);
        class h extends HTMLElement {
            constructor() {
                super(),
                    (this.parallaxImage = this.querySelector("[data-parallax-image]")),
                    (this.windowInnerHeight = window.innerHeight),
                    (this.isActive = !1),
                    (this.timeout = null),
                    (this.directionMap = { right: 0, top: 90, left: 180, bottom: 270 }),
                    (this.directionMultipliers = { 0: [1, 0], 90: [0, -1], 180: [-1, 0], 270: [0, 1] }),
                    this.init(),
                    window.addEventListener("scroll", () => this.scrollHandler());
            }
            getParallaxInfo() {
                let { width: e, height: t, top: i } = this.parallaxImage.getBoundingClientRect(),
                    s = this.parallaxImage,
                    n,
                    { angle: a, movement: o } = s.dataset,
                    r = "top" === a ? Math.ceil(t * (parseFloat(o) / 100)) : Math.ceil(e * (parseFloat(o) / 100));
                (a = this.directionMap[a] ?? parseFloat(a)) != a && (a = 270),
                    r != r && (r = 100),
                    (a %= 360) < 0 && (a += 360);
                let c = a > 90 && a < 270,
                    l = a < 180;
                if (((s.style[c ? "left" : "right"] = 0), (s.style[l ? "top" : "bottom"] = 0), a % 90)) {
                    let d = (a * Math.PI) / 180;
                    n = [Math.cos(d), -1 * Math.sin(d)];
                } else n = this.directionMultipliers[a];
                return (
                    n[0] && (s.style.width = `calc(100% + ${r * Math.abs(n[0])}px)`),
                    n[1] && (s.style.height = `calc(100% + ${r * Math.abs(n[1])}px)`),
                    { element: s, movementPixels: r, multipliers: n, top: i, height: t }
                );
            }
            init() {
                let { element: e, movementPixels: t, multipliers: i, top: s, height: n } = this.getParallaxInfo(),
                    a = this.windowInnerHeight - s,
                    o = this.windowInnerHeight + n,
                    r = a / o;
                if (r > -0.1 && r < 1.1) {
                    let c = Math.min(Math.max(r, 0), 1) * t;
                    e.style.transform = `translate3d(${c * i[0]}px, ${c * i[1]}px, 0)`;
                }
                this.isActive && requestAnimationFrame(this.init.bind(this));
            }
            scrollHandler() {
                this.isActive
                    ? clearTimeout(this.timeout)
                    : ((this.isActive = !0), requestAnimationFrame(this.init.bind(this))),
                    (this.timeout = setTimeout(() => (this.isActive = !1), 20));
            }
        }
        customElements.define("parallax-image", h);
        class u extends HTMLElement {
            constructor() {
                super(), this.init();
            }
            init() {
                let e = (e, t) => {
                    e[0].isIntersecting && (this.removeAnimations(), t.unobserve(this));
                };
                new IntersectionObserver(e.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
            }
            removeAnimations() {
                let e = this.closest(".image-wrap"),
                    t = this.closest(".skrim__link");
                e && e.classList.add("loaded"), t && t.classList.add("loaded");
            }
        }
        customElements.define("image-element", u);
        class p extends HTMLElement {
            constructor() {
                if (
                    (super(),
                    (this.enabled = this.getAttribute("data-enabled")),
                    (this.context = this.getAttribute("data-context")),
                    (this.input = this.querySelector('input[type="search"]')),
                    (this.predictiveSearchResults = this.querySelector("#predictive-search")),
                    (this.closeBtn = this.querySelector(".btn--close-search")),
                    (this.screen = this.querySelector("[data-screen]")),
                    (this.SearchModal = this.closest("#SearchModal") || null),
                    document.addEventListener("predictive-search:open", (e) => {
                        if (!e.detail || e.detail.context !== this.context) return;
                        this.classList.add("is-active");

                        // Show wrappers when modal opens
                        this.toggleSearchWrappers();
                        setTimeout(() => {
                            this.input.focus();
                        }, 100),

                        document.body.classList.add("predictive-overflow-hidden");
                    }),
                    this.SearchModal)
                ) {
                    let e = new MutationObserver((e) => {
                        e.forEach((e) => {
                            if ("class" === e.attributeName) {
                                let t = e.target.className;
															if (t.indexOf('modal--is-active') > -1) {
																// Show wrappers when modal opens
																this.toggleSearchWrappers();
																setTimeout(() => {
																	this.input.focus();
																}, 100);
															}
                            }
                        });
                    });
                    e.observe(this.SearchModal, { attributes: !0 });
                }
                if ("false" === this.enabled) return;
                this.input.addEventListener("keydown", () => {
                    this.classList.add("is-active");
                }),
                    this.input.addEventListener(
                        "input",
                        this.debounce((e) => {
                            this.onChange(e);
														this.toggleSearchWrappers();
                        }, 300).bind(this)
                    ),
										// Also handle immediate input for instant hide/show
										this.input.addEventListener("input", () => {
											this.toggleSearchWrappers();
										});
                    document.addEventListener("predictive-search:close", () => {
                        this.close();
                    }),
                    document.addEventListener("keydown", (e) => {
                        27 === e.keyCode && this.close();
                    }),
                    this.closeBtn.addEventListener("click", (e) => {
                        e.preventDefault(), this.close();
                    }),
                    this.screen.addEventListener("click", () => {
                        this.close();
                    });
            }
						toggleSearchWrappers() {
							const searchTerm = this.input.value.trim();
							const suggestedWrapper = this.SearchModal?.querySelector('.quick-search__suggested-wrapper');
							const promotionWrapper = this.SearchModal?.querySelector('.quick-search__promotion-wrapper');

							if (suggestedWrapper) {
								if (searchTerm.length > 0) {
									suggestedWrapper.style.display = 'none';
								} else {
									suggestedWrapper.style.display = '';
								}
							}

							if (promotionWrapper) {
								if (searchTerm.length > 0) {
									promotionWrapper.style.display = 'none';
								} else {
									promotionWrapper.style.display = '';
								}
							}
						}
            onChange() {
                let e = this.input.value.trim();

								if (!e.length) {
									this.close();
									return;
								}
                this.getSearchResults(e);
            }
            getSearchResults(e) {
                let t = this.paramUrl({
                    q: e,
                    "resources[limit]": 3,
                    "resources[limit_scope]": "each",
                    "resources[options][unavailable_products]": "last",
                });
                fetch(`${theme.routes.predictiveSearch}?${t}&section_id=search-results`)
                    .then((e) => {
                        if (!e.ok) {
                            let t = Error(e.status);
                            throw (this.close(), t);
                        }
                        return e.text();
                    })
                    .then((e) => {
                        let t = new DOMParser()
                            .parseFromString(e, "text/html")
                            .querySelector("#shopify-section-search-results").innerHTML;
                        (this.predictiveSearchResults.innerHTML = t), this.open(), AOS.refreshHard();
                    })
                    .catch((e) => {
                        throw (this.close(), e);
                    });
            }
            open() {
                this.predictiveSearchResults.style.display = "block";
            }
            close() {
                (this.predictiveSearchResults.style.display = "none"),
                    (this.predictiveSearchResults.innerHTML = ""),
                    this.classList.remove("is-active"),
                    document.body.classList.remove("predictive-overflow-hidden"),
                    document.dispatchEvent(new CustomEvent("predictive-search:close-all"));

										if (this.input) {
											this.input.value = "";
										}
										this.toggleSearchWrappers();
            }
            debounce(e, t) {
                let i;
                return (...s) => {
                    clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
                };
            }
            paramUrl(e) {
                return Object.keys(e)
                    .map(function (t) {
                        return t + "=" + encodeURIComponent(e[t]);
                    })
                    .join("&");
            }
        }
        customElements.define("predictive-search", p);
        class f extends HTMLElement {
            constructor() {
                super(),
                    (this.checkboxInput = this.querySelector(`#Recipient-Checkbox-${this.dataset.sectionId}`)),
                    (this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`)),
                    (this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`)),
                    (this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`)),
                    this.addEventListener("change", () => this.onChange()),
                    (this.recipientFields = this.querySelector(".recipient-fields")),
                    this.checkboxInput.addEventListener("change", () => {
                        this.recipientFields.style.display = this.checkboxInput.checked ? "block" : "none";
                    });
            }
            connectedCallback() {
                document.addEventListener("ajaxProduct:error", (e) => {
                    let t = e.target.querySelector('[name="id"]').value;
                    t === this.dataset.productVariantId && this.displayErrorMessage(e.detail.errorMessage);
                }),
                    document.addEventListener("ajaxProduct:added", (e) => {
                        let t = e.target.querySelector('[name="id"]').value;
                        t === this.dataset.productVariantId && (this.clearInputFields(), this.clearErrorMessage());
                    });
            }
            onChange() {
                this.checkboxInput.checked || (this.clearInputFields(), this.clearErrorMessage());
            }
            clearInputFields() {
                this.querySelectorAll(".field__input").forEach((e) => (e.value = ""));
            }
            displayErrorMessage(e) {
                if ((this.clearErrorMessage(), e))
                    return Object.entries(e).forEach(([e, t]) => {
                        let i = this[`${e}Input`];
                        i && (i.setAttribute("aria-invalid", !0), i.classList.add("field__input--error"));
                    });
            }
            clearErrorMessage() {
                this.querySelectorAll(".field__input").forEach((e) => {
                    e.setAttribute("aria-invalid", !1),
                        e.removeAttribute("aria-describedby"),
                        e.classList.remove("field__input--error");
                });
            }
        }
        customElements.define("recipient-form", f),
            (theme.ProductScreen = (function () {
                var e = document.title,
                    t = "productscreen",
                    i = 0;
                document.getElementById("MainContent");
                var s = {
                    close: ".js-screen-close",
                    openClass: "screen-layer--is-active",
                    closeSlideAnimate: ["screen-layer--is-sliding"],
                    bodyOpenClass: "screen-layer-open",
                    bodyClosingClass: ["screen-layer-closing"],
                    bodyCloseAnimate: ["screen-layer-closing", "screen-layer-animating"],
                    loaderStart: 200,
                    pullToCloseThreshold: -100,
                };
                function n(e, t) {
                    (this.id = e),
                        (this.screen = document.getElementById(e)),
                        this.screen &&
                            ((this.nodes = {
                                loader: document.getElementById("OverscrollLoader").querySelector(".icon-loader__path"),
                                screenContent: this.screen.querySelector(".screen-layer__inner"),
                                photoswipe: document.querySelector(".pswp"),
                            }),
                            (this.title = this.screen.dataset.productTitle),
                            (this.openBtnClass = ".js-screen-open-" + t),
                            (this.initialized = !1),
                            (this.isOpen = !1),
                            (this.focusOnOpen = s.focusOnOpen ? this.screen.querySelector(s.focusOnOpen) : this.screen),
                            this.init());
                }
                return (
                    (n.prototype = Object.assign({}, n.prototype, {
                        init: function () {
                            document.querySelectorAll(this.openBtnClass).forEach((e) => {
                                e.setAttribute("aria-expanded", "false"),
                                    e.addEventListener("click", this.open.bind(this));
                            }),
                                this.screen.querySelectorAll(s.close).forEach((e) => {
                                    e.on(
                                        "click." + t,
                                        function (e) {
                                            this.close(!1, { noAnimate: !0, back: !0 });
                                        }.bind(this)
                                    );
                                }),
                                "sticky" === theme.settings.cartType &&
                                    (document.addEventListener(
                                        "ajaxProduct:added:" + this.id,
                                        function () {
                                            theme.headerNav.toggleThumbMenu(!1, !0), this.close(!1, { back: !0 });
                                        }.bind(this)
                                    ),
                                    document.addEventListener(
                                        "ajaxProduct:error:" + this.id,
                                        function () {
                                            this.initialized && this.open();
                                        }.bind(this)
                                    ));
                        },
                        open: function (e, n) {
                            this.screen = document.getElementById(this.id);
                            var a = !1,
                                o = { updateCurrentPath: !n || n.updateCurrentPath };
                            if (!this.isOpen) {
                                e ? e.preventDefault() : (a = !0),
                                    e &&
                                        e.stopPropagation &&
                                        (e.stopPropagation(), (this.activeSource = e.currentTarget)),
                                    this.isOpen && !a && this.close(),
                                    (i = window.scrollY),
                                    theme.utils.prepareTransition(
                                        this.screen,
                                        function () {
                                            this.screen.classList.add(s.openClass);
                                        }.bind(this)
                                    ),
                                    document.documentElement.classList.add(s.bodyOpenClass),
                                    document.body.classList.add(s.bodyOpenClass),
                                    this.nodes.screenContent.scrollTo(0, 0),
                                    window.scrollTo(0, 0),
                                    theme.a11y.trapFocus({
                                        container: this.screen,
                                        elementToFocus: this.focusOnOpen,
                                        namespace: t,
                                    }),
                                    this.activeSource &&
                                        this.activeSource.hasAttribute("aria-expanded") &&
                                        this.activeSource.setAttribute("aria-expanded", "true");
                                var r = this.activeSource.dataset.url;
                                document.dispatchEvent(new CustomEvent("productModalOpen." + this.id)),
                                    document.dispatchEvent(
                                        new CustomEvent("newPopstate", {
                                            detail: { screen: this, url: r, updateCurrentPath: o.updateCurrentPath },
                                        })
                                    ),
                                    (this.initialized = !0),
                                    (this.isOpen = !0),
                                    (document.title = this.title),
                                    window.ga && ga("send", "pageview", { page: r }),
                                    this.bindEvents();
                            }
                        },
                        close: function (n, a) {
                            var o = a || (n ? n.data : null),
                                r = !!o && o.back,
                                c = !!o && !!o.noAnimate;
                            document.body.removeAttribute("style"),
                                (this.nodes.loader.style.strokeDashoffset = s.loaderStart),
                                r &&
                                    document.dispatchEvent(
                                        new CustomEvent("newPopstate", { detail: { screen: this, back: !0 } })
                                    );
                            var l = c ? [] : s.closeSlideAnimate,
                                d = c ? s.bodyClosingClass : s.bodyCloseAnimate;
                            this.isOpen &&
                                (document.activeElement.blur(),
                                theme.utils.prepareTransition(
                                    this.screen,
                                    function () {
                                        this.screen.classList.remove(s.openClass),
                                            this.screen.classList.add(...l),
                                            this.screen.classList.remove("is-transitioning");
                                    }.bind(this)
                                ),
                                document.documentElement.classList.remove(s.bodyOpenClass),
                                document.body.classList.remove(s.bodyOpenClass),
                                document.documentElement.classList.add(...d),
                                document.body.classList.add(...d),
                                window.setTimeout(
                                    function () {
                                        this.screen.classList.remove(...l),
                                            document.documentElement.classList.remove(...d),
                                            document.body.classList.remove(...d),
                                            window.scrollTo(0, i);
                                    }.bind(this),
                                    500
                                ),
                                theme.a11y.removeTrapFocus({ container: this.screen, namespace: t }),
                                this.activeSource &&
                                    this.activeSource.hasAttribute("aria-expanded") &&
                                    (this.activeSource.setAttribute("aria-expanded", "false"),
                                    this.activeSource.focus()),
                                document.dispatchEvent(new CustomEvent("productModalClose")),
                                document.dispatchEvent(new CustomEvent("productModalClose." + this.id)),
                                window.scrollTo(0, i),
                                (this.isOpen = !1),
                                (document.title = e),
                                window.ga && ga("send", "pageview"),
                                this.unbindEvents());
                        },
                        bindEvents: function () {
                            window.on(
                                "keyup." + t,
                                function (e) {
                                    27 === e.keyCode &&
                                        !(
                                            this.nodes.photoswipe.classList.contains("pswp--open") ||
                                            document.body.classList.contains("js-drawer-open")
                                        ) &&
                                        this.close(!1, { back: !0 });
                                }.bind(this)
                            );
                            var e = 0,
                                i = 0;
                            window.on(
                                "touchmove." + t,
                                theme.utils.throttle(
                                    15,
                                    function () {
                                        var t = window.scrollY;
                                        !(t >= 0) &&
                                            ((e = -(t / 100)),
                                            (document.body.style.background = "rgba(0,0,0," + e + ")"),
                                            (i = s.loaderStart + 2 * t),
                                            t <= s.pullToCloseThreshold && (i = 0),
                                            (this.nodes.loader.style.strokeDashoffset = i));
                                    }.bind(this)
                                )
                            ),
                                window.on(
                                    "touchend." + t,
                                    function () {
                                        window.scrollY < s.pullToCloseThreshold && this.close(!1, { back: !0 });
                                    }.bind(this)
                                );
                        },
                        unbindEvents: function () {
                            window.off("keyup." + t), window.off("touchmove." + t), window.off("touchend." + t);
                        },
                    })),
                    n
                );
            })()),
            (theme.QuickShopScreens = (function () {
                var e = window.location.pathname + window.location.search,
                    t = e,
                    i = null,
                    s = null;
                "scrollRestoration" in history && (history.scrollRestoration = "manual");
                var n = {
                        screensWrap: "#ProductScreens",
                        screens: "[data-product-id]",
                        trigger: ".quick-product__btn",
                    },
                    a = [];
                function o(e) {
                    e.close(), (s = null), window.dispatchEvent(new Event("resize"));
                }
                function r(e) {
                    var t = [];
                    return (
                        (e ? e.querySelectorAll(n.trigger) : document.querySelectorAll(n.trigger)).forEach((e) => {
                            var i = e.dataset.productId;
                            if (t.indexOf(i) > -1) {
                                var s = document.querySelector('.screen-layer--product[data-product-id="' + i + '"]');
                                s && s.parentNode.removeChild(s);
                                return;
                            }
                            t.push(i);
                        }),
                        t
                    );
                }
                function c(e) {
                    for (var t, i, s = document.createDocumentFragment(), o = 0; o < e.length; o++)
                        if (
                            -1 === a.indexOf(e[o]) &&
                            ((t = "ProductScreen-" + e[o]), (i = document.getElementById(t)))
                        ) {
                            s.appendChild(i), a.push(e[o]);
                            var r = document.querySelectorAll(`#${t}`)[0];
                            r &&
                                r.parentNode.classList.contains("hotspot-content__block") &&
                                r.parentNode.removeChild(r);
                        }
                    document.querySelector(n.screensWrap).appendChild(s);
                    for (var o = 0; o < a.length; o++)
                        (t = "ProductScreen-" + a[o]), new theme.ProductScreen(t, "product-" + a[o]);
                }
                return {
                    init: function n(a) {
                        theme.settings.quickView &&
                            (c(r()),
                            (function n() {
                                !Shopify.designMode &&
                                    (document.addEventListener("newPopstate", function (n) {
                                        if (n.detail) {
                                            var a = n.detail;
                                            (s = a.screen),
                                                a.back &&
                                                    ((i = location.pathname), (t = e), history.pushState({}, "", e)),
                                                a.url &&
                                                    a.updateCurrentPath &&
                                                    ((i = location.pathname),
                                                    (t = a.url),
                                                    history.pushState({}, "", a.url));
                                        }
                                    }),
                                    window.addEventListener(
                                        "popstate",
                                        function (n) {
                                            var a = !1;
                                            if (((i = t), location.pathname !== t)) {
                                                if (((i = t), (t = location.pathname), location.pathname === e)) {
                                                    s && s.isOpen && o(s);
                                                    return;
                                                }
                                                if (-1 !== location.pathname.indexOf("/products/")) {
                                                    s
                                                        ? s.open()
                                                        : document
                                                              .querySelector(
                                                                  '.quick-product__btn[href="' +
                                                                      location.pathname +
                                                                      '"]'
                                                              )
                                                              .dispatchEvent(new Event("click"), {
                                                                  updateCurrentPath: !1,
                                                              });
                                                    return;
                                                }
                                                if (n.originalEvent && n.originalEvent.state) {
                                                    if (s && s.isOpen) {
                                                        o(s), history.replaceState({}, "", e);
                                                        return;
                                                    }
                                                    a = !0;
                                                } else if (s) {
                                                    if (s.isOpen) {
                                                        o(s);
                                                        return;
                                                    }
                                                } else a = !0;
                                                a && (window.location.href = location.href);
                                            }
                                        }.bind(this)
                                    ));
                            })());
                    },
                    unload: function e(t) {
                        if (theme.settings.quickView) {
                            for (
                                var i,
                                    s,
                                    a = [],
                                    o = r(t),
                                    c =
                                        ((i = document.querySelectorAll(n.trigger)),
                                        (s = []),
                                        i.forEach((e) => {
                                            var t = e.dataset.productId;
                                            s.push(t);
                                        }),
                                        s),
                                    l = 0;
                                l < o.length;
                                l++
                            ) {
                                var d = o[l];
                                -1 === c.indexOf(d) && a.push(d);
                            }
                            for (var l = 0; l < a.length; l++) sections._removeInstance(a[l]);
                        }
                    },
                    reInit: function e(t) {
                        if (theme.settings.quickView) {
                            var i = r(t);
                            (function e(t, i) {
                                for (var s = 0; s < t.length; s++) {
                                    var n = i.querySelector('.screen-layer--product[data-product-id="' + t[s] + '"]');
                                    n && n.parentNode.removeChild(n);
                                }
                            })(i, t),
                                c(i);
                            var s = document.getElementById("ProductScreens");
                            theme.sections.register("product-template", theme.Product, s);
                        }
                    },
                };
            })()),
            (theme.HoverProductGrid = (function () {
                var e = { product: ".grid-product", slider: ".product-slider" };
                function t(t) {
                    if (
                        ((this.container = t),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.namespace = ".product-image-slider-" + this.sectionId),
                        (this.activeIds = []),
                        (this.allSliders = {}),
                        theme.settings.hoverProductGrid)
                    )
                        (this.products = t.querySelectorAll(e.product)),
                            (this.slidersMobile = "true" === t.dataset.productSlidersMobile),
                            0 !== this.products.length && this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.destroyAllSliders(), this.setupEventType(), this.listnerSetup();
                        },
                        setupEventType: function () {
                            this.products.forEach((e) => {
                                e.off("mouseenter" + this.namespace), e.off("mouseout" + this.namespace);
                            }),
                                window.off("scroll" + this.namespace),
                                theme.config.bpSmall
                                    ? this.slidersMobile && this.inViewSliderInit()
                                    : this.mouseSliderInit();
                        },
                        listnerSetup: function () {
                            document.addEventListener(
                                "matchSmall",
                                function () {
                                    this.destroyAllSliders(), this.setupEventType();
                                }.bind(this)
                            ),
                                document.addEventListener(
                                    "unmatchSmall",
                                    function () {
                                        this.destroyAllSliders(), this.setupEventType();
                                    }.bind(this)
                                );
                        },
                        inViewSliderInit: function () {
                            this.products.forEach((t) => {
                                new IntersectionObserver(
                                    (i, s) => {
                                        i.forEach((i) => {
                                            var s = t.querySelector(e.slider);
                                            theme.config.bpSmall &&
                                                (i.isIntersecting ? this.initSlider(s) : this.destroySlider(s));
                                        });
                                    },
                                    { threshold: 1 }
                                ).observe(t);
                            });
                        },
                        mouseSliderInit: function () {
                            this.products.forEach((t) => {
                                var i = t.querySelector(e.slider);
                                t.on(
                                    "mouseenter" + this.namespace,
                                    function () {
                                        this.initSlider(i);
                                    }.bind(this)
                                ),
                                    t.on(
                                        "mouseleave" + this.namespace,
                                        function (e) {
                                            this.destroySlider(i);
                                        }.bind(this)
                                    );
                            });
                        },
                        initSlider: function (e) {
                            e.dataset &&
                                !(e.dataset.imageCount < 2) &&
                                -1 === this.activeIds.indexOf(e.dataset.id) &&
                                (e.classList.add("product-slider--init"),
                                (this.allSliders[e.dataset.id] = new theme.Slideshow(e, {
                                    autoPlay: 1050,
                                    fade: !0,
                                    avoidReflow: !0,
                                })),
                                this.activeIds.push(e.dataset.id));
                        },
                        destroySlider: function (e) {
                            if (e.dataset && !(e.dataset.imageCount < 2)) {
                                var t = this.activeIds.indexOf(e.dataset.id);
                                if (-1 !== t) {
                                    this.activeIds.splice(t, 1);
                                    var i = this.allSliders[e.dataset.id];
                                    i && "function" == typeof i.destroy && i.destroy();
                                }
                            }
                        },
                        destroyAllSliders: function () {
                            this.products.forEach((t) => {
                                var i = t.querySelector(e.slider);
                                this.destroySlider(i);
                            });
                        },
                    })),
                    t
                );
            })()),
            (theme.slideNav = (function () {
                var e,
                    t,
                    i,
                    s,
                    n,
                    a,
                    o,
                    r = {
                        container: "#PageContainer",
                        navWrapper: ".slide-nav__overflow",
                        nav: "#SlideNav",
                        toggleBtn: ".js-toggle-slide-nav",
                        subNavToggleBtn: ".js-toggle-submenu",
                        thumbNavToggle: ".site-nav__thumb-button",
                    },
                    c = {
                        subNavLink: "slide-nav__sublist-link",
                        return: "slide-nav__return-btn",
                        isActive: "is-active",
                        isOpen: "js-menu--is-open",
                        subNavShowing: "sub-nav--is-open",
                        thirdNavShowing: "third-nav--is-open",
                    },
                    l = ".slideNav",
                    d = !0,
                    h = 1,
                    u = null;
                function p(e) {
                    (u = e.currentTarget).classList.contains(c.isActive)
                        ? f()
                        : (function e(t) {
                              if (
                                  (a.forEach((e) => {
                                      e.classList.add(c.isActive);
                                  }),
                                  theme.utils.prepareTransition(n, function () {
                                      n.classList.add(c.isOpen);
                                  }),
                                  d)
                              ) {
                                  var i = document.querySelector(r.navWrapper).clientHeight;
                                  s.style.transform = "translate3d(0, " + i + "px, 0)";
                              }
                              n.setAttribute("tabindex", "-1"),
                                  n.focus(),
                                  window.on("keyup" + l, function (e) {
                                      27 === e.keyCode && f();
                                  });
                          })();
                }
                function f() {
                    a.forEach((e) => {
                        e.classList.remove(c.isActive);
                    }),
                        theme.utils.prepareTransition(n, function () {
                            n.classList.remove(c.isOpen);
                        }),
                        d && s.removeAttribute("style"),
                        u.focus(),
                        (u = null),
                        window.off("keyup" + l);
                }
                function m(a) {
                    if (!e) {
                        var o,
                            l,
                            u,
                            p,
                            f,
                            m = a.currentTarget;
                        if (((e = !0), m.classList.contains(c.return)))
                            document
                                .querySelectorAll(r.subNavToggleBtn + '[data-level="' + (h - 1) + '"]')
                                .forEach((e) => {
                                    e.classList.remove(c.isActive);
                                }),
                                document
                                    .querySelectorAll('.slide-nav__dropdown[data-level="' + h + '"]')
                                    .forEach((e) => {
                                        theme.utils.prepareTransition(e, function () {
                                            e.classList.remove(c.isActive);
                                        });
                                    }),
                                i && i.classList.remove(c.isActive);
                        else {
                            m.classList.add(c.isActive);
                            var v = m.nextElementSibling;
                            theme.utils.prepareTransition(v, function () {
                                v.classList.add(c.isActive);
                            });
                        }
                        (i = m),
                            (h = (l = (o = m.dataset.target)
                                ? document.querySelector('.slide-nav__dropdown[data-parent="' + o + '"]')
                                : document.querySelector(r.nav)).dataset.level
                                ? parseInt(l.dataset.level)
                                : 1),
                            (t = l),
                            (u = l.clientHeight),
                            (p = h > 2 ? c.thirdNavShowing : c.subNavShowing),
                            (n.style.height = u + "px"),
                            n.classList.remove(c.thirdNavShowing),
                            n.classList.add(p),
                            o || (n.classList.remove(c.thirdNavShowing), n.classList.remove(c.subNavShowing)),
                            (e = !1),
                            d && (s.style.transform = "translate3d(0, " + u + "px, 0)");
                    }
                }
                return {
                    init: function e() {
                        document.querySelector(r.thumbNavToggle) && (d = !1),
                            (s = document.querySelector(r.container)),
                            (n = document.querySelector(r.navWrapper)),
                            (a = document.querySelectorAll(r.toggleBtn)),
                            (o = document.querySelectorAll(r.subNavToggleBtn)),
                            a.forEach((e) => {
                                e.on("click" + l, p);
                            }),
                            o.forEach((e) => {
                                e.on("click" + l, m);
                            });
                    },
                    unload: function e() {
                        window.off(l);
                    },
                };
            })()),
            (window.onpageshow = function (e) {
                e.persisted &&
                    (document.body.classList.remove("unloading"),
                    document.querySelectorAll(".cart__checkout").forEach((e) => {
                        e.classList.remove("btn--loading");
                    }),
                    document.querySelectorAll("#StickySubmit").forEach((e) => {
                        e.classList.remove("btn--loading");
                    })),
                    (event.persisted ||
                        (void 0 !== window.performance &&
                            window.performance.navigation &&
                            2 === window.performance.navigation.type)) &&
                        theme.resetScrollPosition();
            }),
            (theme.resetScrollPosition = function () {
                if (theme.config.hasSessionStorage) {
                    var e = document.location.pathname;
                    sessionStorage["scrollPosition_" + e] &&
                        window.scrollTo(0, sessionStorage.getItem("scrollPosition_" + e));
                }
            }),
            (theme.storeScrollPositionOnUnload = function () {
                if (theme.config.hasSessionStorage) {
                    var e = theme.config.isSafari ? "pagehide" : "beforeunload";
                    window.addEventListener(e, function (e) {
                        var t = window.scrollY;
                        sessionStorage.setItem("scrollPosition_" + document.location.pathname, t.toString());
                    });
                }
            }),
            (theme.pageTransitions = function () {
                "true" === document.body.dataset.transitions &&
                    (theme.config.isSafari &&
                        document.querySelectorAll("a").forEach((e) => {
                            window.setTimeout(function () {
                                document.body.classList.remove("unloading");
                            }, 1200);
                        }),
                    document
                        .querySelectorAll(
                            'a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"], a[href*="player.vimeo.com/video/"], a[href*="vimeo.com/"], a[download]'
                        )
                        .forEach((e) => {
                            e.classList.add("js-no-transition");
                        }),
                    document.querySelectorAll("a:not(.js-no-transition)").forEach((e) => {
                        e.addEventListener("click", function (t) {
                            if (t.metaKey) return !0;
                            var i = e.getAttribute("href");
                            if (i.indexOf(location.pathname) >= 0 && i.indexOf("#") >= 0) return !0;
                            t.preventDefault(),
                                document.body.classList.add("unloading"),
                                window.setTimeout(function () {
                                    location.href = i;
                                }, 50);
                        });
                    }));
            }),
            (theme.headerNav = (function () {
                var e,
                    t,
                    i = {
                        wrapper: ".header-wrapper",
                        siteHeader: ".site-header",
                        logo: ".site-header__logo img",
                        navItems: ".site-nav__item",
                        navLinks: ".site-nav__link",
                        navLinksWithDropdown: ".site-nav__link--has-dropdown",
                        navDropdownLinks: ".site-nav__dropdown-link--second-level",
                        thumbMenu: ".site-nav__thumb-menu",
                        navDetails: ".site-nav__details",
                        navDropdown: ".site-nav__dropdown",
                    },
                    s = {
                        hasDropdownClass: "site-nav--has-dropdown",
                        hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
                        dropdownActive: "is-focused",
                        stickyCartActive: "body--sticky-cart-open",
                        overlayEnabledClass: "header-wrapper--overlay",
                        overlayedClass: "is-light",
                        thumbMenuInactive: "site-nav__thumb-menu--inactive",
                        stickyClass: "site-header--sticky",
                        overlayStickyClass: "header-wrapper--sticky",
                        openTransitionClass: "site-header--opening",
                        menuHoveredClass: "menu-hovered",
                    },
                    n = {
                        namespace: ".siteNav",
                        overlayHeader: !1,
                        stickyActive: !1,
                        forceStickyOnMobile: !1,
                        forceCloseThumbNav: !1,
                    };
                function a() {
                    var e;
                    "bar" === n.headerStyle &&
                        ((e = document.createElement("div")),
                        e.classList.add("site-header-sticky"),
                        theme.utils.wrap(t, e),
                        !theme.settings.overlayHeader &&
                            (c(),
                                setTimeout(function () {
                                    c(),
                                        0 === document.querySelector(".site-header-sticky").offsetHeight &&
                                            setTimeout(function () {
                                                window.dispatchEvent(new Event("resize"));
                                            }, 500);
                                }, 200)));
                }
                function o() {
                    r(), "bar" === n.headerStyle && c();
                }
                function r() {
                    const o =
                        theme.config.bpSmall ||
                        (window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
                    n.headerStyle = o ? "button" : e.dataset.headerStyle;
                    n.stickyThreshold = "button" === n.headerStyle ? 100 : 250;
                    "button" !== n.headerStyle && d(!1),
                        theme.settings.overlayHeader &&
                            (function e(t) {
                                let s = [...document.querySelectorAll(".shopify-section-group-header-group")],
                                    n = s[0],
                                    a = s[1];
                                if (
                                    (1 === s.length &&
                                        n.querySelector(i.wrapper) &&
                                        (document.querySelector(i.wrapper).style.top = 0),
                                    n && a && n.querySelector(i.wrapper) && a.querySelector(".announcement"))
                                ) {
                                    let o = t.closest(".shopify-section-group-header-group"),
                                        r = o.nextElementSibling;
                                    if (r && r.classList.contains("shopify-section-group-header-group")) {
                                        let c = r.offsetHeight;
                                        document.querySelector(i.wrapper).style.top = c + "px";
                                    }
                                }
                            })(t);
                }
                function isDropdownOnTop(el) {
                    if (!el) return !1;

                    var cs = window.getComputedStyle(el);
                    var z = cs.zIndex;
                    var zi = parseInt(z, 10);

                    return !isNaN(zi) && zi === 6;
                }

                function watchDropdownZIndex() {
                    var rafId = 0;
                    var removeTimer = 0;
                    var REMOVE_DELAY = 150; // tweak to taste

                    function addHovered() {
                      if (!e) return;

                      if (removeTimer) {
                        window.clearTimeout(removeTimer);
                        removeTimer = 0;
                      }

                      if (!e.classList.contains(s.menuHoveredClass)) {
                        e.classList.add(s.menuHoveredClass);
                      }
                    }

                    function scheduleRemoveHovered() {
                      if (!e) return;
                      if (!e.classList.contains(s.menuHoveredClass)) return;
                      if (removeTimer) return;

                      removeTimer = window.setTimeout(function () {
                        removeTimer = 0;

                        if (e && e.classList.contains(s.menuHoveredClass)) {
                          e.classList.remove(s.menuHoveredClass);
                        }
                      }, REMOVE_DELAY);
                    }

                    function tick() {
                      if (e) {
                        var anyOnTop = !1;
                        var dropdowns = document.querySelectorAll(i.navDropdown);

                        dropdowns.forEach(function (dd) {
                          if (!anyOnTop && isDropdownOnTop(dd)) {
                            anyOnTop = !0;
                          }
                        });

                        if (anyOnTop) {
                          addHovered();
                        } else {
                          scheduleRemoveHovered();
                        }
                      }

                      rafId = window.requestAnimationFrame(tick);
                    }

                    rafId = window.requestAnimationFrame(tick);

                    return function () {
                      if (rafId) window.cancelAnimationFrame(rafId);
                      if (removeTimer) window.clearTimeout(removeTimer);
                    };
                }
                function c() {
                    var e = document.querySelector(".site-header-sticky");
                    if (e) {
                        var i = t.offsetHeight;
                        e.style.height = i + "px";
                    }
                }
                function l(e) {
                    if (window.scrollY > n.stickyThreshold)
                        n.forceStickyOnMobile && (n.forceStickyOnMobile = !1),
                            !n.stickyActive && ("button" === n.headerStyle ? d(!0) : "bar" === n.headerStyle && h(!0));
                    else {
                        if (n.forceStickyOnMobile || !n.stickyActive) return;
                        "button" === n.headerStyle ? d(!1) : "bar" === n.headerStyle && h(!1),
                            theme.settings.overlayHeader || c();
                    }
                }
                function d(e, t) {
                    if (
                        n.forceCloseThumbNav ||
                        document.querySelector(".slide-nav__overflow--thumb").classList.contains("js-menu--is-open")
                    )
                        return;
                    let a = document.querySelector(i.thumbMenu);
                    a && a.classList.toggle(s.thumbMenuInactive, !e),
                        document.body.classList.toggle("sticky-nav--is-open", e),
                        (n.stickyActive = e),
                        (n.forceCloseThumbNav = t);
                    if ("button" === n.headerStyle) {
                        const o = document.querySelector(i.siteHeader),
                            r = document.querySelector(i.wrapper);
                        if (o) {
                            o.classList.toggle(s.stickyClass, e),
                                e
                                    ? setTimeout(function () {
                                          o.classList.add(s.openTransitionClass);
                                      }, 100)
                                    : o.classList.remove(s.openTransitionClass);
                        }
                        theme.settings.overlayHeader &&
                            r &&
                            (r.classList.toggle(s.overlayStickyClass, e), r.classList.toggle(s.overlayedClass, !e));
                    }
                }
                function h(i) {
                    "bar" === n.headerStyle &&
                        (i
                            ? (t.classList.add(s.stickyClass),
                              theme.settings.overlayHeader &&
                                  (e.classList.remove(s.overlayedClass), e.classList.add(s.overlayStickyClass)),
                              setTimeout(function () {
                                  t.classList.add(s.openTransitionClass);
                              }, 100))
                            : (t.classList.remove(s.openTransitionClass),
                              t.classList.remove(s.stickyClass),
                              theme.settings.overlayHeader &&
                                  (e.classList.add(s.overlayedClass), e.classList.remove(s.overlayStickyClass))),
                        (n.stickyActive = i));
                }
                return {
                    init: function s() {
                        (e = document.querySelector(i.wrapper)),
                            (t = document.querySelector(i.siteHeader)),
                            (theme.settings.overlayHeader = "true" === t.dataset.overlay),
                            (n.stickyActive = !1),
                            new theme.Modals("SearchModal", "search-modal", {
                                closeOffContentClick: !1,
                                focusIdOnOpen: "SearchModalInput",
                            }),
                            window.on("resize" + n.namespace, theme.utils.debounce(150, o)),
                            window.on("load" + n.namespace, a),
                            r(),
                            window.on("scroll" + n.namespace, theme.utils.throttle(150, l)),
                            window.on("scroll" + n.namespace, theme.utils.debounce(150, l)),
                            Shopify.designMode && window.dispatchEvent(new Event("resize")),
                            (function e() {
                                let t = document.querySelectorAll(i.navDetails);
                                t.forEach((e) => {
                                    let t = e.querySelector("summary");
                                    document.addEventListener("click", (i) => {
                                        e.hasAttribute("open") && !e.contains(i.target)
                                            ? (e.removeAttribute("open"), t.setAttribute("aria-expanded", "false"))
                                            : e.hasAttribute("open")
                                              ? t.setAttribute("aria-expanded", "false")
                                              : t.setAttribute("aria-expanded", "true");
                                    });
                                });
                            })();
                            n._stopDropdownWatch = watchDropdownZIndex();
                    },
                    disableOverlayHeader: function t() {
                        e.classList.remove(n.overlayEnabledClass),
                            e.classList.remove(n.overlayedClass),
                            (theme.settings.overlayHeader = !1);
                    },
                    toggleThumbMenu: d,
                    unload: function e() {
                        if (n._stopDropdownWatch) n._stopDropdownWatch();
                        window.off(n.namespace);
                    },
                };
            })()),
            (theme.articleImages = function () {
                var e = document.querySelectorAll(".rte--indented-images");
                e.length &&
                    e.forEach((e) => {
                        e.querySelectorAll("img").forEach((t) => {
                            var i = t.getAttribute("style");
                            (!i || "float: none;" == i) && t.width < e.offsetWidth && t.classList.add("rte__no-indent");
                        });
                    });
            }),
            (theme.customerTemplates = function () {
                var e, t, i, s;
                function n() {
                    document.getElementById("RecoverPasswordForm").classList.toggle("hide"),
                        document.getElementById("CustomerLoginForm").classList.toggle("hide");
                }
                "#recover" === window.location.hash && n(),
                    (e = document.getElementById("RecoverPassword")) &&
                        e.addEventListener("click", function (e) {
                            e.preventDefault(), n();
                        }),
                    (t = document.getElementById("HideRecoverPasswordLink")) &&
                        t.addEventListener("click", function (e) {
                            e.preventDefault(), n();
                        }),
                    document.querySelector(".reset-password-success") &&
                        document.getElementById("ResetSuccess").classList.remove("hide"),
                    (i = document.getElementById("AddressNewForm")),
                    (s = document.querySelectorAll(".js-address-form")),
                    i &&
                        s.length &&
                        (setTimeout(function () {
                            document.querySelectorAll(".js-address-country").forEach((e) => {
                                var t = e.dataset.countryId,
                                    i = e.dataset.provinceId,
                                    s = e.dataset.provinceContainerId;
                                new Shopify.CountryProvinceSelector(t, i, { hideElement: s });
                            });
                        }, 1e3),
                        document.querySelectorAll(".address-new-toggle").forEach((e) => {
                            e.addEventListener("click", function () {
                                i.classList.toggle("hide");
                            });
                        }),
                        document.querySelectorAll(".address-edit-toggle").forEach((e) => {
                            e.addEventListener("click", function (e) {
                                var t = e.currentTarget.dataset.formId;
                                document.getElementById("EditAddress_" + t).classList.toggle("hide");
                            });
                        }),
                        document.querySelectorAll(".address-delete").forEach((e) => {
                            e.addEventListener("click", function (e) {
                                var t = e.currentTarget.dataset.formId;
                                confirm(
                                    e.currentTarget.dataset.confirmMessage ||
                                        "Are you sure you wish to delete this address?"
                                ) &&
                                    Shopify &&
                                    Shopify.postLink("/account/addresses/" + t, { parameters: { _method: "delete" } });
                            });
                        }));
            }),
            (theme.CartDrawer = (function () {
                var e = { drawer: "#CartDrawer", form: "#CartDrawerForm" };
                function t() {
                    (this.form = document.querySelector(e.form)),
                        (this.drawer = new theme.Drawers("CartDrawer", "cart")),
                        this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            (this.cartForm = new theme.CartForm(this.form)),
                                this.cartForm.buildCart(),
                                document.addEventListener(
                                    "ajaxProduct:added",
                                    function (e) {
                                        document.body.classList.add("cart-has-items"),
                                            this.cartForm.buildCart(),
                                            this.open();
                                    }.bind(this)
                                ),
                                document.addEventListener("cart:open", this.open.bind(this)),
                                document.addEventListener("cart:close", this.close.bind(this));
                        },
                        open: function () {
                            this.drawer.open(),
                                setTimeout(function () {
                                    theme.a11y.trapFocus({
                                        container: this.form,
                                        elementToFocus: this.form,
                                        namespace: "cartdrawer_focus",
                                    });
                                }, 100);
                        },
                        close: function () {
                            this.drawer.close(),
                                theme.a11y.removeTrapFocus({ container: this.form, namespace: "cartdrawer_focus" });
                        },
                    })),
                    t
                );
            })()),
            (theme.refreshCart = function () {
                "sticky" === theme.settings.cartType &&
                    theme.StickyCart &&
                    theme.cart.getCart().then(function (e) {
                        theme.StickyCart.refresh(e);
                    });
            }),
            (theme.StickyCart = (function () {
                var e = {
                        cart: "#StickyCart",
                        items: "#StickyItems",
                        subtotal: "#StickySubtotal",
                        submit: "#StickySubmit",
                    },
                    t = {
                        cartTemplate: "template-cart",
                        active: "sticky-cart--open",
                        activeBodyClass: "body--sticky-cart-open",
                    };
                function i() {
                    (this.status = {
                        loaded: !1,
                        loading: !1,
                        open: document.body.classList.contains(t.activeBodyClass),
                    }),
                        document.querySelector(e.cart) && this.initEventListeners();
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        initEventListeners: function () {
                            var t = document.querySelector(e.submit);
                            t.addEventListener("click", function () {
                                t.classList.add("btn--loading");
                            }),
                                document.addEventListener(
                                    "ajaxProduct:added",
                                    function () {
                                        this.hideCart(),
                                            theme.cart.getCart().then(
                                                function (e) {
                                                    this.buildCart(e, !0);
                                                }.bind(this)
                                            );
                                    }.bind(this)
                                );
                        },
                        hideCart: function () {
                            document.body.classList.remove(t.activeBodyClass),
                                document.querySelector(e.cart).classList.remove(t.active);
                        },
                        showCart: function (i, s) {
                            i &&
                                (document.querySelector(e.items).innerText = theme.strings.cartItems.replace(
                                    "[count]",
                                    i
                                )),
                                s &&
                                    (document.querySelector(e.subtotal).innerHTML = theme.Currency.formatMoney(
                                        s,
                                        theme.settings.moneyFormat
                                    )),
                                document.body.classList.add(t.activeBodyClass),
                                document.querySelector(e.cart).classList.add(t.active),
                                (this.status.open = !0);
                        },
                        buildCart: function (e, t) {
                            this.loading(!0),
                                (this.status.loaded = !0),
                                this.loading(!1),
                                !0 === t && this.showCart(e.item_count, e.total_price);
                        },
                        loading: function (t) {
                            (this.status.loading = t),
                                t
                                    ? document.querySelector(e.cart).classList.add("is-loading")
                                    : document.querySelector(e.cart).classList.remove("is-loading");
                        },
                        updateError: function (e) {
                            e.responseJSON && e.responseJSON.description && console.warn(e.responseJSON.description);
                        },
                    })),
                    {
                        init: i,
                        refresh: function i(s) {
                            !document.body.classList.contains(t.cartTemplate) &&
                                (s.item_count > 0
                                    ? (document.body.classList.add(t.activeBodyClass),
                                      document.querySelector(e.cart).classList.add(t.active))
                                    : (document.body.classList.remove(t.activeBodyClass),
                                      document.querySelector(e.cart).classList.remove(t.active)),
                                (document.querySelector(e.items).innerText = theme.strings.cartItems.replace(
                                    "[count]",
                                    s.item_count
                                )),
                                (document.querySelector(e.subtotal).innerHTML = theme.Currency.formatMoney(
                                    s.total_price,
                                    theme.settings.moneyFormat
                                )));
                        },
                    }
                );
            })()),
            (theme.Product = (function () {
                var e = {},
                    t = {
                        onSale: "sale-price",
                        disabled: "disabled",
                        isModal: "is-modal",
                        loading: "loading",
                        loaded: "loaded",
                        hidden: "hide",
                        visuallyHide: "visually-invisible",
                        thumbActive: "thumb--current",
                        lowInventory: "inventory--low",
                    },
                    i = {
                        variantsJson: "[data-variant-json]",
                        currentVariantJson: "[data-current-variant-json]",
                        imageContainer: "[data-product-images]",
                        mainSlider: "[data-product-photos]",
                        thumbSlider: "[data-product-thumbs]",
                        thumbScroller: "[data-product-thumbs-scroller]",
                        photo: "[data-product-photo]",
                        photoThumbs: "[data-product-thumb]",
                        photoThumbItem: "[data-product-thumb-item]",
                        zoomButton: ".product__photo-zoom",
                        priceWrapper: "[data-price-wrapper]",
                        price: "[data-product-price]",
                        comparePrice: "[data-product-price-compare]",
                        priceA11y: "[data-price-a11y]",
                        comparePriceA11y: "[data-compare-a11y]",
                        sku: "[data-sku]",
                        inventory: "[data-product-inventory]",
                        incomingInventory: "[data-incoming-inventory]",
                        unitWrapper: "[data-product-unit-wrapper]",
                        addToCart: "[data-add-to-cart]",
                        addToCartText: "[data-add-to-cart-text]",
                        variantType: ".variant-wrapper",
                        originalSelectorId: "[data-product-select]",
                        singleOptionSelector: "[data-variant-input]",
                        variantColorSwatch: "[data-color-swatch]",
                        dynamicVariantsEnabled: "[data-dynamic-variants-enabled]",
                        productImageMain: ".product-image-main",
                        productVideo: ".product__video",
                        videoParent: ".product__video-wrapper",
                        slide: ".product-main-slide",
                        currentSlide: ".is-selected",
                        startingSlide: ".starting-slide",
                        media: "[data-product-media-type-model]",
                        closeMedia: ".product-single__close-media",
                        blocks: "[data-product-blocks]",
                        blocksHolder: "[data-blocks-holder]",
                        formContainer: ".product-single__form",
                        availabilityContainer: "[data-store-availability]",
                    };
                function s(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.productId = e.getAttribute("data-product-id")),
                        (this.inModal = "true" === e.dataset.modal),
                        this.modal,
                        (this.namespace = ".product-" + this.sectionId),
                        (this.namespaceImages = ".product-image-" + this.sectionId),
                        (this.settings = {
                            enableHistoryState: "true" === e.dataset.history,
                            namespace: ".product-" + this.sectionId,
                            inventory: !1,
                            inventoryThreshold: 10,
                            modalInit: !1,
                            hasImages: !0,
                            hasVideos: e.querySelectorAll(i.productVideo).length || !1,
                            videoStyle: e.dataset.videoStyle,
                            has3d: !1,
                            imageSetName: null,
                            imageSetIndex: null,
                            currentImageSet: null,
                            stackedImages: e.dataset.imagesStacked || !1,
                            stackedCurrent: 0,
                            stackedImagePositions: [],
                            imageSize: "620x",
                            currentSlideIndex: 0,
                            videoLooping: e.dataset.videoLooping,
                        }),
                        (this.videos = {}),
                        this.inModal &&
                            ((this.settings.enableHistoryState = !1),
                            (this.namespace = ".product-" + this.sectionId + "-modal"),
                            (this.modal = document.getElementById("ProductScreen-" + this.sectionId))),
                        this.init();
                }
                return (
                    (s.prototype = Object.assign({}, s.prototype, {
                        init: function () {
                            (this.mainSlider = this.container.querySelector(i.mainSlider)),
                                (this.thumbSlider = this.container.querySelector(i.thumbSlider)),
                                (this.firstProductImage = this.mainSlider.querySelector("img")),
                                this.firstProductImage || (this.settings.hasImages = !1);
                            var e = this.mainSlider.querySelector("[data-set-name]");
                            (this.settings.imageSetName = !!e && e.dataset.setName),
                                this.inModal &&
                                    (this.container.classList.add(t.isModal),
                                    document.removeEventListener(
                                        "productModalOpen.ProductScreen-" + this.sectionId,
                                        this.openModalProduct.bind(this)
                                    ),
                                    document.removeEventListener(
                                        "productModalClose.ProductScreen-" + this.sectionId,
                                        this.openModalProduct.bind(this)
                                    ),
                                    document.addEventListener(
                                        "productModalOpen.ProductScreen-" + this.sectionId,
                                        this.openModalProduct.bind(this)
                                    ),
                                    document.addEventListener(
                                        "productModalClose.ProductScreen-" + this.sectionId,
                                        this.closeModalProduct.bind(this)
                                    )),
                                this.inModal ||
                                    (this.formSetup(),
                                    this.preImageSetup(),
                                    this.videoSetup(),
                                    this.initProductSlider());
                        },
                        formSetup: function () {
                            this.initAjaxProductForm(),
                                this.availabilitySetup(),
                                this.initVariants(),
                                this.settings.imageSetName && this.updateImageSet();
                        },
                        availabilitySetup: function () {
                            var e = this.container.querySelector(i.availabilityContainer);
                            e && (this.storeAvailability = new theme.StoreAvailability(e));
                        },
                        initVariants: function () {
                            var e = this.container.querySelector(i.variantsJson),
                                t = !!this.container.querySelector(i.dynamicVariantsEnabled);
                            if (e) {
                                this.variantsObject = JSON.parse(e.innerHTML);
                                var s = {
                                        container: this.container,
                                        enableHistoryState: this.settings.enableHistoryState,
                                        singleOptionSelector: i.singleOptionSelector,
                                        originalSelectorId: i.originalSelectorId,
                                        variants: this.variantsObject,
                                        dynamicVariantsEnabled: t,
                                    },
                                    n = this.container.querySelectorAll(i.variantColorSwatch);
                                if (
                                    (n.length &&
                                        n.forEach((e) => {
                                            e.addEventListener(
                                                "change",
                                                function (t) {
                                                    var i = e.dataset.colorName,
                                                        s = e.dataset.colorIndex;
                                                    this.updateColorName(i, s);
                                                }.bind(this)
                                            );
                                        }),
                                    (this.variants = new theme.Variants(s)),
                                    this.storeAvailability)
                                ) {
                                    var a = this.variants.currentVariant
                                        ? this.variants.currentVariant.id
                                        : this.variants.variants[0].id;
                                    this.storeAvailability.updateContent(a),
                                        this.container.on(
                                            "variantChange" + this.settings.namespace,
                                            this.updateAvailability.bind(this)
                                        );
                                }
                                this.container.on("variantChange" + this.namespace, this.updateCartButton.bind(this)),
                                    this.container.on(
                                        "variantImageChange" + this.settings.namespace,
                                        this.updateVariantImage.bind(this)
                                    ),
                                    this.container.on(
                                        "variantPriceChange" + this.settings.namespace,
                                        this.updatePrice.bind(this)
                                    ),
                                    this.container.on(
                                        "variantUnitPriceChange" + this.settings.namespace,
                                        this.updateUnitPrice.bind(this)
                                    ),
                                    this.container.querySelectorAll(i.sku).length &&
                                        this.container.on(
                                            "variantSKUChange" + this.settings.namespace,
                                            this.updateSku.bind(this)
                                        );
                                var o = this.container.querySelector(i.inventory);
                                if (
                                    (o &&
                                        ((this.settings.inventory = !0),
                                        (this.settings.inventoryThreshold = o.dataset.threshold),
                                        this.updateInventory({ detail: { variant: this.variants.currentVariant } }),
                                        this.container.on(
                                            "variantChange" + this.settings.namespace,
                                            this.updateInventory.bind(this)
                                        )),
                                    t)
                                ) {
                                    var r = this.container.querySelector(i.currentVariantJson);
                                    if (r) {
                                        var c = this.container.querySelector(i.variantType);
                                        c &&
                                            new theme.VariantAvailability({
                                                container: this.container,
                                                namespace: this.settings.namespace,
                                                type: c.dataset.type,
                                                variantsObject: this.variantsObject,
                                                currentVariantObject: JSON.parse(r.innerHTML),
                                                form: this.container.querySelector(i.formContainer),
                                            });
                                    }
                                }
                                if (this.settings.imageSetName) {
                                    var l = this.container.querySelector(
                                        '.variant-input-wrap[data-handle="' + this.settings.imageSetName + '"]'
                                    );
                                    l
                                        ? ((this.settings.imageSetIndex = l.dataset.index),
                                          this.container.on(
                                              "variantChange" + this.settings.namespace,
                                              this.updateImageSet.bind(this)
                                          ))
                                        : (this.settings.imageSetName = null),
                                        window.on(
                                            "resize" + this.namespaceImages,
                                            theme.utils.debounce(
                                                200,
                                                function () {
                                                    theme.config.bpSmall || (this.settings.currentImageSet = null),
                                                        this.updateImageSet();
                                                }.bind(this)
                                            )
                                        );
                                }
                            }
                        },
                        initAjaxProductForm: function () {
                            if ("drawer" === theme.settings.cartType || "sticky" === theme.settings.cartType) {
                                var e = this.container.querySelector(i.formContainer);
                                new theme.AjaxProduct(e, i.addToCart, {
                                    scopedEventId: "ProductScreen-" + this.sectionId,
                                });
                            }
                        },
                        updateColorName: function (e, t) {
                            var i = this.container.querySelector(
                                '[data-color-label][data-color-label-index="' + t + '"]'
                            );
                            i && (i.textContent = e);
                        },
                        updateCartButton: function (e) {
                            var s = e.detail.variant,
                                n = this.container.querySelector(i.addToCart),
                                a = this.container.querySelector(i.addToCartText);
                            if (n) {
                                if (s) {
                                    if (s.available) {
                                        n.classList.remove(t.disabled), (n.disabled = !1);
                                        var o = a.dataset.defaultText;
                                        a.textContent = o;
                                    } else
                                        n.classList.add(t.disabled),
                                            (n.disabled = !0),
                                            (a.textContent = theme.strings.soldOut);
                                } else
                                    n.classList.add(t.disabled),
                                        (n.disabled = !0),
                                        (a.textContent = theme.strings.unavailable);
                            }
                        },
                        updatePrice: function (e) {
                            var s = e.detail.variant;
                            s &&
                                ((this.container.querySelector(i.price).innerHTML = theme.Currency.formatMoney(
                                    s.price,
                                    theme.settings.moneyFormat
                                )),
                                s.compare_at_price > s.price
                                    ? ((this.container.querySelector(i.comparePrice).innerHTML =
                                          theme.Currency.formatMoney(s.compare_at_price, theme.settings.moneyFormat)),
                                      this.container.querySelector(i.priceWrapper).classList.remove(t.hidden),
                                      this.container.querySelector(i.price).classList.add(t.onSale),
                                      this.container
                                          .querySelector(i.comparePriceA11y)
                                          .setAttribute("aria-hidden", "false"),
                                      this.container.querySelector(i.priceA11y).setAttribute("aria-hidden", "false"))
                                    : (this.container.querySelector(i.priceWrapper) &&
                                          this.container.querySelector(i.comparePriceA11y) &&
                                          (this.container.querySelector(i.priceWrapper).classList.add(t.hidden),
                                          this.container
                                              .querySelector(i.comparePriceA11y)
                                              .setAttribute("aria-hidden", "true")),
                                      this.container.querySelector(i.price).classList.remove(t.onSale),
                                      this.container.querySelector(i.priceA11y).setAttribute("aria-hidden", "true")));
                        },
                        updateUnitPrice: function (e) {
                            var s = e.detail.variant;
                            if (s && s.unit_price) {
                                var n = theme.Currency.formatMoney(s.unit_price, theme.settings.moneyFormat),
                                    a = theme.Currency.getBaseUnit(s),
                                    o = this.container.querySelector(i.unitWrapper);
                                (o.innerHTML = n + "/" + a), o.classList.remove(...[t.hidden, t.visuallyHide]);
                            } else this.container.querySelector(i.unitWrapper).classList.add(t.visuallyHide);
                        },
                        imageSetArguments: function (e) {
                            var e = e || (this.variants ? this.variants.currentVariant : null);
                            if (e) {
                                var t = (this.settings.currentImageSet = this.getImageSetName(
                                        e[this.settings.imageSetIndex]
                                    )),
                                    i = this.settings.imageSetName + "_" + t;
                                return (
                                    (this.settings.currentSlideIndex = 0),
                                    {
                                        cellSelector: '[data-group="' + i + '"]',
                                        imageSet: i,
                                        initialIndex: this.settings.currentSlideIndex,
                                    }
                                );
                            }
                        },
                        updateImageSet: function (e, i) {
                            var s =
                                e && e.detail ? e.detail.variant : this.variants ? this.variants.currentVariant : null;
                            if (s) {
                                var n = this.getImageSetName(s[this.settings.imageSetIndex]),
                                    a = this.settings.imageSetName + "_" + n;
                                if (this.settings.currentImageSet !== n) {
                                    if (!theme.config.bpSmall && this.settings.stackedImages) {
                                        this.container.querySelectorAll("[data-group]").forEach((e) => {
                                            e.classList.add(t.hidden),
                                                e.dataset.group &&
                                                    e.dataset.group === a &&
                                                    e.classList.remove(t.hidden);
                                        }),
                                            this.stackedImagePositions(),
                                            AOS.refresh(),
                                            (this.settings.currentImageSet = n);
                                        return;
                                    }
                                    theme.config.bpSmall &&
                                        this.settings.stackedImages &&
                                        this.container.querySelectorAll("[data-group]").forEach((e) => {
                                            e.classList.remove(t.hidden);
                                        }),
                                        this.initProductSlider(s);
                                }
                            }
                        },
                        updateImageSetThumbs: function (e) {
                            this.settings.stackedImages ||
                                this.thumbSlider.querySelectorAll(".product__thumb-item").forEach((i) => {
                                    i.classList.toggle(t.hidden, i.dataset.group !== e);
                                });
                        },
                        getImageSetName: function (e) {
                            return e
                                .toLowerCase()
                                .replace(/[^a-z0-9]+/g, "-")
                                .replace(/-$/, "")
                                .replace(/^-/, "");
                        },
                        updateSku: function (e) {
                            var s = e.detail.variant,
                                n = "",
                                a = !0;
                            s &&
                                (s.sku && ((n = s.sku), (a = !1)),
                                this.container.querySelectorAll(i.sku).forEach((e) => {
                                    e.classList.toggle(t.hidden, a), (e.textContent = n);
                                }));
                        },
                        updateInventory: function (e) {
                            var t = e.detail.variant;
                            if (!t || !t.inventory_management || "continue" === t.inventory_policy) {
                                this.toggleInventoryQuantity(!1), this.toggleIncomingInventory(!0, !1);
                                return;
                            }
                            if (
                                "shopify" === t.inventory_management &&
                                window.inventories &&
                                window.inventories[this.productId]
                            ) {
                                let i = window.inventories[this.productId][t.id],
                                    { quantity: s, policy: n, incoming: a, next_incoming_date: o } = i || {};
                                this.toggleInventoryQuantity(s),
                                    (a && !t.available) || (s <= 0 && "continue" === n)
                                        ? this.toggleIncomingInventory(!0, o)
                                        : this.toggleIncomingInventory(!1);
                            }
                        },
                        updateAvailability: function (e) {
                            var t = e.detail.variant;
                            t && this.storeAvailability.updateContent(t.id);
                        },
                        toggleInventoryQuantity: function (e) {
                            let s = this.container.querySelector(i.inventory),
                                n = s.closest(".sales-point"),
                                a = !1;
                            parseInt(e) <= parseInt(this.settings.inventoryThreshold) && parseInt(e) > 0 && (a = !0),
                                parseInt(e) > 0
                                    ? (a
                                          ? (s.parentNode.classList.add(t.lowInventory),
                                            e > 1
                                                ? (s.textContent = theme.strings.otherStockLabel.replace("[count]", e))
                                                : (s.textContent = theme.strings.oneStockLabel.replace("[count]", e)))
                                          : (s.parentNode.classList.remove(t.lowInventory),
                                            (s.textContent = theme.strings.inStockLabel)),
                                      n && n.classList.remove(t.hidden))
                                    : n && n.classList.add(t.hidden);
                        },
                        toggleIncomingInventory: function (e, s) {
                            let n = this.container.querySelector(i.incomingInventory);
                            if (!n) return;
                            let a = "true" === n.dataset.enabled,
                                o = n.querySelector(".js-incoming-text");
                            if (!a) {
                                n.classList.add(t.hidden);
                                return;
                            }
                            e
                                ? s
                                    ? ((o.textContent = theme.strings.willBeInStockAfter.replace("[date]", s)),
                                      n.classList.remove(t.hidden))
                                    : ((o.textContent = theme.strings.waitingForStock), n.classList.remove(t.hidden))
                                : n.classList.add(t.hidden);
                        },
                        videoSetup: function () {
                            var e = this.mainSlider.querySelectorAll(i.productVideo);
                            if (!e.length) return !1;
                            e.forEach((e) => {
                                var t = e.dataset.videoType;
                                "youtube" === t
                                    ? this.initYoutubeVideo(e)
                                    : "vimeo" === t
                                      ? this.initVimeoVideo(e)
                                      : "mp4" === t && this.initMp4Video(e);
                            });
                        },
                        initYoutubeVideo: function (t) {
                            e[t.id] = new theme.YouTube(t.id, {
                                videoId: t.dataset.videoId,
                                videoParent: i.videoParent,
                                autoplay: !1,
                                style: t.dataset.videoStyle,
                                loop: t.dataset.videoLoop,
                                events: {
                                    onReady: this.youtubePlayerReady.bind(this),
                                    onStateChange: this.youtubePlayerStateChange.bind(this),
                                },
                            });
                        },
                        initVimeoVideo: function (t) {
                            e[t.id] = new theme.VimeoPlayer(t.id, t.dataset.videoId, {
                                videoParent: i.videoParent,
                                autoplay: !1,
                                style: t.dataset.videoStyle,
                                loop: t.dataset.videoLoop,
                            });
                        },
                        youtubePlayerReady: function (t) {
                            var i = t.target.getIframe().id;
                            if (e[i]) {
                                var s = e[i],
                                    n = s.videoPlayer;
                                "sound" !== s.options.style && n.mute(),
                                    s.parent.classList.remove("loading"),
                                    s.parent.classList.add("loaded"),
                                    s.parent.classList.add("video-interactable"),
                                    this._isFirstSlide(i) && "sound" !== s.options.style && n.playVideo();
                            }
                        },
                        _isFirstSlide: function (e) {
                            return this.mainSlider.querySelector(i.startingSlide + " #" + e);
                        },
                        youtubePlayerStateChange: function (t) {
                            var i = e[t.target.getIframe().id];
                            switch (t.data) {
                                case -1:
                                    i.attemptedToPlay && i.parent.classList.add("video-interactable");
                                    break;
                                case 0:
                                    i && "true" === i.options.loop && i.videoPlayer.playVideo();
                                    break;
                                case 3:
                                    i.attemptedToPlay = !0;
                            }
                        },
                        initMp4Video: function (t) {
                            (e[t.id] = { id: t.id, type: "mp4" }), this._isFirstSlide(t.id) && this.playMp4Video(t.id);
                        },
                        stopVideos: function () {
                            for (var [t, i] of Object.entries(e))
                                i.videoPlayer
                                    ? "function" == typeof i.videoPlayer.stopVideo && i.videoPlayer.stopVideo()
                                    : "mp4" === i.type && this.stopMp4Video(i.id);
                        },
                        _getVideoType: function (e) {
                            return e.getAttribute("data-video-type");
                        },
                        _getVideoDivId: function (e) {
                            return e.id;
                        },
                        playMp4Video: function (e) {
                            var t = this.container.querySelector("#" + e),
                                s = t.play();
                            t.setAttribute("controls", ""),
                                t.focus(),
                                t.addEventListener("focusout", this.returnFocusToThumbnail.bind(this)),
                                void 0 !== s &&
                                    s
                                        .then(function () {})
                                        .catch(function (e) {
                                            t.setAttribute("controls", ""),
                                                t.closest(i.videoParent).setAttribute("data-video-style", "unmuted");
                                        });
                        },
                        stopMp4Video: function (e) {
                            var t = this.container.querySelector("#" + e);
                            t.removeEventListener("focusout", this.returnFocusToThumbnail.bind(this)),
                                t && "function" == typeof t.pause && (t.removeAttribute("controls"), t.pause());
                        },
                        returnFocusToThumbnail: function (e) {
                            if (e.relatedTarget && e.relatedTarget.classList.contains("product__thumb")) {
                                var t = this.container.querySelector(
                                    '.product__thumb-item[data-index="' + this.settings.currentSlideIndex + '"] a'
                                );
                                t && t.focus();
                            }
                        },
                        preImageSetup: function () {
                            this.setImageSizes(),
                                this.initImageSwitch(),
                                this.initImageZoom(),
                                this.customMediaListners(),
                                this.initModelViewerLibraries(),
                                this.initShopifyXrLaunch(),
                                theme.collapsibles.init(this.container),
                                window.SPR && (SPR.initDomEls(), SPR.loadBadges());
                        },
                        initProductSlider: function (e) {
                            if (this.mainSlider.querySelectorAll(i.slide).length <= 1) {
                                var t = this.mainSlider.querySelector(i.slide);
                                t && t.classList.add("is-selected");
                                return;
                            }
                            if (
                                ((this.settings.has3d = this.container.querySelectorAll(i.media).length),
                                "muted" !== this.settings.videoStyle && theme.videoModal(!0),
                                !e)
                            ) {
                                var s = this.mainSlider.querySelector(i.startingSlide);
                                this.settings.currentSlideIndex = this._slideIndex(s);
                            }
                            var n = {
                                dragThreshold: 25,
                                adaptiveHeight: !0,
                                avoidReflow: !0,
                                initialIndex: this.settings.currentSlideIndex,
                                childNav: this.thumbSlider,
                                childNavScroller: this.container.querySelector(i.thumbScroller),
                                childVertical: "beside" === this.thumbSlider.dataset.position,
                                fade: !this.settings.stackedImages,
                                pageDots: !0,
                                wrapAround: !0,
                                callbacks: {
                                    onInit: this.onSliderInit.bind(this),
                                    onChange: this.onSlideChange.bind(this),
                                },
                            };
                            this.settings.imageSetName &&
                                ((n = Object.assign({}, n, this.imageSetArguments(e))),
                                this.updateImageSetThumbs(n.imageSet)),
                                this.initSliders(n),
                                document.addEventListener(
                                    "matchSmall",
                                    function () {
                                        this.initSliders(n, !0);
                                    }.bind(this)
                                ),
                                document.addEventListener(
                                    "unmatchSmall",
                                    function () {
                                        this.initSliders(n, !0);
                                    }.bind(this)
                                );
                        },
                        onSliderInit: function (e) {
                            this.settings.imageSetName && this.prepMediaOnSlide(e),
                                0 === this.mainSlider.offsetHeight &&
                                    setTimeout(function () {
                                        window.dispatchEvent(new Event("resize"));
                                    }, 250);
                        },
                        onSlideChange: function (e) {
                            if (this.flickity) {
                                var t = this.mainSlider.querySelector(
                                        '.product-main-slide[data-index="' + this.settings.currentSlideIndex + '"]'
                                    ),
                                    i = this.settings.imageSetName
                                        ? this.mainSlider.querySelectorAll(".flickity-slider .product-main-slide")[e]
                                        : this.mainSlider.querySelector('.product-main-slide[data-index="' + e + '"]');
                                t.setAttribute("tabindex", "-1"),
                                    i.setAttribute("tabindex", 0),
                                    this.stopMediaOnSlide(t),
                                    this.prepMediaOnSlide(i),
                                    (this.settings.currentSlideIndex = e);
                            }
                        },
                        stopMediaOnSlide(t) {
                            var s = t.querySelector(i.productVideo);
                            if (s) {
                                var n = this._getVideoType(s),
                                    a = this._getVideoDivId(s);
                                if ("youtube" === n) {
                                    if (e[a].videoPlayer) {
                                        e[a].videoPlayer.stopVideo();
                                        return;
                                    }
                                } else if ("mp4" === n) {
                                    this.stopMp4Video(a);
                                    return;
                                }
                            }
                            var o = t.querySelector(i.media);
                            o && o.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 }));
                        },
                        prepMediaOnSlide(t) {
                            var s = t.querySelector(i.productVideo);
                            if (s) {
                                this.flickity.reposition();
                                var n = this._getVideoType(s),
                                    a = this._getVideoDivId(s);
                                if ("youtube" === n) {
                                    if (e[a].videoPlayer && "sound" !== e[a].options.style) {
                                        e[a].videoPlayer.playVideo();
                                        return;
                                    }
                                } else "mp4" === n && this.playMp4Video(a);
                            }
                            var o = t.querySelector(i.media);
                            o &&
                                (o.dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })),
                                t.querySelector(".shopify-model-viewer-ui__button").setAttribute("tabindex", 0),
                                t.querySelector(".product-single__close-media").setAttribute("tabindex", 0)),
                                this.hideZoomOverlay(o);
                        },
                        _slideIndex: function (e) {
                            return e.getAttribute("data-index");
                        },
                        initImageZoom: function () {
                            var e = this.container.querySelector(i.imageContainer);
                            e &&
                                (new theme.Photoswipe(e, this.sectionId),
                                e.addEventListener(
                                    "photoswipe:afterChange",
                                    function (e) {
                                        this.flickity && this.flickity.goToSlide(e.detail.index);
                                    }.bind(this)
                                ));
                        },
                        getThumbIndex: function (e) {
                            return this.settings.stackedImages
                                ? e.dataset.index
                                : Array.from(e.parentElement.children).indexOf(e);
                        },
                        setImageSizes: function () {
                            if (this.settings.hasImages) {
                                var e = this.firstProductImage.currentSrc;
                                e && (this.settings.imageSize = theme.Images.imageSize(e));
                            }
                        },
                        updateVariantImage: function (e) {
                            var t = e.detail.variant;
                            theme.Images.getSizedImageUrl(t.featured_media.preview_image.src, this.settings.imageSize);
                            var i = this.container.querySelector(
                                    '.product-main-slide[data-id="' + t.featured_media.id + '"]'
                                ),
                                s = this.getThumbIndex(i);
                            void 0 !== s &&
                                (!theme.config.bpSmall && this.settings.stackedImages
                                    ? (this.stackedScrollTo(s), this.stackedActive(0), this.stackedImagePositions())
                                    : this.flickity && this.flickity.goToSlide(s));
                        },
                        initImageSwitch: function () {
                            var e = this.container.querySelectorAll(i.photoThumbs);
                            e.length &&
                                e.forEach((e) => {
                                    e.addEventListener(
                                        "click",
                                        function (t) {
                                            if (
                                                (t.preventDefault(),
                                                !theme.config.bpSmall && this.settings.stackedImages)
                                            ) {
                                                var i = this.getThumbIndex(e);
                                                this.stackedScrollTo(i);
                                            }
                                        }.bind(this)
                                    ),
                                        e.addEventListener(
                                            "focus",
                                            function (s) {
                                                var n = this.getThumbIndex(e);
                                                !theme.config.bpSmall &&
                                                    (this.settings.stackedImages
                                                        ? (this.container
                                                              .querySelectorAll(i.photoThumbItem)
                                                              .forEach((e) => {
                                                                  e.classList.remove(t.thumbActive);
                                                              }),
                                                          this.stackedScrollTo(n))
                                                        : this.flickity && this.flickity.goToSlide(n));
                                            }.bind(this)
                                        ),
                                        e.addEventListener(
                                            "keydown",
                                            function (e) {
                                                13 === e.keyCode &&
                                                    this.container.querySelector(i.currentSlide).focus();
                                            }.bind(this)
                                        );
                                });
                        },
                        stackedImagesInit: function () {
                            window.off(this.namespaceImages),
                                this.stackedImagePositions(),
                                this.inModal
                                    ? setTimeout(
                                          function () {
                                              this.stackedActive(this.settings.stackedCurrent);
                                          }.bind(this),
                                          1e3
                                      )
                                    : this.stackedActive(this.settings.stackedCurrent),
                                window.on(
                                    "resize" + this.namespaceImages,
                                    theme.utils.debounce(200, this.stackedImagePositions.bind(this))
                                ),
                                window.on(
                                    "scroll" + this.namespaceImages,
                                    theme.utils.throttle(
                                        200,
                                        function () {
                                            var e = window.scrollY;
                                            this.stackedImagePositions();
                                            var t = this.settings.stackedImagePositions.reduce(function (t, i) {
                                                    return Math.abs(i - e) < Math.abs(t - e) ? i : t;
                                                }),
                                                i = this.settings.stackedImagePositions.indexOf(t);
                                            this.settings.stackedCurrent !== i && this.stackedActive(i);
                                        }.bind(this)
                                    )
                                );
                        },
                        stackedImagePositions: function () {
                            var e = [];
                            this.container.querySelectorAll(i.photo).forEach((t) => {
                                var i = Math.round(t.offsetTop);
                                i > 0 && e.push(Math.round(i - window.outerHeight / 2));
                            }),
                                (this.settings.stackedImagePositions = e);
                        },
                        stackedScrollTo: function (e) {
                            var t = this.container.querySelectorAll(i.photo)[e];
                            if (t) {
                                var s = t.offsetTop;
                                window.scroll({ top: s, behavior: "smooth" });
                            }
                        },
                        stackedActive: function (s) {
                            this.container.querySelectorAll(i.photoThumbItem).forEach((e) => {
                                e.classList.remove(t.thumbActive), e.classList.remove("is-active");
                            });
                            var n = this.container.querySelectorAll(i.photoThumbItem + ":not(.hide")[s];
                            if (
                                (n && (n.classList.add(t.thumbActive), (this.settings.currentSlideIndex = s)),
                                this.settings.hasVideos)
                            ) {
                                this.stopVideos();
                                var a = this.container.querySelectorAll(i.photo)[s].querySelector(".product__video");
                                if (a) {
                                    var o = this._getVideoType(a),
                                        r = this._getVideoDivId(a);
                                    if ("youtube" === o) {
                                        if (e[r].videoPlayer && "sound" !== e[r].options.style) {
                                            e[r].videoPlayer.playVideo();
                                            return;
                                        }
                                    } else "mp4" === o && this.playMp4Video(r);
                                }
                            }
                            if (this.settings.has3d) {
                                var c = this.container.querySelectorAll(i.media);
                                c.length &&
                                    c.forEach((e) => {
                                        e.dispatchEvent(new CustomEvent("mediaHidden"));
                                    });
                                var l = this.container.querySelectorAll(i.photo)[s].querySelector(i.media);
                                l && l.dispatchEvent(new CustomEvent("mediaVisible"));
                            }
                            this.settings.stackedCurrent = s;
                        },
                        initSliders: function (e, t) {
                            this.destroyImageCarousels();
                            var s = this.container.querySelector(i.imageContainer);
                            !theme.config.bpSmall && this.settings.stackedImages
                                ? (this.stackedImagesInit(), s.setAttribute("data-has-slideshow", "false"))
                                : ((this.flickity = new theme.Slideshow(this.mainSlider, e)),
                                  s.setAttribute("data-has-slideshow", "true"));
                        },
                        destroyImageCarousels: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        hideZoomOverlay: function (e) {
                            var s = this.container.querySelector(i.zoomButton);
                            e ? s && s.classList.add(t.hidden) : s && s.classList.remove(t.hidden);
                        },
                        openModalProduct: function () {
                            var e = !1;
                            this.settings.modalInit
                                ? ((e = !0),
                                  !theme.config.bpSmall && this.settings.stackedImages && this.stackedActive(0))
                                : ((this.blocksHolder = this.container.querySelector(i.blocksHolder)),
                                  fetch(this.blocksHolder.dataset.url)
                                      .then(function (e) {
                                          return e.text();
                                      })
                                      .then(
                                          function (e) {
                                              var t = new DOMParser().parseFromString(e, "text/html"),
                                                  s = t.querySelector(i.blocks);
                                              s.querySelectorAll("[id]").forEach((e) => {
                                                  var t = e.getAttribute("id");
                                                  e.setAttribute("id", t + "-modal");
                                                  var i = s.querySelector(`[for="${t}"]`);
                                                  i && i.setAttribute("for", t + "-modal");
                                                  var n = s.querySelector(`[aria-controls="${t}"]`);
                                                  n && n.setAttribute("aria-controls", t + "-modal");
                                              });
                                              var n = s.querySelector(i.formContainer);
                                              if (n) {
                                                  var a = n.getAttribute("id");
                                                  s.querySelectorAll("[form]").forEach((e) => {
                                                      e.setAttribute("form", a);
                                                  });
                                              }
                                              (this.blocksHolder.innerHTML = ""),
                                                  this.blocksHolder.append(s),
                                                  this.formSetup(),
                                                  this.updateModalProductInventory(),
                                                  Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init(),
                                                  theme.collapsibles.init(this.container);
                                              var o = t.querySelectorAll(
                                                  "#MainContent .shopify-section:not(.shopify-section__product)"
                                              );
                                              o.length && this.loadProductSections(o);
                                              var r = t.querySelector(".index-section.social-section");
                                              r && this.loadSocialSection(r),
                                                  window.SPR && (SPR.initDomEls(), SPR.loadBadges()),
                                                  theme.sections.loadSubSections(this.modal),
                                                  document.dispatchEvent(
                                                      new CustomEvent("quickview:loaded", {
                                                          detail: { productId: this.productId },
                                                      })
                                                  ),
                                                  this.preImageSetup(),
                                                  this.initProductSlider(),
                                                  (this.settings.modalInit = !0);
                                          }.bind(this)
                                      )),
                                document.dispatchEvent(
                                    new CustomEvent("quickview:open", {
                                        detail: { initialized: e, productId: this.productId },
                                    })
                                );
                        },
                        updateModalProductInventory: function () {
                            (window.inventories = window.inventories || {}),
                                this.container.querySelectorAll(".js-product-inventory-data").forEach((e) => {
                                    var t = e.dataset.productId;
                                    (window.inventories[t] = {}),
                                        e.querySelectorAll(".js-variant-inventory-data").forEach((e) => {
                                            window.inventories[t][e.dataset.id] = {
                                                quantity: e.dataset.quantity,
                                                policy: e.dataset.policy,
                                                incoming: e.dataset.incoming,
                                                next_incoming_date: e.dataset.date,
                                            };
                                        });
                                });
                        },
                        closeModalProduct: function () {
                            this.stopVideos(),
                                this.unloadProductSections(),
                                this.unloadSocialSection(),
                                (this.settings.modalInit = !1),
                                window.off(this.namespace);
                        },
                        unloadProductSections: function () {
                            var e = document.querySelector("#ProductSectionsHolder-" + this.productId);
                            e && (e.innerHTML = "");
                        },
                        loadProductSections: function (e) {
                            var t = document.querySelector("#ProductSectionsHolder-" + this.productId);
                            t && ((t.innerHTML = ""), t.append(...e), theme.collapsibles.init(t));
                        },
                        loadSocialSection: function (e) {
                            var t = document.querySelector("#SocialSectionHolder-" + this.productId);
                            t && t.replaceWith(e);
                        },
                        unloadSocialSection: function () {
                            var e = document.querySelector("#SocialSectionHolder-" + this.productId);
                            e && (e.innerHTML = "");
                        },
                        initModelViewerLibraries: function () {
                            var e = this.container.querySelectorAll(i.media);
                            e.length < 1 || theme.ProductMedia.init(e, this.sectionId);
                        },
                        initShopifyXrLaunch: function () {
                            document.addEventListener(
                                "shopify_xr_launch",
                                function () {
                                    this.container
                                        .querySelector(i.productMediaWrapper + ":not(." + self.classes.hidden + ")")
                                        .dispatchEvent(new CustomEvent("xrLaunch", { bubbles: !0, cancelable: !0 }));
                                }.bind(this)
                            );
                        },
                        customMediaListners: function () {
                            this.container.querySelectorAll(i.closeMedia).forEach((e) => {
                                e.addEventListener(
                                    "click",
                                    function () {
                                        if (this.settings.stackedImages)
                                            var e = this.mainSlider.querySelector(
                                                '.product-main-slide[data-index="' +
                                                    this.settings.currentSlideIndex +
                                                    '"]'
                                            );
                                        else var e = this.mainSlider.querySelector(i.currentSlide);
                                        var t = e.querySelector(i.media);
                                        t &&
                                            t.dispatchEvent(
                                                new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })
                                            );
                                    }.bind(this)
                                );
                            });
                            var e = this.container.querySelectorAll("model-viewer");
                            e.length &&
                                e.forEach((e) => {
                                    e.addEventListener(
                                        "shopify_model_viewer_ui_toggle_play",
                                        function (e) {
                                            this.mediaLoaded(e);
                                        }.bind(this)
                                    ),
                                        e.addEventListener(
                                            "shopify_model_viewer_ui_toggle_pause",
                                            function (e) {
                                                this.mediaUnloaded(e);
                                            }.bind(this)
                                        );
                                });
                        },
                        mediaLoaded: function (e) {
                            this.container.querySelectorAll(i.closeMedia).forEach((e) => {
                                e.classList.remove(t.hidden);
                            }),
                                this.flickity && this.flickity.setDraggable(!1);
                        },
                        mediaUnloaded: function (e) {
                            this.container.querySelectorAll(i.closeMedia).forEach((e) => {
                                e.classList.add(t.hidden);
                            }),
                                this.flickity && this.flickity.setDraggable(!0);
                        },
                        onUnload: function () {
                            window.off(this.namespace),
                                this.container.off(this.namespace),
                                this.destroyImageCarousels(),
                                theme.ProductMedia.removeSectionModels(this.sectionId),
                                AOS && AOS.refresh();
                        },
                    })),
                    s
                );
            })()),
            (theme.Blog = (function () {
                function e(e) {
                    this.tagFilters();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        tagFilters: function () {
                            var e = document.getElementById("BlogTagFilter");
                            e &&
                                e.addEventListener("change", function () {
                                    location.href = e.value;
                                });
                        },
                    })),
                    e
                );
            })()),
            (theme.HeaderSection = (function () {
                function e(e) {
                    this.initDrawers(),
                        this.hoverMenu(),
                        theme.headerNav.init(),
                        theme.slideNav.init(),
                        Shopify &&
                            Shopify.designMode &&
                            (theme.sections.reinit("slideshow-section"),
                            setTimeout(function () {
                                window.dispatchEvent(new Event("resize"));
                            }, 500));
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        initDrawers: function () {
                            "drawer" !== theme.settings.cartType ||
                                document.body.classList.contains("template-cart") ||
                                new theme.CartDrawer();
                        },
                        hoverMenu: function () {
                            let e = document.querySelectorAll(
                                '[data-section-type="header-section"] details[data-hover="true"]'
                            );
                            e.forEach((e) => {
                                let t = e.querySelector("summary"),
                                    i = t.dataset.link;
                                t.addEventListener("click", (e) => {
                                    e.preventDefault(), (window.location.href = i);
                                }),
                                    e.addEventListener("mouseover", () => {
                                        e.hasAttribute("open") ||
                                            (e.setAttribute("open", ""), e.setAttribute("aria-expanded", "true"));
                                    }),
                                    e.addEventListener("mouseleave", () => {
                                        e.hasAttribute("open") &&
                                            (e.removeAttribute("open"), e.setAttribute("aria-expanded", "false"));
                                    });
                            });
                        },
                        onUnload: function () {
                            theme.headerNav.unload(), theme.slideNav.unload();
                        },
                    })),
                    e
                );
            })()),
            (theme.FooterSection = (function () {
                var e = { locale: "[data-disclosure-locale]", currency: "[data-disclosure-currency]" };
                function t(e) {
                    (this.container = e),
                        (this.localeDisclosure = null),
                        (this.currencyDisclosure = null),
                        theme.initWhenVisible({
                            element: this.container,
                            callback: this.init.bind(this),
                            threshold: 1e3,
                        });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            var t = this.container.querySelector(e.locale),
                                i = this.container.querySelector(e.currency);
                            t && (this.localeDisclosure = new theme.Disclosure(t)),
                                i && (this.currencyDisclosure = new theme.Disclosure(i));
                        },
                        onUnload: function () {
                            this.localeDisclosure && this.localeDisclosure.destroy(),
                                this.currencyDisclosure && this.currencyDisclosure.destroy();
                        },
                    })),
                    t
                );
            })()),
            (theme.Collection = (function () {
                var e = !1,
                    t = { sortSelect: "#SortBy" };
                function i(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".collection-" + this.sectionId),
                        document.querySelector(".collection-hero")
                            ? this.checkIfNeedReload()
                            : theme.settings.overlayHeader && theme.headerNav.disableOverlayHeader(),
                        this.init();
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            (this.container = this.container),
                                (this.sectionId = this.container.getAttribute("data-section-id")),
                                (this.sortSelect = document.querySelector(t.sortSelect)),
                                this.sortSelect &&
                                    (this.sortSelect.on("change", this.onSortChange.bind(this)),
                                    (this.defaultSort = this.getDefaultSortValue())),
                                new theme.HoverProductGrid(this.container),
                                this.sortTags(),
                                this.bindBackButton();
                        },
                        getSortValue: function () {
                            return this.sortSelect.value || this.defaultSort;
                        },
                        getDefaultSortValue: function () {
                            return this.sortSelect.dataset.sortBy;
                        },
                        onSortChange: function () {
                            (this.queryParams = new URLSearchParams(window.location.search)),
                                this.queryParams.set("sort_by", this.getSortValue()),
                                this.queryParams.delete("page"),
                                (window.location.search = this.queryParams.toString());
                        },
                        sortTags: function () {
                            var e = document.getElementById("SortTags");
                            e &&
                                e.on("change", function (t) {
                                    location.href = e.value;
                                });
                        },
                        bindBackButton: function () {
                            window.off("popstate" + this.namespace),
                                window.on("popstate" + this.namespace, (t) => {
                                    if (t) {
                                        if (location.href.indexOf(location.pathname) >= 0) return !0;
                                        let i = new URL(window.location.href);
                                        theme.CollectionAjaxFilter(i, !1).then(() => {
                                            (e = !1), this.initPriceRange();
                                        });
                                    }
                                });
                        },
                        checkIfNeedReload: function () {
                            Shopify.designMode &&
                                theme.settings.overlayHeader &&
                                (document
                                    .querySelector(".header-wrapper")
                                    .classList.contains("header-wrapper--overlay") ||
                                    location.reload());
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            window.off(this.namespace), this.container.off(this.namespace);
                        },
                    })),
                    i
                );
            })()),
            (theme.CollectionFilter = (function () {
                var e = !1,
                    t = {
                        activeTagList: ".tag-list--active-tags",
                        activeTags: ".tag-list a",
                        filters: ".collection-filter",
                        priceRange: ".price-range",
                        tags: ".tag-list input",
                        tagsForm: ".filter-form",
                    },
                    i = { activeTag: "tag--active", removeTagParent: "tag--remove" };
                function s(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".collection-filter-" + this.sectionId),
                        this.init();
                }
                return (
                    (s.prototype = Object.assign({}, s.prototype, {
                        init: function () {
                            document.querySelectorAll(t.activeTags).forEach((e) => {
                                e.on("click" + this.namespace, this.onTagClick.bind(this));
                            }),
                                document.querySelectorAll(t.tagsForm).forEach((e) => {
                                    e.addEventListener("input", this.onFormSubmit.bind(this));
                                }),
                                this.initPriceRange();
                        },
                        initPriceRange: function () {
                            let e = document.querySelectorAll(t.priceRange);
                            e.forEach((e) => new theme.PriceRange(e, { onChange: this.renderFromFormData.bind(this) }));
                        },
                        onTagClick: function (t) {
                            var i = t.currentTarget;
                            if (i.classList.contains("no-ajax") || (t.preventDefault(), e)) return;
                            e = !0;
                            let s = i.parentNode,
                                n = new URL(i.href);
                            this.renderActiveTag(s, i), this.startLoading(), this.renderCollectionPage(n.searchParams);
                        },
                        onFormSubmit: function (t) {
                            let i = t.target;
                            if (i.classList.contains("no-ajax") || (t.preventDefault(), e)) return;
                            e = !0;
                            let s = i.closest("li"),
                                n = i.closest("form"),
                                a = new FormData(n);
                            this.renderActiveTag(s, i), this.startLoading(), this.renderFromFormData(a);
                        },
                        renderCollectionPage: function (t) {
                            theme.CollectionAjaxFilter(t).then(() => {
                                (e = !1),
                                    this.initPriceRange(),
                                    document.dispatchEvent(new CustomEvent("collection:reloaded"));
                            });
                        },
                        renderFromFormData: function (e) {
                            let t = new URLSearchParams(e);
                            this.renderCollectionPage(t);
                        },
                        renderActiveTag: function (e, s) {
                            let n = e.querySelector(".tag__text");
                            if (e.classList.contains(i.activeTag)) e.classList.remove(i.activeTag);
                            else {
                                if (s.closest("li").classList.contains(i.removeTagParent)) e.remove();
                                else {
                                    let a = document.createElement("li");
                                    a.classList.add(...["tag", "tag--remove"]);
                                    let o = document.createElement("a");
                                    o.classList.add(...["btn", "btn--small", "js-no-transition"]),
                                        (o.innerText = n.innerText);
                                    let r = document.createElement("div");
                                    r.classList.add("tag-remove-svg"),
                                        (r.innerHTML =
                                            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>'),
                                        a.appendChild(o),
                                        a.appendChild(r);
                                    let c = document.querySelector(t.activeTagList);
                                    c && c.append(a);
                                }
                                e.classList.add(i.activeTag);
                            }
                        },
                        startLoading: function () {
                            document.querySelectorAll(".grid-product").forEach((e) => {
                                e.classList.add("unload");
                            });
                        },
                        forceReload: function () {
                            this.init();
                        },
                    })),
                    s
                );
            })()),
            (theme.CollectionAjaxFilter = function (e, t = !0) {
                let i = {
                        filterWrapperId: "CollectionFiltersSection",
                        productWrapperId: "CollectionGrid",
                        productContentId: "CollectionAjaxContent",
                    },
                    s = document.getElementById(i.filterWrapperId),
                    n = document.getElementById(i.productWrapperId),
                    a = new theme.AjaxRenderer({
                        sections: [
                            { sectionId: s.dataset.sectionId, nodeId: i.filterWrapperId },
                            { sectionId: n.dataset.sectionId, nodeId: i.productContentId },
                        ],
                    });
                return a.renderPage(window.location.pathname, e, t).then(() => {
                    theme.sections.reinit("collection-grid"), theme.sections.reinit("collection-filter");
                    let e = document.getElementById(i.productContentId);
                    theme.reinitProductGridItem(e), theme.QuickShopScreens.reInit(e);
                });
            }),
            (theme.FeaturedCollection = (function () {
                var e = {
                        scrollWrap: "[data-pagination-wrapper]",
                        productContainer: "[data-product-container]",
                        collectionProductContainer: "[data-collection-container]",
                        product: "[data-product-grid]",
                        arrows: "[data-arrow]",
                    },
                    t = {
                        loading: "collection-loading",
                        arrowLeft: "overflow-scroller__arrow--left",
                        disableScrollLeft: "overflow-scroller--disable-left",
                        disableScrollRight: "overflow-scroller--disable-right",
                    };
                function i(t) {
                    (this.container = t),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.scrollWrap = this.container.querySelector(e.scrollWrap)),
                        (this.scrollArrows = this.container.querySelectorAll(e.arrows)),
                        (this.namespace = ".featured-collection-" + this.sectionId),
                        (this.options = {
                            scrollable: this.container.dataset.scrollable,
                            paginate: this.container.dataset.paginate === "true",
                            scrollMode: this.container.dataset.scrollMode || "off",
                            autoScroll:
                                this.container.dataset.scrollMode === "stepped" ||
                                this.container.dataset.scrollMode === "continuous",
                        });
                    var i = this.container.dataset.paginateBy,
                        s = this.container.dataset.collectionCount,
                        n = parseInt(this.container.dataset.scrollInterval, 10) || 5;
                    (this.settings = {
                        url: this.container.dataset.collectionUrl,
                        page: 1,
                        pageCount: this.options.paginate ? Math.ceil(s / i) : 0,
                        itemsToScroll: 3,
                        gridItemWidth: this.container.dataset.gridItemWidth,
                        scrollIntervalMs: Math.max(2000, Math.min(15000, n * 1000)),
                    }),
                        (this.state = {
                            isInit: !1,
                            loading: !1,
                            scrollerEnabled: !1,
                            loadedAllProducts: !1,
                            scrollable: this.options.scrollable,
                            scrollInterval: null,
                            scrollSpeed: 3,
                            autoScrollInterval: null,
                            continuousAnimationId: null,
                        }),
                        (this.continuousScrollSpeed =
                            Math.max(0.25, Math.min(2, parseFloat(this.container.dataset.scrollSpeed) || 0.5))),
                        (this.sizing = { scroller: 0, itemWidth: 0 }),
                        theme.initWhenVisible({ element: this.container, callback: this.init.bind(this) });
                }
                return (
                    (i.prototype = Object.assign({}, i.prototype, {
                        init: function () {
                            new theme.HoverProductGrid(this.container),
                                this.state.scrollable &&
                                    ((this.sizing = this.getScrollWidths()),
                                    window.on(
                                        "resize" + this.namespace,
                                        theme.utils.debounce(200, this.handleResize.bind(this))
                                    ),
                                    this.toggleScrollListener(this.state.scrollable),
                                    this.arrowListeners(this.state.scrollable),
                                    this.options.autoScroll &&
                                        (this.startAutoScroll(),
                                        this.container.on("mouseenter" + this.namespace, this.stopAutoScroll.bind(this)),
                                        this.container.on("mouseleave" + this.namespace, this.startAutoScroll.bind(this))),
                                    (this.state.isInit = !0));
                        },
                        startAutoScroll: function () {
                            var e = this;
                            this.stopAutoScroll();
                            if (this.options.scrollMode === "stepped") {
                                this.state.autoScrollInterval = setInterval(function () {
                                    e.autoScrollTick();
                                }, this.settings.scrollIntervalMs);
                            } else if (this.options.scrollMode === "continuous") {
                                (function tick() {
                                    if (e.state.loading || !e.scrollWrap || !e.sizing.scrollSize) {
                                        e.state.continuousAnimationId = requestAnimationFrame(tick);
                                        return;
                                    }
                                    var scrollLeft = e.scrollWrap.scrollLeft + e.continuousScrollSpeed;
                                    if (scrollLeft >= e.sizing.scrollSize) {
                                        scrollLeft = 0;
                                    }
                                    e.scrollWrap.scrollLeft = scrollLeft;
                                    var pct = Math.floor((scrollLeft / e.sizing.scrollSize) * 100);
                                    e.disableArrow(pct);
                                    e.state.continuousAnimationId = requestAnimationFrame(tick);
                                })();
                            }
                        },
                        stopAutoScroll: function () {
                            this.state.autoScrollInterval &&
                                (clearInterval(this.state.autoScrollInterval), (this.state.autoScrollInterval = null));
                            this.state.continuousAnimationId &&
                                (cancelAnimationFrame(this.state.continuousAnimationId),
                                (this.state.continuousAnimationId = null));
                        },
                        autoScrollTick: function () {
                            if (this.state.loading || !this.scrollWrap || !this.sizing.scrollSize) return;
                            var e = this.scrollWrap.scrollLeft,
                                t = this.sizing.itemWidth * this.settings.itemsToScroll,
                                i = e + t;
                            if (i >= this.sizing.scrollSize) {
                                this.scrollWrap.scroll({ left: 0, behavior: "smooth" });
                            } else {
                                this.scrollWrap.scroll({ left: i, behavior: "smooth" });
                            }
                            var s = Math.floor((i >= this.sizing.scrollSize ? 0 : i) / this.sizing.scrollSize * 100);
                            this.disableArrow(s);
                        },
                        reInit: function () {
                            new theme.HoverProductGrid(this.container),
                                this.state.scrollable &&
                                    ((this.sizing = this.getScrollWidths()),
                                    this.toggleScrollListener(this.state.scrollable)),
                                theme.reinitProductGridItem();
                        },
                        loadingState: function (e) {
                            (this.state.loading = e), this.container.classList.toggle(t.loading, e);
                        },
                        getScrollWidths: function () {
                            var e = this.scrollWrap.offsetWidth,
                                t = this.scrollWrap.scrollWidth,
                                i = this.scrollWrap.querySelector(".grid__item").offsetWidth;
                            return (
                                this.state.isInit || (t -= 200),
                                t <= e && this.disableArrow(null, !0),
                                { scroller: t, scrollSize: t - e, itemWidth: i }
                            );
                        },
                        handleResize: function () {
                            this.state.scrollable && (this.sizing = this.getScrollWidths()),
                                this.toggleScrollListener(this.state.scrollable),
                                this.arrowListeners(this.state.scrollable);
                        },
                        toggleScrollListener: function (e) {
                            e
                                ? !this.state.scrollerEnabled &&
                                  (this.scrollWrap.on(
                                      "scroll" + this.namespace,
                                      theme.utils.throttle(250, this.scrollCheck.bind(this))
                                  ),
                                  (this.state.scrollerEnabled = !0))
                                : (this.scrollWrap.off("scroll" + this.namespace), (this.state.scrollerEnabled = !1));
                        },
                        scrollCheck: function (e) {
                            if (this.state.loading) {
                                this.toggleScrollListener(!1);
                                return;
                            }
                            0 === this.sizing.scrollSize && (this.sizing = this.getScrollWidths());
                            var t,
                                i = Math.floor(
                                    ((e.currentTarget.scrollLeft ? e.currentTarget.scrollLeft : 0) /
                                        this.sizing.scrollSize) *
                                        100
                                );
                            this.sizing.scrollSize,
                                this.options.paginate &&
                                    !this.state.loadedAllProducts &&
                                    i > 50 &&
                                    this.getNewProducts(),
                                i || (i = 0),
                                this.disableArrow(i);
                        },
                        arrowListeners: function (e) {
                            this.scrollArrows.forEach((t) => {
                                t.off("click" + this.namespace),
                                    e
                                        ? (t.classList.remove("hide"),
                                          t.on("click" + this.namespace, this.arrowScroll.bind(this)))
                                        : t.classList.add("hide");
                            });
                        },
                        arrowScroll: function (e) {
                            var i = e.currentTarget.classList.contains(t.arrowLeft) ? "left" : "right",
                                s = theme.config.bpSmall ? 1 : 2;
                            if ("mouseenter" === e.type)
                                this.state.scrollInterval = setInterval(
                                    function () {
                                        var e = this.scrollWrap.scrollLeft;
                                        this.scrollWrap.scrollLeft = "left" === i ? e - s : e + s;
                                    }.bind(this),
                                    this.state.scrollSpeed
                                );
                            else if ("mouseleave" === e.type) clearInterval(this.state.scrollInterval);
                            else if ("click" === e.type) {
                                clearInterval(this.state.scrollInterval);
                                var n = this.scrollWrap.scrollLeft,
                                    a = this.sizing.itemWidth * this.settings.itemsToScroll,
                                    o = "left" === i ? n - a : n + a;
                                this.scrollWrap.scroll({ left: o, behavior: "smooth" });
                            }
                            o <= 0 && this.disableArrow(o);
                        },
                        disableArrow: function (e, i) {
                            this.scrollArrows.forEach((s) => {
                                if (
                                    (s.classList.remove(t.disableScrollRight),
                                    s.classList.remove(t.disableScrollLeft),
                                    i)
                                ) {
                                    s.classList.add(t.disableScrollRight), s.classList.add(t.disableScrollLeft);
                                    return;
                                }
                                if (e <= 10) {
                                    s.classList.add(t.disableScrollLeft);
                                    return;
                                }
                                if (e >= 96) {
                                    s.classList.add(t.disableScrollRight);
                                    return;
                                }
                            });
                        },
                        getNewProducts: function () {
                            this.loadingState(!0);
                            var t = this.settings.page + 1,
                                i = this.settings.gridItemWidth;
                            if (t > this.settings.pageCount || void 0 === this.settings.url) {
                                this.loadingState(!1), (this.state.loadedAllProducts = !0);
                                return;
                            }
                            fetch(this.settings.url + "?page=" + t)
                                .then(function (e) {
                                    return e.text();
                                })
                                .then(
                                    function (t) {
                                        var s = new DOMParser()
                                                .parseFromString(t, "text/html")
                                                .querySelectorAll(e.collectionProductContainer + " .grid-product"),
                                            n = document.createDocumentFragment();
                                        s.forEach((e) => {
                                            e.classList.add(i), n.appendChild(e);
                                        }),
                                            this.container.querySelector(e.productContainer).appendChild(n),
                                            this.ajaxSuccess();
                                    }.bind(this)
                                );
                        },
                        ajaxSuccess: function () {
                            this.loadingState(!1), (this.settings.page = this.settings.page + 1), this.reInit();
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onLoad: function () {
                            theme.QuickShopScreens.reInit(this.container);
                        },
                        onUnload: function () {
                            this.stopAutoScroll(),
                                window.off(this.namespace),
                                this.container.off(this.namespace),
                                window.dispatchEvent(new Event("resize")),
                                this.scrollWrap.off(this.namespace),
                                theme.QuickShopScreens.unload(this.container);
                        },
                    })),
                    i
                );
            })()),
            (theme.Testimonials = (function () {
                var e = { adaptiveHeight: !1, avoidReflow: !0, pageDots: !0, prevNextButtons: !1, wrapAround: !0 };
                function t(e) {
                    this.container = e;
                    var t = e.getAttribute("data-section-id");
                    (this.slideshow = e.querySelector("#Testimonials-" + t)),
                        this.slideshow &&
                            theme.initWhenVisible({
                                element: this.container,
                                callback: this.init.bind(this),
                                threshold: 600,
                            });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function (t, i) {
                            this.slideshow.dataset.count <= 3 && ((e.wrapAround = !1), (e.contain = !0)),
                                (this.flickity = new theme.Slideshow(this.slideshow, e)),
                                this.flickity.resize();
                        },
                        onUnload: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        onDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                        onBlockSelect: function (e) {
                            var t = parseInt(
                                this.slideshow.querySelector(".testimonials-slide--" + e.detail.blockId).dataset.index
                            );
                            clearTimeout(this.timeout),
                                this.flickity &&
                                    "function" == typeof this.flickity.pause &&
                                    (this.flickity.goToSlide(t), this.flickity.pause());
                        },
                        onBlockDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                    })),
                    t
                );
            })()),
            (theme.HeroAnimated = (function () {
                var e = { active: "animated__slide--active", inactive: "animated__slide--inactive" };
                function t(e) {
                    this.container = e;
                    var t = e.dataset.count,
                        i = e.querySelector(".hero");
                    if (
                        (i && (i.classList.remove("loading", "loading--delayed"), i.classList.add("loaded")),
                        (this.allImages = Array.from(e.querySelectorAll(".animated__slide"))),
                        (this.slidesWithImages = Array.from(e.querySelectorAll("[data-slide-with-image]"))),
                        (this.state = { activeIndex: 0 }),
                        "1" === t)
                    ) {
                        this.setFades(!0);
                        return;
                    }
                    this.slidesWithImages.length === this.allImages.length &&
                        (this.interval,
                        (this.intervalSpeed = e.dataset.interval),
                        (this.maxIndex = t - 1),
                        theme.initWhenVisible({ element: this.container, callback: this.initInterval.bind(this) }));
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        initInterval: function () {
                            this.setFades(!0),
                                (this.interval = setInterval(
                                    function () {
                                        this.setFades();
                                    }.bind(this),
                                    this.intervalSpeed
                                ));
                        },
                        setFades: function (t) {
                            var i = this.state.activeIndex === this.maxIndex ? 0 : this.state.activeIndex + 1;
                            if ((t && (i = this.state.activeIndex), !t)) {
                                var s = this.allImages[this.state.activeIndex];
                                s.classList.remove(e.active), s.classList.add(e.inactive);
                            }
                            var n = this.allImages[i];
                            n.classList.remove(e.inactive), n.classList.add(e.active), (this.state.activeIndex = i);
                        },
                        onUnload: function () {
                            clearInterval(this.interval);
                        },
                    })),
                    t
                );
            })());
        class m extends HTMLElement {
            constructor() {
                if (
                    (super(),
                    (this.cookieName = this.id),
                    (this.cookie = Cookies.get(this.cookieName)),
                    (this.classes = {
                        activeContent: "age-verification-popup__content--active",
                        inactiveContent: "age-verification-popup__content--inactive",
                        inactiveDeclineContent: "age-verification-popup__decline-content--inactive",
                        activeDeclineContent: "age-verification-popup__decline-content--active",
                    }),
                    (this.declineButton = this.querySelector("[data-age-verification-popup-decline-button]")),
                    (this.declineContent = this.querySelector("[data-age-verification-popup-decline-content]")),
                    (this.content = this.querySelector("[data-age-verification-popup-content]")),
                    (this.returnButton = this.querySelector("[data-age-verification-popup-return-button]")),
                    (this.exitButton = this.querySelector("[data-age-verification-popup-exit-button]")),
                    (this.backgroundImage = this.querySelector("[data-background-image]")),
                    (this.mobileBackgroundImage = this.querySelector("[data-mobile-background-image]")),
                    Shopify.designMode &&
                        (document.addEventListener("shopify:section:select", (e) => {
                            e.detail.sectionId === this.dataset.sectionId && this.init();
                        }),
                        document.addEventListener("shopify:section:load", (e) => {
                            if (e.detail.sectionId === this.dataset.sectionId) {
                                this.init(),
                                    "true" === this.dataset.testMode && this.cookie && Cookies.remove(this.cookieName);
                                let t = sessionStorage.getItem(this.id);
                                t && this.showDeclineContent();
                            }
                        }),
                        document.addEventListener("shopify:section:unload", (e) => {
                            e.detail.sectionId === this.dataset.sectionId && this.modal.close();
                        })),
                    this.cookie && "false" === this.dataset.testMode)
                )
                    return;
                this.init();
            }
            init() {
                (this.modal = new theme.Modals(this.id, "age-verification-popup-modal", { closeOffContentClick: !1 })),
                    this.backgroundImage && (this.backgroundImage.style.display = "block"),
                    theme.config.bpSmall &&
                        this.mobileBackgroundImage &&
                        (this.mobileBackgroundImage.style.display = "block"),
                    this.modal.open(),
                    theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent")),
                    this.declineButton &&
                        this.declineButton.addEventListener("click", (e) => {
                            e.preventDefault(),
                                this.showDeclineContent(),
                                Shopify.designMode && sessionStorage.setItem(this.id, "second-view");
                        }),
                    this.returnButton &&
                        this.returnButton.addEventListener("click", (e) => {
                            e.preventDefault(), this.hideDeclineContent();
                            let t = sessionStorage.getItem(this.id);
                            Shopify.designMode && t && sessionStorage.removeItem(this.id);
                        }),
                    this.exitButton &&
                        this.exitButton.addEventListener("click", (e) => {
                            e.preventDefault(),
                                "false" === this.dataset.testMode &&
                                    Cookies.set(this.cookieName, "entered", {
                                        expires: 30,
                                        sameSite: "none",
                                        secure: !0,
                                    }),
                                this.backgroundImage && (this.backgroundImage.style.display = "none"),
                                theme.config.bpSmall &&
                                    this.mobileBackgroundImage &&
                                    (this.mobileBackgroundImage.style.display = "none"),
                                this.modal.close(),
                                theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent"));
                        });
            }
            showDeclineContent() {
                this.declineContent.classList.remove(this.classes.inactiveDeclineContent),
                    this.declineContent.classList.add(this.classes.activeDeclineContent),
                    this.content.classList.add(this.classes.inactiveContent),
                    this.content.classList.remove(this.classes.activeContent);
            }
            hideDeclineContent() {
                this.declineContent.classList.add(this.classes.inactiveDeclineContent),
                    this.declineContent.classList.remove(this.classes.activeDeclineContent),
                    this.content.classList.remove(this.classes.inactiveContent),
                    this.content.classList.add(this.classes.activeContent);
            }
        }
        customElements.define("age-verification-popup", m),
            (theme.Maps = (function () {
                var e = { zoom: 14 },
                    t = null,
                    i = [],
                    s = {},
                    n = {
                        section: '[data-section-type="map"]',
                        map: "[data-map]",
                        mapOverlay: ".map-section__overlay",
                    };
                function a(e) {
                    (this.container = e),
                        (this.sectionId = this.container.getAttribute("data-section-id")),
                        (this.namespace = ".map-" + this.sectionId),
                        (this.map = e.querySelector(n.map)),
                        (this.key = this.map.dataset.apiKey),
                        (s = {
                            addressNoResults: theme.strings.addressNoResults,
                            addressQueryLimit: theme.strings.addressQueryLimit,
                            addressError: theme.strings.addressError,
                            authError: theme.strings.authError,
                        }),
                        this.key &&
                            theme.initWhenVisible({
                                element: this.container,
                                callback: this.prepMapApi.bind(this),
                                threshold: 20,
                            });
                }
                return (
                    (window.gm_authFailure = function () {
                        Shopify.designMode &&
                            (document.querySelectorAll(n.section).forEach((e) => {
                                e.classList.add("map-section--load-error");
                            }),
                            document.querySelectorAll(n.map).forEach((e) => {
                                e.parentNode.removeChild(e);
                            }),
                            window.mapError(theme.strings.authError));
                    }),
                    (window.mapError = function (e) {
                        var t = document.createElement("div");
                        t.classList.add("map-section__error", "errors", "text-center"),
                            (t.innerHTML = e),
                            document.querySelectorAll(n.mapOverlay).forEach((e) => {
                                e.parentNode.prepend(t);
                            }),
                            document.querySelectorAll(".map-section__link").forEach((e) => {
                                e.classList.add("hide");
                            });
                    }),
                    (a.prototype = Object.assign({}, a.prototype, {
                        prepMapApi: function () {
                            if ("loaded" === t) this.createMap();
                            else if (
                                (i.push(this),
                                "loading" !== t &&
                                    ((t = "loading"), void 0 === window.google || void 0 === window.google.maps))
                            ) {
                                var e = document.createElement("script");
                                (e.onload = function () {
                                    (t = "loaded"),
                                        i.forEach((e) => {
                                            e.createMap();
                                        });
                                }),
                                    (e.src = "https://maps.googleapis.com/maps/api/js?key=" + this.key),
                                    document.head.appendChild(e);
                            }
                        },
                        createMap: function () {
                            var t = this.map;
                            return (function e(t) {
                                var i = new google.maps.Geocoder();
                                if (t) {
                                    var s = t.dataset.addressSetting;
                                    return new Promise((e, t) => {
                                        i.geocode({ address: s }, function (i, s) {
                                            s !== google.maps.GeocoderStatus.OK && t(s), e(i);
                                        });
                                    });
                                }
                            })(t)
                                .then(
                                    function (i) {
                                        var s = {
                                                zoom: e.zoom,
                                                backgroundColor: "none",
                                                center: i[0].geometry.location,
                                                draggable: !1,
                                                clickableIcons: !1,
                                                scrollwheel: !1,
                                                disableDoubleClickZoom: !0,
                                                disableDefaultUI: !0,
                                            },
                                            n = (this.map = new google.maps.Map(t, s)),
                                            a = (this.center = n.getCenter());
                                        new google.maps.Marker({ map: n, position: n.getCenter() }),
                                            google.maps.event.addDomListener(
                                                window,
                                                "resize",
                                                theme.utils.debounce(250, function () {
                                                    google.maps.event.trigger(n, "resize"),
                                                        n.setCenter(a),
                                                        t.removeAttribute("style");
                                                })
                                            ),
                                            Shopify.designMode && window.AOS && AOS.refreshHard();
                                    }.bind(this)
                                )
                                .catch(function (e) {
                                    var t;
                                    switch (e) {
                                        case "ZERO_RESULTS":
                                            t = s.addressNoResults;
                                            break;
                                        case "OVER_QUERY_LIMIT":
                                            t = s.addressQueryLimit;
                                            break;
                                        case "REQUEST_DENIED":
                                            t = s.authError;
                                            break;
                                        default:
                                            t = s.addressError;
                                    }
                                    Shopify.designMode && window.mapError(t);
                                });
                        },
                        onUnload: function () {
                            0 !== this.map.length &&
                                google &&
                                google.maps &&
                                google.maps.event &&
                                google.maps.event.clearListeners(this.map, "resize");
                        },
                    })),
                    a
                );
            })()),
            (theme.SlideshowSection = (function () {
                function e(e) {
                    this.container = e;
                    var t = e.getAttribute("data-section-id");
                    if (
                        ((this.slideshow = e.querySelector("#Slideshow-" + t)),
                        (this.namespace = "." + t),
                        (this.initialIndex = 0),
                        this.slideshow)
                    ) {
                        var i = e.parentElement;
                        0 === [].indexOf.call(i.parentElement.children, i)
                            ? this.init()
                            : theme.initWhenVisible({ element: this.container, callback: this.init.bind(this) });
                    }
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            var e = this.slideshow.querySelectorAll(".slideshow__slide");
                            if (
                                (this.slideshow.classList.remove("loading", "loading--delayed"),
                                this.slideshow.classList.add("loaded"),
                                e.length > 1)
                            ) {
                                var t = {
                                    prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
                                    pageDots: this.slideshow.hasAttribute("data-dots"),
                                    fade: !0,
                                    setGallerySize: !1,
                                    initialIndex: this.initialIndex,
                                    autoPlay:
                                        "true" === this.slideshow.dataset.autoplay &&
                                        parseInt(this.slideshow.dataset.speed),
                                };
                                this.flickity = new theme.Slideshow(this.slideshow, t);
                            } else e[0].classList.add("is-selected");
                        },
                        forceReload: function () {
                            this.onUnload(), this.init();
                        },
                        onUnload: function () {
                            this.flickity && "function" == typeof this.flickity.destroy && this.flickity.destroy();
                        },
                        onDeselect: function () {
                            this.flickity && "function" == typeof this.flickity.play && this.flickity.play();
                        },
                        onBlockSelect: function (e) {
                            var t = parseInt(
                                this.slideshow.querySelector(".slideshow__slide--" + e.detail.blockId).dataset.index
                            );
                            this.flickity && "function" == typeof this.flickity.pause
                                ? (this.flickity.goToSlide(t), this.flickity.pause())
                                : ((this.initialIndex = t),
                                  setTimeout(
                                      function () {
                                          this.flickity &&
                                              "function" == typeof this.flickity.pause &&
                                              this.flickity.pause();
                                      }.bind(this),
                                      1e3
                                  ));
                        },
                        onBlockDeselect: function () {
                            this.flickity &&
                                "function" == typeof this.flickity.play &&
                                this.flickity.args.autoPlay &&
                                this.flickity.play();
                        },
                    })),
                    e
                );
            })()),
            (theme.NewsletterPopup = (function () {
                function e(e) {
                    this.container = e;
                    var t = this.container.getAttribute("data-section-id");
                    if (
                        ((this.cookieName = "newsletter-" + t),
                        (this.cookie = Cookies.get(this.cookieName)),
                        e && "/challenge" !== window.location.pathname && "/password" !== window.location.pathname)
                    ) {
                        (this.data = {
                            secondsBeforeShow: e.dataset.delaySeconds,
                            daysBeforeReappear: e.dataset.delayDays,
                            hasReminder: e.dataset.hasReminder,
                            testMode: e.dataset.testMode,
                        }),
                            (this.modal = new theme.Modals("NewsletterPopup-" + t, "newsletter-popup-modal"));
                        var i = e.querySelector(".popup-cta a");
                        if (
                            (i &&
                                i.addEventListener(
                                    "click",
                                    function () {
                                        this.closePopup(!0);
                                    }.bind(this)
                                ),
                            (e.querySelector(".errors") || e.querySelector(".note--success")) && this.modal.open(),
                            e.querySelector(".note--success"))
                        ) {
                            this.closePopup(!0);
                            return;
                        }
                        document.addEventListener("modalClose." + e.id, this.closePopup.bind(this)),
                            this.cookie || this.initPopupDelay(),
                            document.addEventListener("reminder:openNewsletter", () => {
                                this.modal.open();
                            });
                    }
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        initPopupDelay: function () {
                            "true" !== this.data.testMode &&
                                setTimeout(
                                    function () {
                                        let e = "true" === sessionStorage.getItem("newsletterAppeared");
                                        if (e) {
                                            let t = new CustomEvent("newsletter:openReminder", { bubbles: !0 });
                                            this.container.dispatchEvent(t);
                                        } else this.modal.open(), sessionStorage.setItem("newsletterAppeared", !0);
                                    }.bind(this),
                                    1e3 * this.data.secondsBeforeShow
                                );
                        },
                        closePopup: function (e) {
                            if ("true" === this.data.testMode) {
                                Cookies.remove(this.cookieName, { path: "/" });
                                return;
                            }
                            var t = e ? 200 : this.data.daysBeforeReappear,
                                i = "true" === this.data.hasReminder,
                                s = "true" === sessionStorage.getItem("reminderAppeared");
                            i && s
                                ? Cookies.set(this.cookieName, "opened", { path: "/", expires: t })
                                : i || Cookies.set(this.cookieName, "opened", { path: "/", expires: t });
                        },
                        onLoad: function () {
                            this.modal.open();
                        },
                        onSelect: function () {
                            this.modal.open();
                        },
                        onDeselect: function () {
                            this.modal.close();
                        },
                        onBlockSelect: function () {
                            this.modal.close();
                        },
                        onBlockDeselect: function () {
                            this.modal.open();
                        },
                        onUnload: function () {
                            this.modal.close();
                        },
                    })),
                    e
                );
            })()),
            (theme.PasswordHeader = (function () {
                function e() {
                    this.init();
                }
                return (
                    (e.prototype = Object.assign({}, e.prototype, {
                        init: function () {
                            if (document.querySelector("#LoginModal")) {
                                var e = new theme.Modals("LoginModal", "login-modal", {
                                    focusIdOnOpen: "password",
                                    solid: !0,
                                });
                                document.querySelectorAll(".errors").length && e.open();
                            }
                        },
                    })),
                    e
                );
            })()),
            (theme.Photoswipe = (function () {
                var e = {
                    trigger: ".js-photoswipe__zoom",
                    images: ".photoswipe__image",
                    slideshowTrack: ".flickity-viewport ",
                    activeImage: ".is-selected",
                };
                function t(e, t) {
                    (this.container = e),
                        (this.sectionId = t),
                        (this.namespace = ".photoswipe-" + this.sectionId),
                        this.gallery,
                        this.images,
                        this.items,
                        (this.inSlideshow = !1),
                        e && "false" !== e.dataset.zoom && this.init();
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            this.container.querySelectorAll(e.trigger).forEach((e) => {
                                e.on("click" + this.namespace, this.triggerClick.bind(this));
                            });
                        },
                        triggerClick: function (t) {
                            this.container.dataset && "true" === this.container.dataset.hasSlideshow
                                ? (this.inSlideshow = !0)
                                : (this.inSlideshow = !1),
                                (this.items = this.getImageData());
                            var i = this.inSlideshow ? this.container.querySelector(e.activeImage) : t.currentTarget,
                                s = this.inSlideshow ? this.getChildIndex(i) : i.dataset.index;
                            this.initGallery(this.items, s);
                        },
                        getChildIndex: function (e) {
                            for (var t = 0; null != (e = e.previousSibling); ) t++;
                            return t + 1;
                        },
                        getImageData: function () {
                            this.images = this.inSlideshow
                                ? this.container.querySelectorAll(e.slideshowTrack + e.images)
                                : this.container.querySelectorAll(e.images);
                            var t = [];
                            return (
                                this.images.forEach((e) => {
                                    var i = {
                                        msrc: e.currentSrc || e.src,
                                        src: e.getAttribute("data-photoswipe-src"),
                                        w: e.getAttribute("data-photoswipe-width"),
                                        h: e.getAttribute("data-photoswipe-height"),
                                        el: e,
                                        initialZoomLevel: 0.5,
                                    };
                                    t.push(i);
                                }),
                                t
                            );
                        },
                        initGallery: function (e, t) {
                            var i = document.querySelectorAll(".pswp")[0];
                            (this.gallery = new PhotoSwipe(i, PhotoSwipeUI_Default, e, {
                                allowPanToNext: !1,
                                captionEl: !1,
                                closeOnScroll: !1,
                                counterEl: !1,
                                history: !1,
                                index: t - 1,
                                pinchToClose: !1,
                                preloaderEl: !1,
                                scaleMode: "zoom",
                                shareEl: !1,
                                tapToToggleControls: !1,
                                getThumbBoundsFn: function (t) {
                                    var i = window.pageYOffset || document.documentElement.scrollTop,
                                        s = e[t].el.getBoundingClientRect();
                                    return { x: s.left, y: s.top + i, w: s.width };
                                },
                            })),
                                this.gallery.listen("afterChange", this.afterChange.bind(this)),
                                this.gallery.init(),
                                this.preventiOS15Scrolling();
                        },
                        afterChange: function () {
                            var e = this.gallery.getCurrentIndex();
                            this.container.dispatchEvent(
                                new CustomEvent("photoswipe:afterChange", { detail: { index: e } })
                            );
                        },
                        syncHeight: function () {
                            document.documentElement.style.setProperty(
                                "--window-inner-height",
                                `${window.innerHeight}px`
                            );
                        },
                        preventiOS15Scrolling: function () {
                            let e;
                            /iPhone|iPad|iPod/i.test(window.navigator.userAgent) &&
                                (this.syncHeight(),
                                (e = window.scrollY),
                                document.documentElement.classList.add("pswp-open-in-ios"),
                                window.addEventListener("resize", this.syncHeight),
                                this.gallery.listen("destroy", () => {
                                    document.documentElement.classList.remove("pswp-open-in-ios"),
                                        window.scrollTo(0, e);
                                }));
                        },
                    })),
                    t
                );
            })());
        class v extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.url = this.dataset.url),
                    (this.intent = this.dataset.intent),
                    (this.placeholder = this.querySelector(".product-recommendations-placeholder")),
                    (this.productResults = this.querySelector(".grid-product")),
                    (this.sectionId = this.dataset.sectionId),
                    (this.blockId = this.dataset.blockId),
                    document.addEventListener("recommendations:loaded", (e) => {
                        (this.colorImages = this.el.querySelectorAll(".grid-product__color-image")),
                            this.colorImages.length &&
                                ((this.swatches = this.el.querySelectorAll(".color-swatch--with-image")),
                                this.colorSwatchHovering());
                    });
            }
            connectedCallback() {
                fetch(this.url)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = document.createElement("div");
                        t.innerHTML = e;
                        let i = t.querySelector(".product-recommendations");
                        if (!i) {
                            this.el.classList.add("hide"), AOS && AOS.refreshHard();
                            return;
                        }
                        (this.placeholder.innerHTML = ""),
                            (this.placeholder.innerHTML = i.innerHTML),
                            theme.reinitProductGridItem(this.el),
                            (this.slideshow = this.querySelector("[data-slideshow]")),
                            this.slideshow && this.setupSlider(),
                            document.dispatchEvent(
                                new CustomEvent("recommendations:loaded", {
                                    detail: { section: this.el, intent: this.intent },
                                })
                            );
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
            setupSlider() {
                let e = this.slideshow.dataset.controls,
                    t = parseFloat(this.slideshow.dataset.perSlide),
                    i = parseFloat(this.slideshow.dataset.count),
                    s = !1,
                    n = !0;
                "arrows" === e && ((n = !1), (s = !0)),
                    t < i &&
                        (this.flickity = new theme.Slideshow(this.slideshow, {
                            prevNextButtons: s,
                            pageDots: n,
                            adaptiveHeight: !0,
                            wrapAround: !1,
                        }));
            }
            colorSwatchHovering() {
                this.swatches.forEach((e) => {
                    e.addEventListener(
                        "mouseenter",
                        function () {
                            this.setActiveColorImage(e);
                        }.bind(this)
                    ),
                        e.addEventListener(
                            "touchstart",
                            function (t) {
                                t.preventDefault(), this.setActiveColorImage(e);
                            }.bind(this),
                            { passive: !0 }
                        ),
                        e.addEventListener(
                            "mouseleave",
                            function () {
                                this.removeActiveColorImage(e);
                            }.bind(this)
                        );
                });
            }
            setActiveColorImage(e) {
                let t = e.dataset.variantId,
                    i = e.dataset.variantImage;
                this.colorImages.forEach((e) => {
                    e.classList.remove("is-active");
                }),
                    this.swatches.forEach((e) => {
                        e.classList.remove("is-active");
                    });
                let s = this.el.querySelector(`.grid-product__color-image--${t}`);
                (s.style.backgroundImage = "url(" + i + ")"),
                    s.classList.add("is-active"),
                    e.classList.add("is-active");
                let n = e.dataset.url,
                    a = e.closest(".grid-item__link");
                a.setAttribute("href", n);
            }
            removeActiveColorImage(e) {
                let t = e.dataset.variantId;
                this.el.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active");
            }
        }
        customElements.define("product-recommendations", v),
            (theme.StoreAvailability = (function () {
                var e = {
                    drawerOpenBtn: ".js-drawer-open-availability",
                    modalOpenBtn: ".js-modal-open-availability",
                    productTitle: "[data-availability-product-title]",
                };
                function t(e) {
                    (this.container = e),
                        (this.baseUrl = e.dataset.baseUrl),
                        (this.productTitle = e.dataset.productName);
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        updateContent: function (t) {
                            var i = this.baseUrl + "/variants/" + t + "/?section_id=store-availability",
                                s = this;
                            fetch(i)
                                .then(function (e) {
                                    return e.text();
                                })
                                .then(function (t) {
                                    if ("" === t.trim()) {
                                        this.container.innerHTML = "";
                                        return;
                                    }
                                    (s.container.innerHTML = t),
                                        (s.container.innerHTML = s.container.firstElementChild.innerHTML),
                                        s.container.querySelector(e.drawerOpenBtn) &&
                                            (s.drawer = new theme.Drawers("StoreAvailabilityDrawer", "availability")),
                                        s.container.querySelector(e.modalOpenBtn) &&
                                            (s.modal = new theme.Modals("StoreAvailabilityModal", "availability"));
                                    var i = s.container.querySelector(e.productTitle);
                                    i && (i.textContent = s.productTitle);
                                });
                        },
                    })),
                    t
                );
            })()),
            (theme.VideoSection = (function () {
                var e = { videoParent: ".video-parent-section" };
                function t(e) {
                    (this.container = e),
                        (this.sectionId = e.getAttribute("data-section-id")),
                        (this.namespace = ".video-" + this.sectionId),
                        this.videoObject,
                        theme.initWhenVisible({
                            element: this.container,
                            callback: this.init.bind(this),
                            threshold: 500,
                        });
                }
                return (
                    (t.prototype = Object.assign({}, t.prototype, {
                        init: function () {
                            var e = this.container.querySelector(".video-div");
                            if (e) {
                                var t = e.dataset.type;
                                switch (t) {
                                    case "youtube":
                                        var i = e.dataset.videoId;
                                        this.initYoutubeVideo(i);
                                        break;
                                    case "vimeo":
                                        var i = e.dataset.videoId;
                                        this.initVimeoVideo(i);
                                        break;
                                    case "mp4":
                                        this.initMp4Video();
                                }
                            }
                        },
                        initYoutubeVideo: function (t) {
                            this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
                                videoId: t,
                                videoParent: e.videoParent,
                            });
                        },
                        initVimeoVideo: function (t) {
                            this.videoObject = new theme.VimeoPlayer("Vimeo-" + this.sectionId, t, {
                                videoParent: e.videoParent,
                            });
                        },
                        initMp4Video: function () {
                            var t = "Mp4Video-" + this.sectionId,
                                i = document.getElementById(t),
                                s = i.closest(e.videoParent);
                            if (i) {
                                s.classList.add("loaded");
                                var n = document.querySelector("#" + t).play();
                                void 0 !== n &&
                                    n
                                        .then(function () {})
                                        .catch(function () {
                                            i.setAttribute("controls", ""), s.classList.add("video-interactable");
                                        });
                            }
                        },
                        onUnload: function (e) {
                            e.target.id.replace("shopify-section-", ""),
                                this.videoObject &&
                                    "function" == typeof this.videoObject.destroy &&
                                    this.videoObject.destroy();
                        },
                    })),
                    t
                );
            })());
        class g extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.display = this.querySelector("[data-time-display]")),
                    (this.block = this.closest(".countdown__block--timer")),
                    (this.year = this.el.dataset.year),
                    (this.month = this.el.dataset.month),
                    (this.day = this.el.dataset.day),
                    (this.hour = this.el.dataset.hour),
                    (this.minute = this.el.dataset.minute),
                    (this.daysPlaceholder = this.querySelector("[date-days-placeholder]")),
                    (this.hoursPlaceholder = this.querySelector("[date-hours-placeholder]")),
                    (this.minutesPlaceholder = this.querySelector("[date-minutes-placeholder]")),
                    (this.secondsPlaceholder = this.querySelector("[date-seconds-placeholder]")),
                    (this.messagePlaceholder = this.querySelector("[data-message-placeholder]")),
                    (this.hideTimerOnComplete = this.el.dataset.hideTimer),
                    (this.completeMessage = this.el.dataset.completeMessage),
                    (this.timerComplete = !1),
                    this.init();
            }
            init() {
                setInterval(() => {
                    this.timerComplete || this._calculate();
                }, 1e3);
            }
            _calculate() {
                let e =
                    +new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`).getTime() -
                    +new Date().getTime();
                if (e > 0) {
                    let t = {
                        days: Math.floor(e / 864e5),
                        hours: Math.floor((e / 36e5) % 24),
                        minutes: Math.floor((e / 1e3 / 60) % 60),
                        seconds: Math.floor((e / 1e3) % 60),
                    };
                    (this.daysPlaceholder.innerHTML = t.days),
                        (this.hoursPlaceholder.innerHTML = t.hours),
                        (this.minutesPlaceholder.innerHTML = t.minutes),
                        (this.secondsPlaceholder.innerHTML = t.seconds);
                } else
                    this.completeMessage &&
                        this.messagePlaceholder &&
                        this.messagePlaceholder.classList.add("countdown__timer-message--visible"),
                        "true" === this.hideTimerOnComplete &&
                            (this.display.classList.remove("countdown__display--visible"),
                            this.display.classList.add("countdown__display--hidden")),
                        this.completeMessage ||
                            "true" !== this.hideTimerOnComplete ||
                            this.block.classList.add("countdown__block--hidden"),
                        (this.timerComplete = !0);
            }
        }
        customElements.define("countdown-timer", g);
        class y extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.buttons = this.querySelectorAll("[data-button]")),
                    (this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]")),
                    (this.blockContainer = this.querySelector("[data-block-container]")),
                    (this.colorImages = this.querySelectorAll(".grid-product__color-image")),
                    (this.colorSwatches = this.querySelectorAll(".color-swatch--with-image")),
                    this._bindEvents(),
                    this._setupQuickShop(),
                    this.colorImages.length && this._colorSwatchHovering();
            }
            _colorSwatchHovering() {
                this.colorSwatches.forEach((e) => {
                    e.addEventListener(
                        "mouseenter",
                        function () {
                            this._setActiveColorImage(e);
                        }.bind(this)
                    ),
                        e.addEventListener(
                            "touchstart",
                            function (t) {
                                t.preventDefault(), this._setActiveColorImage(e);
                            }.bind(this),
                            { passive: !0 }
                        ),
                        e.addEventListener(
                            "mouseleave",
                            function () {
                                this._removeActiveColorImage(e);
                            }.bind(this)
                        );
                });
            }
            _setActiveColorImage(e) {
                var t = e.dataset.variantId,
                    i = e.dataset.variantImage;
                this.colorImages.forEach((e) => {
                    e.classList.remove("is-active");
                }),
                    this.colorSwatches.forEach((e) => {
                        e.classList.remove("is-active");
                    });
                var s = this.el.querySelector(".grid-product__color-image--" + t);
                (s.style.backgroundImage = "url(" + i + ")"),
                    s.classList.add("is-active"),
                    e.classList.add("is-active");
                var n = e.dataset.url,
                    a = e.closest(".grid-item__link");
                a && a.setAttribute("href", n);
            }
            _removeActiveColorImage(e) {
                let t = e.dataset.variantId;
                this.querySelector(`.grid-product__color-image--${t}`).classList.remove("is-active");
            }
            _bindEvents() {
                this.buttons.forEach((e) => {
                    let t = e.dataset.button;
                    e.on("click", (e) => {
                        e.preventDefault(), e.stopPropagation(), this._showContent(t);
                    });
                }),
                    document.addEventListener("shopify:block:select", (e) => {
                        let t = e.detail.blockId;
                        this._showContent(`${t}`);
                    });
            }
            _showContent(e) {
                this.hotspotBlocks.forEach((t) => {
                    t.dataset.hotspotBlock === e ? t.classList.add("is-active") : t.classList.remove("is-active");
                });
            }
            _setupQuickShop() {
                this.querySelectorAll('[data-block-type="product"]').length > 0 &&
                    ("function" == typeof theme.QuickShop
                        ? new theme.QuickShop(this.blockContainer)
                        : "function" == typeof theme.initQuickShop && theme.initQuickShop(),
                    "function" == typeof theme.QuickAdd && new theme.QuickAdd(this.blockContainer));
            }
        }
        customElements.define("hot-spots", y);
        class S extends HTMLElement {
            constructor() {
                super(),
                    (this.el = this),
                    (this.sectionId = this.dataset.sectionId),
                    (this.button = this.querySelector("[data-button]")),
                    (this.draggableContainer = this.querySelector("[data-draggable]")),
                    (this.primaryImage = this.querySelector("[data-primary-image]")),
                    (this.secondaryImage = this.querySelector("[data-secondary-image]")),
                    this.calculateSizes(),
                    (this.active = !1),
                    (this.currentX = 0),
                    (this.initialX = 0),
                    (this.xOffset = 0),
                    (this.buttonOffset = this.button.offsetWidth / 2),
                    this.el.addEventListener("touchstart", this.dragStart, !1),
                    this.el.addEventListener("touchend", this.dragEnd, !1),
                    this.el.addEventListener("touchmove", this.drag, !1),
                    this.el.addEventListener("mousedown", this.dragStart, !1),
                    this.el.addEventListener("mouseup", this.dragEnd, !1),
                    this.el.addEventListener("mousemove", this.drag, !1),
                    window.on(
                        "resize",
                        theme.utils.debounce(250, () => {
                            this.calculateSizes(!0);
                        })
                    ),
                    document.addEventListener("shopify:section:load", (e) => {
                        e.detail.sectionId === this.sectionId && null !== this.primaryImage && this.calculateSizes();
                    });
            }
            calculateSizes(e = !1) {
                (this.active = !1),
                    (this.currentX = 0),
                    (this.initialX = 0),
                    (this.xOffset = 0),
                    (this.buttonOffset = this.button.offsetWidth / 2),
                    (this.elWidth = this.el.offsetWidth),
                    (this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`),
                    this.primaryImage && (this.primaryImage.style.width = `${this.elWidth}px`),
                    e && (this.draggableContainer.style.width = `${this.elWidth / 2}px`);
            }
            dragStart(e) {
                "touchstart" === e.type
                    ? (this.initialX = e.touches[0].clientX - this.xOffset)
                    : (this.initialX = e.clientX - this.xOffset),
                    e.target === this.button && (this.active = !0);
            }
            dragEnd(e) {
                (this.initialX = this.currentX), (this.active = !1);
            }
            drag(e) {
                this.active &&
                    (e.preventDefault(),
                    "touchmove" === e.type
                        ? (this.currentX = e.touches[0].clientX - this.initialX)
                        : (this.currentX = e.clientX - this.initialX),
                    (this.xOffset = this.currentX),
                    this.setTranslate(this.currentX, this.button));
            }
            setTranslate(e, t) {
                let i = e - this.buttonOffset,
                    s = this.elWidth / 2 + e,
                    n = -((this.elWidth / 2 + this.buttonOffset) * 1),
                    a = this.elWidth / 2 - this.buttonOffset;
                i < n + 50 ? ((i = n + 50), (s = 50)) : i > a - 50 && ((i = a - 50), (s = this.elWidth - 50)),
                    (t.style.transform = `translate(${i}px, -50%)`),
                    (this.draggableContainer.style.width = `${s}px`);
            }
        }
        customElements.define("image-compare", S),
            (theme.isStorageSupported = function (e) {
                if (window.self !== window.top) return !1;
                var t,
                    i = "test";
                "session" === e && (t = window.sessionStorage), "local" === e && (t = window.localStorage);
                try {
                    return t.setItem(i, "1"), t.removeItem(i), !0;
                } catch (s) {
                    return !1;
                }
            }),
            (theme.reinitProductGridItem = function () {
                AOS && AOS.refreshHard(), window.SPR && (SPR.initDomEls(), SPR.loadBadges()), theme.collapsibles.init();
            }),
            (theme.reviewAppLinkListener = function () {
                document.addEventListener("click", function (e) {
                    if (window.SPR) {
                        var t = e.target.parentNode,
                            i = null;
                        (t.matches(".spr-pagination-next") || t.matches(".spr-pagination-page")) &&
                            (i = t.closest(".spr-reviews")),
                            i && i.scrollTo(0, 0);
                    }
                });
            }),
            (theme.checkForAnchorLink = function () {
                if (window.location.hash) {
                    var e = document.querySelector(window.location.hash);
                    e && window.scrollTo(0, e.offsetTop - 100);
                }
            }),
            (theme.init = function () {
                theme.QuickShopScreens.init(),
                    theme.rteInit(),
                    theme.articleImages(),
                    theme.collapsibles.init(),
                    "sticky" === theme.settings.cartType && new theme.StickyCart.init(),
                    theme.videoModal(),
                    window.addEventListener("pageshow", function (e) {
                        e.persisted && theme.refreshCart();
                    }),
                    performance && 2 === performance.navigation.type && theme.refreshCart();
            }),
            (theme.initSecondary = function () {
                document.body.classList.add("js-animate"),
                    AOS.init({
                        easing: "ease-out-quad",
                        once: !1,
                        mirror: !0,
                        offset: 100,
                        disableMutationObserver: !0,
                    }),
                    document.addEventListener("lazyloaded", function (e) {
                        var t = e.target;
                        t && t.parentNode.classList.add("loaded");
                    }),
                    theme.storeScrollPositionOnUnload(),
                    theme.reviewAppLinkListener(),
                    theme.checkForAnchorLink();
            }),
            (theme.config.hasSessionStorage = theme.isStorageSupported("session")),
            (theme.config.hasLocalStorage = theme.isStorageSupported("local")),
            (r = function () {
                if (
                    ((theme.sections = new theme.Sections()),
                    theme.init(),
                    theme.settings.isCustomerTemplate && theme.customerTemplates(),
                    theme.sections.register("slideshow-section", theme.SlideshowSection),
                    theme.sections.register("header-section", theme.HeaderSection),
                    theme.sections.register("hero-animated", theme.HeroAnimated),
                    theme.sections.register("video-section", theme.VideoSection),
                    theme.sections.register("product", theme.Product),
                    theme.sections.register("password-header", theme.PasswordHeader),
                    theme.sections.register("product-template", theme.Product),
                    theme.sections.register("featured-collection", theme.FeaturedCollection),
                    theme.sections.register("collection-grid", theme.Collection),
                    theme.sections.register("collection-filter", theme.CollectionFilter),
                    theme.sections.register("testimonials", theme.Testimonials),
                    theme.sections.register("newsletter-popup", theme.NewsletterPopup),
                    theme.sections.register("map", theme.Maps),
                    theme.sections.register("blog", theme.Blog),
                    theme.sections.register("footer-section", theme.FooterSection),
                    theme.sections.register("store-availability", theme.StoreAvailability),
                    document.body.classList.contains("template-cart"))
                ) {
                    var e = document.getElementById("CartPageForm");
                    e && new theme.CartForm(e);
                }
                theme.pageTransitions(), theme.initSecondary(), document.dispatchEvent(new CustomEvent("page:loaded"));
            }),
            "loading" != document.readyState ? r() : document.addEventListener("DOMContentLoaded", r);
    })(),
    document.querySelector(".js-toggle-slide-nav").addEventListener("click", function () {
        addClassToBody("overflow-hidden"),
            document.querySelector(".slide_nav__overlay").classList.add("active"),
            document.querySelector(".slide-nav__overflow").classList.remove("js-menu--is-close"),
            document.querySelector(".slide-nav__overflow").classList.remove("is-transitioning"),
            document.querySelector(".slide-nav__overflow").classList.add("js-menu--is-open"),
            document.querySelector(".slide_nav__overlay").classList.remove("js-menu--is-close");
    }),
    document.querySelector(".slide_nav__overlay").addEventListener("click", function () {
        removeClassFromBody("overflow-hidden"),
            this.classList.remove("active"),
            document.querySelector(".slide-nav__overflow").classList.add("js-menu--is-close"),
            document.querySelector(".js-toggle-slide-nav").classList.remove("is-active");
    }),
    document.querySelector(".menu-close-btn svg").addEventListener("click", function () {
        removeClassFromBody("overflow-hidden"),
            document.querySelector(".slide_nav__overlay").classList.remove("active"),
            document.querySelector(".slide-nav__overflow").classList.remove("js-menu--is-open"),
            document.querySelector(".slide-nav__overflow").classList.remove("is-transitioning"),
            document.querySelector(".slide-nav__overflow").classList.add("js-menu--is-close"),
            document.querySelector(".js-toggle-slide-nav").classList.remove("is-active");
    });
var slideNavItems = document.querySelectorAll(".slide-nav__item");
slideNavItems.forEach(function (e) {
    e.addEventListener("click", toggleSlideNavItemClasses);
}),
    $(document).ready(function () {
        $(".menu-close-btn").click(function () {
            $(".site-nav__thumb-button.desktop").trigger("click");
        }),
            $(".cart_add-to_variant").each(function () {
                $(this).on("click", function () {
                    var e = $(this).data("variantid");
                    $(this).parents(".variants-swatch").find(".swatch-label").removeClass("active"),
                        $(this).parents(".color_swatch").find(".swatch-label").addClass("active"),
                        $(this).parents(".reference__item").find(".refrence_cart_btn").attr("data-variantid", e);
                });
            }),
            $(document).on("click", ".refrence_cart_btn", function () {
                var e,
                    t,
                    i,
                    s,
                    n = 1;
                (e = $(this).attr("data-variantid")),
                    (t = $(this)),
                    (i = new XMLHttpRequest()),
                    i.open("POST", "/cart/add.js", !0),
                    i.setRequestHeader("Content-Type", "application/json"),
                    (i.onreadystatechange = function () {
                        if (4 === i.readyState && 200 === i.status) {
                            JSON.parse(i.responseText);
                            var e = new CustomEvent("cart:build", { detail: "Example of an event" });
                            document.dispatchEvent(e);
                        }
                    }),
                    (s = JSON.stringify({ quantity: 1, id: e })),
                    i.send(s);
            }),
            $(document).on("click", ".add-to_variant", function () {
                var e,
                    t,
                    i,
                    s = $(this).data("id");
                $(this).addClass("active"),
                    (e = s),
                    (t = new XMLHttpRequest()).open("POST", "/cart/add.js", !0),
                    t.setRequestHeader("Content-Type", "application/json"),
                    (t.onreadystatechange = function () {
                        if (4 === t.readyState && 200 === t.status) {
                            JSON.parse(t.responseText);
                            var e = new CustomEvent("cart:build", { detail: "Example of an event" });
                            document.dispatchEvent(e), document.querySelector(".js-drawer-open-cart").click();
                        }
                    }),
                    (i = JSON.stringify({ quantity: 1, id: e })),
                    t.send(i);
            });
        var e = window.innerWidth;
        function t() {
            var t = [];
            $("[data-pair]").each(function () {
                var e = $(this).data("pair");
                -1 === t.indexOf(e) && t.push(e);
            }),
                t.forEach(function (t) {
                    var i, s, n;
                    (s = $('.variant_display_desk.desktop[data-pair="' + (i = t) + '"]')),
                        (n = $('.variant_display_mobile.mobile[data-pair="' + i + '"]')),
                        e < 769 ? s.remove() : n.remove();
                });
        }
        t(),
            $(window).on("resize", function () {
                t();
            });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        $(document).on("click", ".filter-label__option", function () {
            $(".filter-form").animate({ transform: "toggle" }),
                $(".filter-form").show(),
                $(".filter-form").addClass("open"),
                $(".filter-menu_overlay").addClass("active"),
                $("body").addClass("overflow-hidden");
        }),
            $(document).on("click", ".filter-menu_overlay", function () {
                $(".filter-form").animate({ transform: "toggle" }),
                    $(".filter-form").hide(),
                    $(".filter-form").removeClass("open"),
                    $(this).removeClass("active"),
                    $("body").removeClass("overflow-hidden");
            }),
            $(document).on("click", ".filter-close-btn svg", function () {
                $(".filter-form").animate({ transform: "toggle" }),
                    $(".filter-form").hide(),
                    $(".filter-form").removeClass("open"),
                    $(".filter-menu_overlay").removeClass("active"),
                    $("body").removeClass("overflow-hidden");
            }),
            $(document).on("click", ".collection-filter__inner .tag-list", function () {
                $("body").removeClass("overflow-hidden");
            });
    });
